import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import VisitorHeader from "../../../common_components/visitor_module_header";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action'
import { attendeeTypeActionId, cityActionId, countryActionId, countryIWithCodeActionId, exhibitorBadgeDaysActionId, pincodeActionId, visitorTypeListActionId, stateActionId, toastError, exhibitionStatusActionId, educationRoleTypeActionId, toastSuccess, industryChaptersActionId, seminarInterestActionId, visitorInterestActionId, primaryChapterListActionId, visitDaysPricingActionId, GSTvalidationActionId, DOC_BASE_URL } from "../../../utils/constants";
import { data } from "jquery";
import { getVistiorRegistarionDetails_action, visitorRegistrationNext_action, getIncompleteVisitorDetail_action, verifyVisitorEmail_action, deleteVisitor_action, visitorRegistrationGroupNext_action, delVisaDoc_action, verifyVisitorPromoCode_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import Resizer from "react-image-file-resizer";
import Modal from 'react-bootstrap/Modal';
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../../utils/Validator";
import DatePicker from "react-datepicker";
import { Tab, Nav, ToggleButton, ButtonGroup, ListGroup, Container, Row, Stack, Dropdown, Form } from "react-bootstrap";
import moment from "moment";
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import { insertUpdateExhSeminar_action, getSeminarGST_action, getExhSeminarDetails_action, deleteExhSeminar_action } from '../../../actions/admin_module_action/master_action/exhibition_master_action/exh_seminar_action';


class VisitorRegistration extends Component {

    // Initialized Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isOpen2: false,
            isOpen3: false,
            isOpen4: false,
            isOpen5: false,
            deleteID: '',
            isModalEdit: false,
            isOtherPreName: false,
            isDisplayPincodeList: false,
            isDisplayCityList: false,
            isDisplayStateList: false,
            isDisplayPersonalCountryList: false,
            isDisplayGroupPincodeList: false,
            isDisplayGroupCityList: false,
            isDisplayGroupStateList: false,
            isDisplayGroupPersonalCountryList: false,
            isSameAsMobNo: false,
            isDataLoad: false,
            VisitorTypeID: '',
            // Input Fields
            countryId: "",
            country: "",
            attendeeTypeId: "",
            otherName: "",
            preName: "Mr",
            firstName: "",
            middleName: "",
            lastName: "",
            designation: "",
            institute: "",
            preMobNo: "",
            mobNo: "",
            preWhatsAppMobNo: "",
            whatsAppMobNo: "",
            personalCountryId: "",
            personalCountry: "",
            pincode: "",
            city: "",
            regState: "",
            website: "",
            gstNo: "",
            panNo: "",
            email: "",
            preTelNo: "",
            telNo: "",
            preTel1No: "",
            tel1No: "",
            vaccineCertificateFile: "",
            vaccineCertificateFileType: "",
            photoIdFile: "",
            photoIdFileType: "",
            photoFile: "",
            photoFileType: "",
            preffDateModal: '',
            preffDateErrModal: '',
            prefTimeModal: '',
            preffTimeErrModal: '',
            b2bRemarkModal: "",
            b2bRemarkErrModal: '',

            isOtherPreNameModal: false,
            countryIdModal: "",
            countryIdErrModal: "",
            otherNameModal: '',
            firstNameModal: '',
            firstNameErrModal: '',
            prenameModal: 'Mr',
            middleNameModal: '',
            lastNameModal: '',
            lastNameErrModal: '',
            designationModal: '',
            designationErrModal: '',
            instituteModal: '',
            instituteErrModal: '',
            mobNoModal: '',
            mobNoErrModal: '',
            preMobNoModal: '',
            whatsAppMobNoModal: '',
            whatsAppMobNoErrModal: '',
            preWhatsAppMobNoModal: '',
            isSameAsMobNoModal: false,
            pincodeModal: '',
            pincodeErrModal: '',
            regStateModal: '',
            regStateErrModal: '',
            cityModal: '',
            cityErrModal: '',
            websiteModal: '',
            emailModal: '',
            telNoModal: '',
            preTelNoModal: '',
            tel1NoModal: '',
            preTel1NoModal: '',
            emailErrModal: '',
            modalID: '',
            //ERROR
            countryIdErr: '',
            attendeeTypeErr: '',
            daysErr: "",
            daysModalErr: "",
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            cityErr: '',
            mobNoErr: '',
            regStateErr: '',
            pincodeErr: "",
            designationErr: '',
            photoFileErr: '',
            lastNameErr: '',
            personalCountryErr: "",
            photoIdFileErr: '',
            instituteErr: '',
            firstNameErr: '',
            whatsAppMobNoErr: '',
            visitorTypeErr: '',
            emailErr: "",
            isExhbitionClosed: false,
            modalStep2: false,
            activeModalStep: 1,
            // lists
            daysList: [],
            daysModalList: [],
            countryList: [],
            visitorTypeList: [],
            personalCountryList: [],
            tempPersonalCountryList: [],
            stateList: [],
            tempStateList: [],
            tempGroupStateList: [],
            cityList: [],
            tempCityList: [],
            tempGroupCityList: [],
            pincodeList: [],
            tempPincodeList: [],
            tempGroupPincodeList: [],
            attendeeList: [],
            educationRoleTypeList: [],
            educationRoleTypeId: '',
            educationRoleTypeIdErr: '',
            educationRoleTypeIdModal: '',
            educationRoleTypeIdErrModal: '',
            eduRoleName: '',
            eduRoleNameModal: '',
            identityCardFile: '',
            identityCardFileType: '',
            identityCardFileErr: '',
            identityCardFileName: '',
            identityCardFilePath: '',
            identityCardFileModal: '',
            identityCardFileTypeModal: '',
            identityCardFileErrModal: '',
            identityCardFileNameModal: '',
            identityCardFilePathModal: '',

            identityCardFileCoordinator: '',
            identityCardFileTypeCoordinator: '',
            identityCardFileNameCoordinator: '',
            identityCardFilePathCoordinator: '',

            GroupDetailsList: [],
            AccountID: '',
            ExhVisitorID: '',
            AccountIDModal: '',
            ExhVisitorIDModal: '',
            isCoordinatorVisit: false,
            isFirst: true,

            chapterErr: '',
            chapterList: [],
            ChapterHallErr: '',
            level2: [],
            // filerArray: [],
            isOtherOpen: false,
            interestListModal: [],
            seminarInterestListModal: [],
            isInterstOne: false,
            isInterestTwo: false,
            isInterstOneCoordinator: false,
            isInterestTwoCoordinator: false,

            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterListLevel3: [],
            primaryChapterListLevel4: [],
            tempDelegationCountryList: [],
            isGrpDelegation: false,

            leader: '',
            leaderErr: '',
            delegationCountry: '',
            // onDelegationCountrySearch
            isDisplayDelegationCountryList: false,
            // renderDelegationCountryList: false,
            delegationCountryErr: '',
            arrivalDate: '',
            arrivalDateErr: '',
            departureDate: '',
            departureDateErr: '',
            delegationRemark: '',
            delegationRemarkErr: '',
            delgationCountryList: [],
            tempDelegationCountryList: [],
            delegationCountryId: '',
            needVisaAssistance: false,
            passName: '',
            passNameErr: '',
            applicantMobNo: '',
            applicantMobNoErr: '',
            preApplicantMobNo: '',
            applicantEmail: '',
            applicantEmailErr: '',
            passNo: '',
            passNoErr: '',
            passDate: '',
            passDateErr: '',
            passExipryDate: '',
            passExipryDateErr: '',
            passCountry: '',
            passCountryErr: '',

            isVisaApplied: false,
            passPortFileName: '',
            passportFile: '',
            passportFilePath: '',
            passportFileType: '',
            passportFileErr: '',
            isDisplayPassCountryList: false,
            isPassportFilePresent: false,
            passCountryList: [],
            tempPassCountryList: [],
            other: '',
            tempObj: {},
            DateArrCoordinator: [],
            ApplicantEmailIDCoordinator: '',
            ApplicantMobileNoCoordinator: '',
            B2BDepartureDateCoordinator: '',
            B2BPreferredTimeCoordinator: '',
            B2BRemarkCoordinator: '',
            CarparkingCoordinator: '',
            DelegationArrivalDateCoordinator: '',
            DelegationCountryIDCoordinator: '',
            DelegationDepartureDateCoordinator: '',
            DelegationNameCoordinator: '',
            DelegationRemarkCoordinator: '',
            IsGroupDelegationullCoordinator: '',
            NameOnPassportCoordinator: '',
            ParkingChargesCoordinator: '',
            PassportExpiryDateCoordinator: '',
            PassportFileCoordinator: '',
            PassportFilePathCoordinator: '',
            PassportFileTypeCoordinator: '',
            PassportIssueDateCoordinator: '',
            PassportIssuingCountryIDCoordinator: '',
            PassportNoCoordinator: '',
            UserIDCoordinator: '',
            areaOfInterestListCoordinator: [],
            hallChapterListCoordinator: [],
            interestSeminarListCoordinator: [],
            isVisaAssistanceCoordinator: false,
            purposeOfVisitListCoordinator: [],
            visitorChapterListCoordinator: [],
            visitorRegNoCoordinator: '',
            PassportFileNameCoordinator: '',
            isPassportFilePresentCoordinator: false,
            IsGroupDelegationCoordinator: false,
            isExhibitionFree: false,
            isShowIntrestList: [],

            onJustSubmit: false,

            isOpenDropDownState: false,
            focusedIndexState: -1,
            isOpenDropDownStateModal: false,
            focusedIndexStateModal: -1,

            isOpenDropDownCity: false,
            focusedIndexCity: -1,
            isOpenDropDownCityModal: false,
            focusedIndexCityModal: -1,

            isOpenDropDownPin: false,
            focusedIndexPin: -1,
            isOpenDropDownPinModal: false,
            focusedIndexPinModal: -1,
            scripts: [],
            isregistrationLinkClosed: false,

            isInvoice: false,
            INVPersonName: '',
            INVCompanyName: '',
            INVAddress: '',
            INVTanNo: '',
            GSTNo: '',
            PANNo: '',

            INVPersonNameErr: '',
            INVCompanyNameErr: '',
            INVAddressErr: '',
            INVTanNoErr: '',
            GSTNoErr: '',
            PANNoErr: '',
            pricingList: [],
            gstValidtionList: [],
            stateid: '',
            exhCode: '',
            DATALOADEDIncomp: false,

            countryIdINV: '',
            pincodeINV: '',
            regStateINV: '',
            cityINV: '',
            countryIdINVErr: '',
            pincodeINVErr: '',
            isDisplayPincodeListINV: false,
            isDisplayStateListINV: false,
            regStateINVErr: '',
            isDisplayCityListINV: false,
            cityINVErr: '',
            tempINVPincodeList: [],
            stateIdINV: '',
            tempINVStateList: [],
            tempINVCityList: [],
            requestPop: false,

            ChargesPop: false,
            seminarCharges: '',
            seminarCGST: '',
            seminarSGST: '',
            seminarIGST: '',
            TotalPayable: '',
            HTMLEDITOR: false,
            HtmlContent: '',
            toShowExtraDaysinPop: false,
            isSaving: false,
            isSameAsAbove: false
        }
        this.getFillList = this.getFillList.bind(this)
        this.onSelectDates = this.onSelectDates.bind(this)
        this.onVisitorRegistrationNext = this.onVisitorRegistrationNext.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.onPincodeSearch = this.onPincodeSearch.bind(this)
        this.onCountrySelect = this.onCountrySelect.bind(this)
        this.renderPincodeList = this.renderPincodeList.bind(this)
        this.onCitySearch = this.onCitySearch.bind(this)
        this.renderCityList = this.renderCityList.bind(this)
        this.onStateSearch = this.onStateSearch.bind(this)
        this.renderStateList = this.renderStateList.bind(this)
        this.onSameAsMobNoClick = this.onSameAsMobNoClick.bind(this)
        // this.onSameAsMobNoClick = this.onSameAsMobNoClick.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.getRegistrationDetails = this.getRegistrationDetails.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.onPersonalCountrySearch = this.onPersonalCountrySearch.bind(this)
        this.renderPersonalCountryList = this.renderPersonalCountryList.bind(this)
        this.onAttendeeSelect = this.onAttendeeSelect.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.verifyEmail = this.verifyEmail.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.handleAddGroupDetail = this.handleAddGroupDetail.bind(this)
        this.renderGroupList = this.renderGroupList.bind(this)
        this.handleDeleteAddedVisitor = this.handleDeleteAddedVisitor.bind(this)
        this.toggleModel = this.toggleModel.bind(this)
        this.renderGroupCityList = this.renderGroupCityList.bind(this)
        this.renderGroupPincodeList = this.renderGroupPincodeList.bind(this)
        this.renderGroupStateList = this.renderGroupStateList.bind(this)
        this.handleEditGroup = this.handleEditGroup.bind(this)
        this.onModalSelectDates = this.onModalSelectDates.bind(this)
        this.renderDelegationCountryList = this.renderDelegationCountryList.bind(this)
        this.onDelegationCountrySearch = this.onDelegationCountrySearch.bind(this)
        this.onPassportCountrySearch = this.onPassportCountrySearch.bind(this)
        this.renderPassCountryList = this.renderPassCountryList.bind(this)
        // this.onFilePick = this.onFilePick.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.inputValidateIndustrySegment = this.inputValidateIndustrySegment.bind(this)
        this.cancelModal = this.cancelModal.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.onFileClick = this.onFileClick.bind(this)
        this.onSelectInterest = this.onSelectInterest.bind(this)
        this.handlePrefTime = this.handlePrefTime.bind(this)
        this.onCheckedSeminar = this.onCheckedSeminar.bind(this)
        this.handleDeleteVisitor = this.handleDeleteVisitor.bind(this)
        this.onStep2Click = this.onStep2Click.bind(this)
        // this.addTestElement = this.addTestElement.bind(this)
        this.onEduRoleSelect = this.onEduRoleSelect.bind(this)
        this.onGSTchange = this.onGSTchange.bind(this)
        this.checknoOfVisitDays = this.checknoOfVisitDays.bind(this)

        this.getpendingDetails = this.getpendingDetails.bind(this)
        this.onCountrySelectINV = this.onCountrySelectINV.bind(this)
        this.onPincodeSearchINV = this.onPincodeSearchINV.bind(this)
        this.renderPincodeListINV = this.renderPincodeListINV.bind(this)
        this.onStateSearchINV = this.onStateSearchINV.bind(this)
        this.renderStateListINV = this.renderStateListINV.bind(this)
        this.onCitySearchINV = this.onCitySearchINV.bind(this)
        this.renderCityListINV = this.renderCityListINV.bind(this)



        this.handleConfirmation = this.handleConfirmation.bind(this)
    }

    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onVisitorRegistrationGroupNext(popArg[0], popArg[1])
            }
            if (confirmationObj.action == 1) {
                this.onVisitorRegistrationNext(popArg[0], popArg[1])
            }
            if (confirmationObj.action == 2) {
                this.onVisitorRegistrationGroupNext(popArg[0])
            }
            if (confirmationObj.action == 3) {
                this.onVisitorRegistrationNext(popArg[0])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }



    // On Component Load
    componentDidMount() {
        this.callGAScripts()
        // getting Exhibition Code from Url
        var exhCode = ""
        var code = ""
        if (this.props.location != null && this.props.location.state == null) {
            var url = this.props.location.pathname != null && this.props.location.pathname.split("/")
            code = url[url.length - 1]
            if (code.includes('-')) {
                this.getpendingDetails(code).then(excode => {
                    this.getFillList(countryIWithCodeActionId, '', '', '', excode, '').then(res => {
                        //exhibition status..................
                        this.getFillList(exhibitionStatusActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                            this.getFillList(visitorInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                    this.getFillList(attendeeTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                        this.getFillList(educationRoleTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                            this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                this.getFillList(visitorTypeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                    this.getFillList(seminarInterestActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                        this.getFillList(industryChaptersActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                            this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                this.getFillList(GSTvalidationActionId, sessionStorage.getItem('sessionExhibitionID'), "", this.state.countryId, "", "").then(() => {
                                                                    this.getFillList(visitDaysPricingActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                        this.getRegistrationDetails()
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                        // Country List 
                        // Attendee List
                        // Days List Action
                        // Get Registration Details When Previous Click
                    })
                })
            } else {
                this.getFillList(countryIWithCodeActionId, '', '', '', code, '').then(res => {
                    //exhibition status..................
                    this.getFillList(exhibitionStatusActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                        this.getFillList(visitorInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                            this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                this.getFillList(attendeeTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                    this.getFillList(educationRoleTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                        this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                            this.getFillList(visitorTypeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                this.getFillList(seminarInterestActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                    this.getFillList(industryChaptersActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                        this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                            this.getFillList(GSTvalidationActionId, sessionStorage.getItem('sessionExhibitionID'), "", this.state.countryId, "", "").then(() => {
                                                                this.getFillList(visitDaysPricingActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                    this.setState({ isLoading: false })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                    // Country List 
                    // Attendee List
                    // Days List Action
                    // Get Registration Details When Previous Click
                })
            }
            // sessionStorage.setItem("sessionExhibitionID", exhCode)
            // console.log("h7hyhyhh", this.props.location.state, 'this.props.location.state', exhCode)

        }
        else if (this.props.location.state != null && this.props.location.state.is_previous) {
            //exhibition status..................
            this.getFillList(exhibitionStatusActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                this.getFillList(visitorInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

                    // Country List 
                    this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                        this.getFillList(attendeeTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                            this.getFillList(seminarInterestActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                this.getFillList(educationRoleTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                    this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                        this.getFillList(visitorTypeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                            this.getFillList(GSTvalidationActionId, sessionStorage.getItem('sessionExhibitionID'), "", this.state.countryId, "", "").then(() => {
                                                this.getFillList(industryChaptersActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                    this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                        this.getFillList(visitDaysPricingActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                            this.getRegistrationDetails()
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
            // Attendee List
            // Days List Action

        }

        // //exhibition status..................
        // this.getFillList(exhibitionStatusActionId, '', '', '', '', '')
        // // Country List 
        // this.getFillList(countryActionId, '', '', '', '', '')
        // // Attendee List
        // this.getFillList(attendeeTypeActionId, '', '', '', '', '')
        // // Days List Action
        // this.getFillList(exhibitorBadgeDaysActionId, "", "", "", "", "")

    }

    getpendingDetails(UUID) {
        const { attendeeList, daysList, educationRoleTypeId, primaryChapterListData, level0, level2, level3, level4 } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props.getIncompleteVisitorDetail_action(UUID)
                .then((data) => {
                    if (data.error != 1) {
                        if (data.data.length > 0) {
                            this.setState({ exhCode: data.data[0][0].Code })
                            var obj
                            if (`${data.data[0][0].AccountID}`.split(',').length > 1) {
                                sessionStorage.setItem('VisitorTypeID', 2)
                                obj = {
                                    'AccountIDs': data.data[0][0].AccountID,
                                    'ExhVisitorIDs': data.data[0][0].ExhVisitorID,
                                    'ExhibitionID': data.data[0][0].ExhibitionID
                                }
                            } else {
                                sessionStorage.setItem('VisitorTypeID', 1)
                                obj = {
                                    'AccountID': data.data[0][0].AccountID,
                                    'ExhVisitorID': data.data[0][0].ExhVisitorID,
                                    'ExhibitionID': data.data[0][0].ExhibitionID
                                }
                            }
                            console.log(obj, '////////////////////////////////////////////////')
                            sessionStorage.setItem('VisitorDataSS', JSON.stringify(obj))
                            setTimeout(() => {
                                this.setState({ isLoading: false },
                                    //  () => 
                                    // this.getRegistrationDetails()
                                    resolve(data.data[0][0].Code)
                                )
                            }, 200);
                        }
                        else {
                            toastError("something went wrong")
                        }
                    }
                })
        })

    }
    componentWillUnmount() {
        // Cleanup: Remove scripts when component unmounts
        const { scripts } = this.state
        if (scripts) {
            scripts.forEach((script) => {
                if (script.parentNode) {
                    script.parentNode.removeChild(script);
                }
            });
        }
    }

    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    onSelectPrimaryChapter(e) {
        const { chapterList } = this.state
        var id = e.target.value
        var checked = e.target.checked

        chapterList.length > 0 && chapterList.map((data) => {
            if (checked) {
                if (id == data.IndustrySegmentID) {
                    data.IsSelect = true
                    if (id == 16) {
                        this.setState({ isOtherOpen: true })
                    }
                }
            }
            else {
                if (id == data.IndustrySegmentID) {
                    data.IsSelect = false
                    if (id == 16) {
                        this.setState({ isOtherOpen: false })
                    }
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", chapterList)
        this.setState({ chapterList: chapterList, chapterErr: "" })
    }

    onCheckLevel2(e, id, tempLevel1) {
        const { level2, primaryChapterListLevel3, level3, primaryChapterListLevel4, primaryChapterListData, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {
                if (event == true) {
                    level2[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.IsSelect = true
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.IsSelect = true
                                }
                            });
                        }
                    });

                } else {
                    level2[i]['IsSelect'] = false

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.IsSelect = false
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.IsSelect = false
                                }
                            });
                        }
                    });
                }

            }
        }
        console.log("tempLevel1", tempLevel1)

        for (let i = 0; i < primaryChapterListData.length; i++) {
            for (let j = 0; j < level2.length; j++) {
                if (level2[j]['ChapterID'] == id) {
                    if (primaryChapterListData[i]['ChapterID'] == level2[j]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel1.every(item => item.IsSelect == 1)
                        console.log("allSelectedChecked", allSelectedChecked)
                        if (allSelectedChecked) {
                            primaryChapterListData[i]['IsSelect'] = true
                        } else {
                            primaryChapterListData[i]['IsSelect'] = false
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);


    }

    onCheckLevel3(e, id, tempLevel3) {
        const { level3, primaryChapterListLevel4, level2, level4, primaryChapterListData } = this.state
        this.setState({ level4DummyId: id })
        const event = e.target.checked

        var modelevel2 = []
        var modelevel3 = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                console.log("***********", level3[i])
                level2.map((s) => {
                    if (level3[i].ParentChapterID == s.ChapterID) {
                        primaryChapterListData.map(q => {
                            if (s.ParentChapterID == q.ChapterID) {
                                modelevel3.push(q)
                            }
                        })
                    }
                })
            }
        }


        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })

        console.log("finalListlevel2", finalListlevel2)


        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                if (event == true) {
                    level3[i]['IsSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {

                            level4.IsSelect = true
                        }
                    });

                } else {
                    level3[i]['IsSelect'] = false
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {
                            level4.IsSelect = false
                        }
                    });

                }
            }
        }

        for (let i = 0; i < level3.length; i++) {
            for (let index = 0; index < level2.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    if (level3[i]['ChapterID'] == id) {
                        if (level2[index]['ChapterID'] == level3[i]['ParentChapterID']) {
                            if (primaryChapterListData[j]['ChapterID'] == level2[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel3.every(item => item.IsSelect == 1)
                                if (allSelectedChecked) {
                                    level2[index]['IsSelect'] = true
                                    const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.IsSelect == 1)
                                    console.log("allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                    if (allSelectedfinalListlevel2) {
                                        primaryChapterListData[j]['IsSelect'] = true
                                    } else {
                                        primaryChapterListData[j]['IsSelect'] = false
                                    }
                                }
                                else {
                                    level2[index]['IsSelect'] = false
                                    primaryChapterListData[j]['IsSelect'] = false
                                }
                            }
                        }
                    }
                }

            }

        }
        setTimeout(() => {
            this.setState({ level3: level3, level2: level2 })
        }, 100);

    }

    recordTwo(level2, level3, level4) {
        const { primaryChapterListLevel3 } = this.state
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterListLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} >
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed " type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                                aria-expanded="false"
                                                aria-controls={'collapse_l2_' + level3data.ChapterID}
                                            >
                                                {/* // checkbox for level3 */}
                                                {level3data.IsCheckbox &&
                                                    <input type="checkbox" className="from-left-sp"

                                                        name="" id={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID, tempLevel3)} />
                                                }
                                                <label style={{ background: 'none', cursor: 'pointer' }} className="p-0" for={level3data.ChapterID}>{level3data.ChapterName}</label>


                                            </button>
                                        </h2>
                                        {this.recordThree(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    recordThree(level3data, level4) {
        const { primaryChapterListLevel4 } = this.state
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterListLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step" style={{ display: 'flex' }}>

                                {level4data.IsCheckbox &&
                                    <input type="checkbox" name="" id={level4data.ChapterID} checked={level4data.IsSelect}
                                        onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID, tempLevel4)} />
                                }
                                <label style={{ background: 'none', cursor: 'pointer' }} className="p-0" for={level4data.ChapterID}>{level4data.ChapterName}</label>
                            </div>
                        )
                    })
                }
            </div>
        </>);
    }

    onSelectLevel4(e, id, tempLevel4) {
        const { level4, exhibitDetailsList, level3, level2, level4DummyId, primaryChapterListLevel3, primaryChapterListLevel4, primaryChapterListData } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level4[i]['IsSelect'] = !level4[i]['IsSelect']
            }
        }
        this.setState({ ChapterHallErr: "" })
        var modelevel2 = []
        var modelevel3 = []

        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level3.map((s) => {
                    if (level4[i].ParentChapterID == s.ChapterID) {
                        level2.map(p => {
                            if (s.ParentChapterID == p.ChapterID) {
                                modelevel2.push(p)
                                primaryChapterListData.map(q => {
                                    if (p.ParentChapterID == q.ChapterID) {
                                        modelevel3.push(q)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }

        const finalListlevel3 = []
        level3.map(data => {
            modelevel2.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel3.push(data)
                }

            })
        })

        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })




        console.log("************** finalListlevel2", finalListlevel2)
        // console.log("************** finalListlevel3", finalListlevel3)


        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    for (let k = 0; k < level2.length; k++) {
                        if (tempLevel4[i]['ChapterID'] == id) {
                            if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                                if (level2[k]['ChapterID'] == level3[index]['ParentChapterID']) {
                                    if (primaryChapterListData[j]['ChapterID'] == level2[k]['ParentChapterID']) {
                                        const allSelectedChecked = tempLevel4.every(item => item.IsSelect == 1)
                                        if (allSelectedChecked) {
                                            level3[index]['IsSelect'] = true

                                            const allSelectedfinalListlevel3 = finalListlevel3.every(item => item.IsSelect == 1)
                                            if (allSelectedfinalListlevel3) {
                                                level2[k]['IsSelect'] = true

                                                const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.IsSelect == 1)
                                                console.log("************** allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                                if (allSelectedfinalListlevel2) {
                                                    primaryChapterListData[j]['IsSelect'] = true

                                                } else {
                                                    primaryChapterListData[j]['IsSelect'] = false
                                                }

                                            } else {
                                                level2[k]['IsSelect'] = false
                                            }


                                        }
                                        else {
                                            level3[index]['IsSelect'] = false
                                            level2[k]['IsSelect'] = false
                                            primaryChapterListData[j]['IsSelect'] = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level4: level4, level3: level3, level2: level2 })
        }, 100);


    }

    // On Delegation Country Search
    onDelegationCountrySearch(e) {
        const { delgationCountryList, tempDelegationCountryList } = this.state
        // this.setState({ passCountry: '' })
        if (e.target.value != '') {
            console.log("tempDelegationCountryList ++++----------->", tempDelegationCountryList)

            var searchCoutryList = tempDelegationCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                delegationCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                delegationCountryErr: '',
                tempDelegationCountryList: searchCoutryList,
                isDisplayDelegationCountryList: true
            })
        }
        else {

            this.setState({
                delegationCountry: e.target.value,
                tempDelegationCountryList: delgationCountryList,
                isDisplayDelegationCountryList: false
            })
        }
    }

    // Render Country for Delegation Country
    renderDelegationCountryList() {
        const { tempDelegationCountryList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempDelegationCountryList.length > 0 && tempDelegationCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                delegationCountry: data.Description, delegationCountryId: data.Code,
                                isDisplayDelegationCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === primaryChapterListActionId) {
                            console.log("primaryChapterListActionId 121212", data.data)
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        // console.log(arr[i].ChapterName)
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    // console.log("primaryChapterListActionId 121212", i, finalName)
                                                    break
                                                }
                                            }
                                        } else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                    }
                                }
                                return
                            }

                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                if (data.data['primaryChapter'][i].ChapterID == 2046) {
                                    data.data['primaryChapter'][i].ChapterName = 'TECHNICAL TEXTILE PRODUCTS & HOME TEXTILE PRODUCT'
                                }
                                if (data.data['primaryChapter'][i].ChapterID == 2033) {
                                    data.data['primaryChapter'].splice(i, 1)
                                }
                                console.log(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                    }
                                }
                                data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                seqnoFormat(data.data['level2'])
                            }
                            console.log(data.data['primaryChapter'])
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                    console.log(data.data['primaryChapter'][i].seqno, i)
                                }
                                // seqnoFormat(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level2'].length; j++) {
                                    if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                        data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                for (var j = 0; j < data.data['level3'].length; j++) {
                                    if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                        for (var k = 0; k < data.data['level2'].length; k++) {
                                            if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                break
                                            }
                                        }
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level4'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                data.data['level2'][i].isHighlight = false;
                            }
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'] ? data.data['primaryChapter'] : [],
                                level0: data.data['level0'] ? data.data['level0'] : [],
                                level2: data.data['level2'] ? data.data['level2'] : [],
                                level3: data.data['level3'] ? data.data['level3'] : [],
                                level4: data.data['level4'] ? data.data['level4'] : [],

                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        // country list 

                        if (actionID === exhibitionStatusActionId) {
                            console.log("exhibitionStatusActionId", data.data)
                            this.setState({
                                isExhbitionClosed: data != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === visitorTypeListActionId) {
                            console.log("Attendee Type data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                visitorTypeList: data.data,
                                VisitorTypeID: 1,
                                isLoading: false,
                            })
                            // this.setState({ VisitorTypeID: data.VisitorTypeID})
                            resolve(true)
                        }
                        if (actionID === industryChaptersActionId) {
                            console.log("industryChaptersActionId 121212", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.IsSelect = false
                            })
                            this.setState({
                                chapterList: data.data,
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                countryList: data != null ? data.data : [],
                                personalCountryList: data.data,
                                tempPersonalCountryList: data.data,
                                delgationCountryList: data.data,
                                tempDelegationCountryList: data.data,
                                passCountryList: data.data,
                                tempPassCountryList: data.data,
                                isLoading: false,

                            })
                            resolve(true)
                        }
                        // ExhibitionID
                        if (actionID === countryIWithCodeActionId) {
                            console.log("country data", data.data[0]['ExhibitionID'])
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []
                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", moment(data.data[0]['ExhibitionDateFrom']).format("DD/MM/YYYY"))
                            sessionStorage.setItem("exhibitionDateTo", moment(data.data[0]['ExhibitionDateTo']).format("DD/MM/YYYY"))
                            sessionStorage.setItem("ExhibitionCountryID", data.data[0]['ExhibitionCountryID'])
                            sessionStorage.setItem("sessionLogoPath", `${DOC_BASE_URL}${data.data[0]['Logo']}`)

                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])
                            sessionStorage.setItem("isVisitorB2B", data.data[0]['isVisitorB2B'])
                            sessionStorage.setItem("isVisitorSeminar", data.data[0]['isVisitorSeminar'])
                            sessionStorage.setItem("isVisitorRegistrationOpen", data.data[0]['isVisitorRegistrationOpen'])

                            sessionStorage.setItem("ExhVisitorVisaIssueDate", data.data[0]['ExhVisitorVisaIssueDate'])
                            sessionStorage.setItem('DATALOADEDIncomp', true)
                            this.setState({
                                isDataLoad: true,
                                // DATALOADEDIncomp: true,
                                bannerPath: data.data[0]['Banner'] != null && data.data[0]['Banner'],
                                isExibitionClosed: data.data[0]['IsExhibitionClosed'] != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                isregistrationLinkClosed: data.data[0]['isregistrationLinkClosed'] != null && data.data[0]['isregistrationLinkClosed'] == 1 ? true : false,
                            })
                            setTimeout(() => {

                            }, 500);

                            // this.getFillList(countryActionId, data.data[0]['ExhibitionID'], '', '', '', '')
                            resolve(true)
                        }
                        // state list
                        if (actionID === stateActionId) {
                            console.log("stateList data", data.data)
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                tempGroupStateList: data.data,
                                tempINVStateList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === GSTvalidationActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                gstValidtionList: data.data, isLoading: false,
                            })
                            resolve(true)
                        }
                        // city list
                        if (actionID === cityActionId) {
                            console.log("city data", data.data)
                            this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                                tempGroupCityList: data.data,
                                tempINVCityList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        // pincode
                        if (actionID === pincodeActionId) {
                            console.log("pincode data", data.data)
                            this.setState({
                                pincodeList: data.data,
                                tempPincodeList: data.data,
                                tempINVPincodeList: data.data,
                                tempGroupPincodeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === educationRoleTypeActionId) {
                            console.log("educationRoleTypeActionId data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                educationRoleTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        // Days List
                        if (actionID === exhibitorBadgeDaysActionId) {
                            console.log("exhibitor data", data.data)
                            var DateList = []
                            var DateListModal = []
                            // data.data.map(item => {
                            //     DateList.push(item)
                            // })
                            // data.data.map(item => {
                            //     DateListModal.push(item)
                            // })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    // 'PriceINR': item['PriceINR'],
                                    // 'PriceUSD': item['PriceUSD'],
                                    // 'PromoCode': null,
                                    // 'PromoCodeDiscount': null
                                }
                                DateList.push(mapData)
                                // DateListModal.push(mapData)
                            })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    // 'PriceINR': item['PriceINR'],
                                    // 'PriceUSD': item['PriceUSD'],
                                    // 'PromoCode': null,
                                    // 'PromoCodeDiscount': null
                                }
                                // DateList.push(mapData)
                                DateListModal.push(mapData)
                            })
                            this.setState({
                                daysList: DateList,
                                daysModalList: DateListModal,
                                isLoading: false,
                                // isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            // sessionStorage.setItem("isExhibitionFree", JSON.stringify(data.data[0]['isExhibitionFree']))
                            resolve(true)
                        }
                        if (actionID === visitDaysPricingActionId) {
                            console.log("exhibitor data", data.data)
                            this.setState({
                                // daysList: DateList,
                                pricingList: data.data
                                // daysModalList: DateListModal,
                                // isLoading: false,
                                // isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            this.setState({
                                isExhibitionFree: data.data.length == 0,
                            })
                            sessionStorage.setItem("isExhibitionFree", data.data.length == 0)
                            resolve(true)

                        }
                        // Attendee Type List
                        if (actionID === attendeeTypeActionId) {
                            console.log("Attendee Type data", data.data)
                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                attendeeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === seminarInterestActionId) {
                            data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                            }));
                            console.log("Visitor Interest List 121212", data.data)
                            const result = this.calculateRowspan(listModal);
                            this.setState({
                                // seminarInterestList: list,
                                seminarInterestListModal: result,
                                isLoading: false
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === visitorInterestActionId) {
                            this.setState({
                                // interestList: data.data,
                                // interestListModal: data.data,
                            })

                            data.data.length > 0 && data.data.map((item) => {
                                item.isSelect = false
                                item.AreaofInterestID == 2 && (item.status = JSON.parse(sessionStorage.getItem('isVisitorB2B')))
                                item.AreaofInterestID == 1 && (item.status = JSON.parse(sessionStorage.getItem('isVisitorSeminar')))
                            })
                            const isShowIntrestList = data.data.some(item => item.status == true)
                            this.setState({ interestListModal: data.data, isShowIntrestList: isShowIntrestList })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })

    }

    // On Select Dates
    onSelectDates(e) {
        const { daysList } = this.state
        var code = e.target.value
        var checked = e.target.checked
        daysList.length > 0 && daysList.map((data) => {
            if (checked) {
                if (code == data.Code) {
                    data.isSelect = true
                }
            } else {
                if (code == data.Code) {
                    data.isSelect = false
                }

            }
        })
        var selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        console.log("hgdddhdjdjdjdkdj", daysList, this.state.daysModalList)
        this.setState({ daysList: daysList, DateArrCoordinator: list, daysErr: "" })
    }

    onModalSelectDates(e) {
        const { daysModalList } = this.state
        var code = e.target.value
        var checked = e.target.checked
        daysModalList.length > 0 && daysModalList.map((data) => {
            if (checked) {
                if (code == data.Code) {
                    data.isSelect = true
                }
            } else {
                if (code == data.Code) {
                    data.isSelect = false
                }

            }
        })
        console.log("hgdddhdjdjdjdkdj", daysModalList)
        this.setState({ daysModalList: daysModalList, daysModalErr: "" })
    }

    //input validate
    inputValidate() {
        const { city, preMobNo, mobNo, regState, designation, photoFile, lastName, photoIdFile, gender, institute, firstName,
            preWhatsAppMobNo, whatsAppMobNo, VisitorTypeID, personalCountryId, pincode, email, countryId, attendeeTypeId, daysList,
            isOtherPreNameModal, otherNameModal, emailErrModal, firstNameModal, firstNameErrModal, prenameModal, middleNameModal, lastNameModal, lastNameErrModal, designationModal, designationErrModal, instituteModal, instituteErrModal, mobNoModal, mobNoErrModal, preMobNoModal, whatsAppMobNoModal, whatsAppMobNoErrModal, preWhatsAppMobNoModal, stateIdINV, isSameAsMobNoModal, pincodeModal, pincodeErrModal, regStateModal, regStateErrModal, cityModal, cityErrModal, websiteModal, emailModal, telNoModal, preTelNoModal, tel1NoModal, educationRoleTypeId, preTel1NoModal, isInvoice,
            INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
            countryIdINVErr, countryIdINV, regStateINV, stateList, gstValidtionList, regStateINVErr, pincodeINVErr, pincodeINV, cityINV, cityINVErr,
        } = this.state
        if (countryId == "" || countryId == "Select") {
            this.setState({ countryIdErr: "Please Select Country" });
        }
        if (attendeeTypeId == "") {
            this.setState({ attendeeTypeErr: "Please Select Attendee Type" });
        } else {
            if (attendeeTypeId == 3) {
                if (educationRoleTypeId == '') {
                    this.setState({ educationRoleTypeIdErr: "Please Select Education Role Type" });
                }
            }
        }
        if (VisitorTypeID == "") {
            this.setState({ visitorTypeErr: "Please Select Visitor Type" });
        }
        if (!(daysList.some(obj => obj.isSelect == true))) {
            if (this.state.VisitorTypeID == 2) {
                this.state.isCoordinatorVisit && this.setState({ daysErr: "Please Select Days" })
            } else {
                this.setState({ daysErr: "Please Select Days" })
            }
        }
        if (firstName == "") {
            this.setState({ firstNameErr: "Please enter first name" });
        }
        if (lastName == "") {
            this.setState({ lastNameErr: "Please enter last name" });
        }
        if (designation == "") {
            this.setState({ designationErr: "Please enter designation" });
        }
        if (institute == "") {
            this.setState({ instituteErr: "Please enter institue/Organization" });
        }
        if (preMobNo == "") {
            this.setState({ mobNoErr: "Please enter pre mobile no" });
        }
        if (mobNo == "") {
            this.setState({ mobNoErr: "Please enter mobile no" });
        }
        if (preWhatsAppMobNo == "") {
            this.setState({ whatsAppMobNoErr: "Please enter pre whatsapp no" });
        }
        if (whatsAppMobNo == "") {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
        }
        if (personalCountryId == "") {
            this.setState({ personalCountryErr: "Please enter Country" });
        }
        // if (photoFile == "") {
        //     this.setState({ photoFileErr: "Please upload photo" });
        // }
        // if (photoIdFile == "") {
        //     this.setState({ photoIdFileErr: "Please upload photo ID" });
        // }
        if (regState == "" && countryId == "91") {
            this.setState({ regStateErr: "Please enter province/state" });
        }
        if (city == "") {
            this.setState({ cityErr: "Please enter city" });
        }
        if (pincode == "") {
            this.setState({ pincodeErr: "Please enter Pincode" });
        }
        if (email == "") {
            this.setState({ emailErr: "Please enter Email" });
        }
        if (email != "") {
            var emailError = emailValidator(email)
            if (emailError != '') {
                this.setState({ emailErr: emailError })
                return
            }
        }
        if (isInvoice) {
            if (INVPersonName == '' || INVPersonName == null) {
                this.setState({
                    INVPersonNameErr: 'Please enter Person Incharge Name'
                })
            }
            if (INVCompanyName == '' || INVCompanyName == null) {
                this.setState({
                    INVCompanyNameErr: 'Please enter Company'
                })
            }
            if (INVAddress == '' || INVAddress == null) {
                this.setState({
                    INVAddressErr: 'Please enter Address'
                })
            }
            // if ((INVTanNo == '' || INVTanNo == null) && this.state.countryId == 91) {
            //     this.setState({
            //         INVTanNoErr: 'Please enter TAN No'
            //     })
            // }
            if ((GSTNo == '' || GSTNo == null) && this.state.countryId == 91) {
                this.setState({
                    GSTNoErr: 'Please enter GST No'
                })
            } else {
                var code = GSTNo.slice(0, 2)
                console.log(code.length, gstValidtionList, 'rere')
                console.log('stateId', stateIdINV)
                var validState = false
                for (var i = 0; i < stateList.length; i++) {
                    if (regStateINV.trim().toLowerCase() == stateList[i].Description.trim().toLowerCase()) {
                        validState = true
                        break
                    }
                }
                if (validState) {
                    if (stateIdINV != '' && stateIdINV != null) {
                        for (var i = 0; i < gstValidtionList.length; i++) {
                            if (gstValidtionList[i].StateID == stateIdINV) {
                                if (parseInt(gstValidtionList[i].GSTCode) != code) {
                                    console.log("2--->",)
                                    this.setState({
                                        GSTNoErr: "Please enter proper gst no",
                                        // GSTNo: value,
                                        // GSTNo: ''
                                    });
                                }
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < gstValidtionList.length; i++) {
                            if (gstValidtionList[i].StateName.trim().toLowerCase() == regStateINV.trim().toLowerCase()) {
                                if (parseInt(gstValidtionList[i].GSTCode) != code) {
                                    console.log("2--->",)
                                    this.setState({
                                        GSTNoErr: "Please enter proper gst no",
                                        // GSTNo: value,
                                        // GSTNo: ''
                                    });
                                }
                            }
                        }
                    }
                } else {
                    if (this.state.countryId == 91) {
                        this.setState({
                            regStateINVErr: 'Please Enter proper State'
                        })
                    }
                }
            }
            if ((PANNo == '' || PANNo == null) && this.state.countryId == 91) {
                this.setState({
                    PANNoErr: 'Please enter PAN No'
                })
            }
            if (countryIdINV == '' || countryIdINV == null) {
                this.setState({
                    countryIdINVErr: 'Please Select Country'
                })
            }
            if ((regStateINV == '' || regStateINV == null) && this.state.countryId == 91) {
                this.setState({
                    regStateINVErr: 'Please Enter State'
                })
            }
            if (pincodeINV == '' || pincodeINV == null) {
                this.setState({
                    pincodeINVErr: 'Please Enter Pin'
                })
            }
            if (cityINV == '' || cityINV == null) {
                this.setState({
                    cityINVErr: 'Please Enter City'
                })
            }
        }
    }

    //input validate
    inputValidateGroup() {
        const { city, preMobNo, mobNo, regState, designation, educationRoleTypeId, photoFile, lastName, photoIdFile, gender, institute, firstName,
            preWhatsAppMobNo, whatsAppMobNo, VisitorTypeID, personalCountryId, pincode, email, countryId, attendeeTypeId, daysList, isInvoice,
            isOtherPreNameModal, otherNameModal, emailErrModal, firstNameModal, firstNameErrModal, prenameModal, middleNameModal, lastNameModal, lastNameErrModal, designationModal, designationErrModal, instituteModal, instituteErrModal, mobNoModal, mobNoErrModal, preMobNoModal, whatsAppMobNoModal, whatsAppMobNoErrModal, preWhatsAppMobNoModal, isSameAsMobNoModal, pincodeModal, pincodeErrModal, regStateModal, regStateErrModal, cityModal, cityErrModal, websiteModal, emailModal, telNoModal, educationRoleTypeIdModal, educationRoleTypeIdErrModal, preTelNoModal, tel1NoModal, preTel1NoModal,
            INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
            ountryIdINVErr, countryIdINV, gstValidtionList, stateIdINV, stateList, regStateINV, regStateINVErr, pincodeINVErr, pincodeINV, cityINV, cityINVErr
        } = this.state
        if (firstNameModal == "") {
            this.setState({ firstNameErrModal: "Please enter first name" });
        }
        if (attendeeTypeId == 3) {
            if (educationRoleTypeIdModal == '') {
                this.setState({ educationRoleTypeIdErrModal: "Please Select Education Role Type" });
            }
        }
        if (lastNameModal == "") {
            this.setState({ lastNameErrModal: "Please enter last name" });
        }
        if (designationModal == "") {
            this.setState({ designationErrModal: "Please enter designation" });
        }
        if (instituteModal == "") {
            this.setState({ instituteErrModal: "Please enter institue/Organization" });
        }
        if (preMobNoModal == "") {
            this.setState({ mobNoErrModal: "Please enter pre mobile no" });
        }
        if (mobNoModal == "") {
            this.setState({ mobNoErrModal: "Please enter mobile no" });
        }
        if (preWhatsAppMobNoModal == "") {
            this.setState({ whatsAppMobNoErrModal: "Please enter pre whatsapp no" });
        }
        if (whatsAppMobNoModal == "") {
            this.setState({ whatsAppMobNoErrModal: "Please enter whatsapp no" });
        }
        // if (photoFile == "") {
        //     this.setState({ photoFileErr: "Please upload photo" });
        // }
        // if (photoIdFile == "") {
        //     this.setState({ photoIdFileErr: "Please upload photo ID" });
        // }
        if (regStateModal == "" && countryId == "91") {
            this.setState({ regStateErrModal: "Please enter province/state" });
        }
        if (cityModal == "") {
            this.setState({ cityErrModal: "Please enter city" });
        }
        if (pincodeModal == "") {
            this.setState({ pincodeErrModal: "Please enter Pincode" });
        }
        if (emailModal == "") {
            this.setState({ emailErrModal: "Please enter Email" });
        }
        if (emailModal != "") {
            var emailError = emailValidator(emailModal)
            if (emailError != '') {
                this.setState({ emailErrModal: emailError })
                return
            }
        }
        if (isInvoice) {
            if (INVPersonName == '' || INVPersonName == null) {
                this.setState({
                    INVPersonNameErr: 'Please enter Person Incharge Name'
                })
            }
            if (INVCompanyName == '' || INVCompanyName == null) {
                this.setState({
                    INVCompanyNameErr: 'Please enter Company'
                })
            }
            if (INVAddress == '' || INVAddress == null) {
                this.setState({
                    INVAddressErr: 'Please enter Address'
                })
            }
            // if ((INVTanNo == '' || INVTanNo == null) && this.state.countryId == 91) {
            //     this.setState({
            //         INVTanNoErr: 'Please enter TAN No'
            //     })
            // }
            if ((GSTNo == '' || GSTNo == null) && this.state.countryId == 91) {
                this.setState({
                    GSTNoErr: 'Please enter GST No'
                })
            }
            else {
                var code = GSTNo.slice(0, 2)
                console.log(code.length, gstValidtionList, 'rere')
                console.log('stateId', stateIdINV)
                var validState = false
                for (var i = 0; i < stateList.length; i++) {
                    if (regStateINV.trim().toLowerCase() == stateList[i].Description.trim().toLowerCase()) {
                        validState = true
                        break
                    }
                }
                if (validState) {
                    if (stateIdINV != '' && stateIdINV != null) {
                        for (var i = 0; i < gstValidtionList.length; i++) {
                            if (gstValidtionList[i].StateID == stateIdINV) {
                                if (parseInt(gstValidtionList[i].GSTCode) != code) {
                                    console.log("2--->",)
                                    this.setState({
                                        GSTNoErr: "Please enter proper gst no",
                                        // GSTNo: value,
                                        // GSTNo: ''
                                    });
                                }
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < gstValidtionList.length; i++) {
                            if (gstValidtionList[i].StateName.trim().toLowerCase() == regStateINV.trim().toLowerCase()) {
                                if (parseInt(gstValidtionList[i].GSTCode) != code) {
                                    console.log("2--->",)
                                    this.setState({
                                        GSTNoErr: "Please enter proper gst no",
                                        // GSTNo: value,
                                        // GSTNo: ''
                                    });
                                }
                            }
                        }
                    }
                } else {
                    if (this.state.countryId == 91) {
                        this.setState({
                            regStateINVErr: 'Please Enter proper State'
                        })
                    }
                }
            }
            if ((PANNo == '' || PANNo == null) && this.state.countryId == 91) {
                this.setState({
                    PANNoErr: 'Please enter PAN No'
                })
            }
            if (countryIdINV == '' || countryIdINV == null) {
                this.setState({
                    countryIdINVErr: 'Please Select Country'
                })
            }
            if ((regStateINV == '' || regStateINV == null) && this.state.countryId == 91) {
                this.setState({
                    regStateINVErr: 'Please Enter State'
                })
            }
            if (pincodeINV == '' || pincodeINV == null) {
                this.setState({
                    pincodeINVErr: 'Please Enter Pin'
                })
            }
            if (cityINV == '' || cityINV == null) {
                this.setState({
                    cityINVErr: 'Please Enter City'
                })
            }
        }
    }

    // On Visitor Registration Next
    onVisitorRegistrationNext(e, mode) {
        const { daysList, daysModalList, stateList, pricingList } = this.state
        e.preventDefault()
        // Is Days Selcted Check
        var daysListValidation = false
        for (var i = 0; i < this.state.daysList.length; i++) {
            if (this.state.daysList[i].isSelect == true) {
                daysListValidation = true
            }
        }
        // preparing Selected Days for udt
        const selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        var toreturn = true
        var visitDaysNoArr = []

        if (pricingList.length != 0) {
            for (var i = 0; i < pricingList.length; i++) {
                visitDaysNoArr.push(pricingList[i].VisitDays)
                if (pricingList[i].VisitDays == list.length) {
                    toreturn = false
                    break
                }
            }
            if (toreturn) {
                toastError(`Visit pass only allowed for ${visitDaysNoArr.toString()} days`)
                // modalErr = false
                return
            }
        }
        this.inputValidate(1)
        // else {
        var isMatched1 = false
        var isMatched2 = false
        if (this.state.countryId == 91) {
            for (var i = 0; i < stateList.length; i++) {
                if (stateList[i].Description.trim().toLowerCase() == this.state.regState.trim().toLowerCase()) {
                    isMatched1 = true
                }
            }
        } else {
            isMatched1 = true
        }
        if (this.state.countryIdINV == 91 && this.state.isInvoice) {
            for (var i = 0; i < stateList.length; i++) {
                if (stateList[i].Description.trim().toLowerCase() == this.state.regStateINV.trim().toLowerCase()) {
                    isMatched2 = true
                }
            }
        } else {
            isMatched2 = true
        }
        if (!isMatched1 || !isMatched2) {
            if (!isMatched1) {
                this.setState({ regStateErr: "Please enter proper State" })
            }
            if (!isMatched2) {
                this.setState({ regStateINVErr: "Please enter proper State" })
            }
            toastError("Please enter proper State")
            return
        }
        // }
        setTimeout(() => {
            const { countryId, attendeeTypeId, city, preMobNo, mobNo, regState, designation, photoFile, lastName, photoIdFile, gender,
                institute, firstName, preWhatsAppMobNo, whatsAppMobNo, pincode, email, firstNameErr, lastNameErr, designationErr,
                instituteErr, mobNoErr, whatsAppMobNoErr, regStateErr, cityErr, pincodeErr, emailErr, preName, middleName, isInvoice,
                isSameAsMobNo, website, preTelNo, preTel1No, telNo, tel1No, countryIdErr, educationRoleTypeId, educationRoleTypeIdErr, attendeeTypeErr, daysErr,
                INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
                countryIdINVErr, countryIdINV, regStateINV, regStateINVErr, pincodeINVErr, pincodeINV, cityINV, cityINVErr,
                identityCardFile, identityCardFileType, identityCardFilePath

            } = this.state

            if (firstName != "" && lastName != "" && designation != "" && institute != "" && mobNo != "" && whatsAppMobNo != "" && preMobNo != "" && preWhatsAppMobNo != '' && city != "" && pincode != "" && email != "" && countryId != "" && attendeeTypeId != "") {
                if (firstNameErr == "" && lastNameErr == "" && designationErr == "" && instituteErr == "" && mobNoErr == "" && educationRoleTypeIdErr == "" &&
                    whatsAppMobNoErr == "" && regStateErr == "" && cityErr == "" && pincodeErr == "" && (emailErr == "" && emailErr != "Please enter proper email." && emailErr != "your emailId already register as a visitor account") && countryIdErr == ""
                    && attendeeTypeErr == "" && daysErr == ""
                ) {
                    var isInvoiceErr = false
                    if (isInvoice) {
                        if (INVPersonName == '' || INVCompanyName == '' || INVAddress == '' ||
                            // (INVTanNo == '' && this.state.countryId == 91) ||
                            (GSTNo == '' && this.state.countryId == 91) || (PANNo == '' && this.state.countryId == 91) || countryIdINV == '' || (regStateINV == '' && this.state.countryId == 91) || pincodeINV == '' || cityINV == '' || INVPersonName == null || INVCompanyName == null || INVAddress == null
                            //  || (INVTanNo == null && this.state.countryId == 91) 
                            || (GSTNo == null && this.state.countryId == 91) || (PANNo == null && this.state.countryId == 91) || countryIdINV == null || (regStateINV == null && this.state.countryId == 91) || pincodeINV == null || cityINV == null) {
                            isInvoiceErr = true
                        }
                        if (INVPersonNameErr != '' || INVCompanyNameErr != '' || INVAddressErr != '' ||
                            //  INVTanNoErr != '' || 
                            GSTNoErr != '' || PANNoErr != '' || countryIdINVErr != '' || regStateINVErr != '' || pincodeINVErr != '' || cityINVErr != '') {
                            isInvoiceErr = true
                        }
                    }
                    if (isInvoiceErr) {
                        toastError("Enter Mandatory Fields")
                    } else {
                        this.setState({ isLoading: true })
                        /// Setting data in session storage For Insert Next
                        sessionStorage.setItem("sessionregisterTelephoneNoPre", preTelNo)
                        sessionStorage.setItem("sessionregisterTelephoneNo1Pre", preTel1No)
                        sessionStorage.setItem("sessionCountryNamePreRegisterMobileNo", preMobNo)
                        sessionStorage.setItem("sessionMobileNo", mobNo)
                        sessionStorage.setItem("sessionCountryNamePreRegisterWhatsAppMobNo", preWhatsAppMobNo)
                        sessionStorage.setItem("sessionVisitorEmail", email)

                        this.props.visitorRegistrationNext_action(countryId, attendeeTypeId, preName, firstName, middleName, lastName,
                            designation, institute, mobNo, whatsAppMobNo, isSameAsMobNo, regState, city,
                            pincode, website, email, telNo, tel1No, list, attendeeTypeId == 3 ? educationRoleTypeId : '',
                            isInvoice, INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, countryIdINV, pincodeINV, regStateINV, cityINV,
                            identityCardFile, identityCardFileType, identityCardFilePath ? identityCardFilePath.split(DOC_BASE_URL).pop() : '')
                            .then((data) => {
                                if (data.error != 1) {
                                    console.log("Visitor Registration Next", data.data[0])
                                    this.setState({ isLoading: false })
                                    sessionStorage.setItem('VisitorDataSS', JSON.stringify(data.data[0]))
                                    sessionStorage.setItem('VisitorTypeID', this.state.VisitorTypeID)
                                    sessionStorage.setItem('countryId', countryId)
                                    if (mode == 1) {
                                        console.log(sessionStorage.getItem('VisitorDataSS'))
                                    } else {
                                        this.props.navigate('/visitorindustrysegment', {
                                            state: {
                                                ExhVisitorID: data.data[0]['ExhVisitorID'],
                                                countryID: countryId,
                                                OnsiteRegistration: false
                                            }
                                        })
                                    }

                                } else {
                                    this.setState({ isLoading: false })
                                    toastError(data.msg);
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                }
                else {
                    toastError("Enter Mandatory Fields")
                }
            }
            else {
                toastError("Enter Mandatory Fields")
            }

        }, 200);
    }

    // addTestElement() {
    //     const { daysList, GroupDetailsList, isCoordinatorVisit, hallChapterListCoordinator, visitorChapterListCoordinator, VisitorTypeID, countryId, attendeeTypeId } = this.state
    //     // Duplicate the last element and make changes
    //     let lastElement = GroupDetailsList[0];
    //     let lastValue = Math.random().toFixed(5)
    //     let duplicatedElement = {
    //         ...lastElement, 'firstName': `${lastElement.firstName + lastValue}`,
    //         'lastName': `${lastElement.lastName + lastValue}`,
    //         'email': `${lastElement.email + lastValue}`,
    //     };

    //     // Add the duplicated element to the array
    //     GroupDetailsList.push(duplicatedElement);
    //     this.setState({ GroupDetailsList: GroupDetailsList })
    // }

    onVisitorRegistrationGroupNext(e, mode) {
        const { daysList, GroupDetailsList, isCoordinatorVisit, interestSeminarListCoordinator, educationRoleTypeIdErr, educationRoleTypeId, hallChapterListCoordinator, visitorChapterListCoordinator, VisitorTypeID, countryId, attendeeTypeId, daysModalList, pricingList } = this.state
        e.preventDefault()
        // Is Days Selcted Check
        var daysListValidation = false
        for (var i = 0; i < this.state.daysList.length; i++) {
            if (this.state.daysList[i].isSelect == true) {
                daysListValidation = true
            }
        }
        this.inputValidate()
        // preparing Selected Days for udt
        const selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []

        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        if (this.state.isInterstOneCoordinator && this.state.interestSeminarListCoordinator.length > 0) {
            interestSeminarListCoordinator.map((data) => {
                var newitem = ''
                this.state.seminarInterestListModal.map(item => {
                    if (data.SeminarID == item.SeminarID) {
                        newitem = item
                    }
                })
                // if (data.isSelect) {
                var isIncluded = false
                list.map((data2) => {
                    if (data2.visitDay == moment.utc(newitem.Date).format("DD MMM YYYY")) {
                        isIncluded = true
                    }
                })
                if (!isIncluded) {
                    list.push({ visitDay: moment.utc(newitem.Date).format("DD MMM YYYY") })
                }
                // }
            })
        }
        var toreturn = true
        var visitDaysNoArr = []

        if (pricingList.length != 0) {
            for (var i = 0; i < pricingList.length; i++) {
                visitDaysNoArr.push(pricingList[i].VisitDays)
                if (pricingList[i].VisitDays == list.length) {
                    toreturn = false
                    break
                }
            }
            if (toreturn) {
                toastError(`Visit pass only allowed for ${visitDaysNoArr.toString()} days`)
                // modalErr = false
                return
            }
        }
        if (countryId == "" || countryId == "Select") {
            this.setState({ countryIdErr: "Please Select Country" });
        }
        if (attendeeTypeId == "") {
            this.setState({ attendeeTypeErr: "Please Select Attendee Type" });
        }
        if (VisitorTypeID == "") {
            this.setState({ visitorTypeErr: "Please Select Visitor Type" });
        }
        if (attendeeTypeId == 3) {
            if (educationRoleTypeId == '' || educationRoleTypeId == null) {
                this.setState({ educationRoleTypeIdErr: "Please Select Education Role Type" });
            }
        }
        // if (!(daysList.some(obj => obj.isSelect == true))) {
        //     this.setState({ daysErr: "Please Select Days" })
        // }
        //     this.setState({ daysErr: "Please Select Days" })
        // }
        var CoordinatorErrFlag = true
        if (isCoordinatorVisit) {
            if (list.length == 0) {
                CoordinatorErrFlag = false
            }
            if (hallChapterListCoordinator.length == 0) {
                CoordinatorErrFlag = false
            }
            if (visitorChapterListCoordinator.length == 0) {
                CoordinatorErrFlag = false
            }
            if (this.state.isVisaAssistanceCoordinator) {
                if (this.state.ApplicantEmailIDCoordinator == '' || this.state.ApplicantEmailIDCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.ApplicantMobileNoCoordinator == '' || this.state.ApplicantMobileNoCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.NameOnPassportCoordinator == '' || this.state.NameOnPassportCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.PassportExpiryDateCoordinator == '' || this.state.PassportExpiryDateCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.PassportFileCoordinator == '' || this.state.PassportFileCoordinator == null) { CoordinatorErrFlag = false }
                // if (this.state.PassportFilePathCoordinator) { CoordinatorErrFlag = false }
                // if (this.state.PassportFileTypeCoordinator) { CoordinatorErrFlag = false }
                if (this.state.PassportFileNameCoordinator == '' || this.state.PassportFileNameCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.PassportIssueDateCoordinator == '' || this.state.PassportIssueDateCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.PassportIssuingCountryIDCoordinator == '' || this.state.PassportIssuingCountryIDCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.PassportNoCoordinator == '' || this.state.PassportNoCoordinator == null) { CoordinatorErrFlag = false }
            }
            if (this.state.IsGroupDelegationCoordinator) {
                if (this.state.DelegationArrivalDateCoordinator == '' || this.state.DelegationArrivalDateCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.DelegationCountryIDCoordinator == '' || this.state.DelegationCountryIDCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.DelegationDepartureDateCoordinator == '' || this.state.DelegationDepartureDateCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.DelegationNameCoordinator == '' || this.state.DelegationNameCoordinator == null) { CoordinatorErrFlag = false }
                if (this.state.DelegationRemarkCoordinator == '' || this.state.DelegationRemarkCoordinator == null) { CoordinatorErrFlag = false }
            }
        }
        var visaFlag = true
        var eduflag = true
        GroupDetailsList.map(item => {
            console.log('GroupDetailsList', item)
            if (item.isVisaAssistance) {
                if (item.PassportFile == '' || item.PassportFile == null) {
                    visaFlag = false
                    console.log('visaFlag', visaFlag)
                }
            }
            if (attendeeTypeId == 3) {
                if (item.educationRoleTypeId == '' || item.educationRoleTypeId == null) {
                    eduflag = false
                }
            } else {
                item.educationRoleTypeId = ""
            }
        })
        this.setState({ GroupDetailsList: GroupDetailsList })
        setTimeout(() => {
            const { countryId, attendeeTypeId, firstName, city, preMobNo, mobNo, regState, designation, photoFile, lastName, photoIdFile, gender,
                instfirstitute, Name, preWhatsAppMobNo, whatsAppMobNo, pincode, email, firstNameErr, lastNameErr, designationErr, isInvoice,
                instituteErr, mobNoErr, whatsAppMobNoErr, regStateErr, institute, cityErr, pincodeErr, emailErr, preName, middleName,
                isSameAsMobNo, website, preTelNo, preTel1No, AccountID, ExhVisitorID, telNo, tel1No, countryIdErr, isOtherPreName, otherName, attendeeTypeErr, daysErr,
                INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
                countryIdINVErr, countryIdINV, regStateINV, regStateINVErr, pincodeINVErr, pincodeINV, cityINV, cityINVErr
            } = this.state

            var isInvoiceErr = false
            if (isInvoice) {
                if (INVPersonName == '' || INVCompanyName == '' || INVAddress == '' ||
                    // (INVTanNo == '' && this.state.countryId == 91) ||
                    (GSTNo == '' && this.state.countryId == 91) || (PANNo == '' && this.state.countryId == 91) || countryIdINV == '' || (regStateINV == '' && this.state.countryId == 91) || pincodeINV == '' || cityINV == '' || INVPersonName == null || INVCompanyName == null || INVAddress == null ||
                    // (INVTanNo == null && this.state.countryId == 91) ||
                    (GSTNo == null && this.state.countryId == 91) || (PANNo == null && this.state.countryId == 91) || countryIdINV == null || (regStateINV == null && this.state.countryId == 91) || pincodeINV == null || cityINV == null) {
                    isInvoiceErr = true
                }
                if (INVPersonNameErr != '' || INVCompanyNameErr != '' || INVAddressErr != '' ||
                    // INVTanNoErr != '' ||
                    GSTNoErr != '' || PANNoErr != '' || countryIdINVErr != '' || regStateINVErr != '' || pincodeINVErr != '' || cityINVErr != '') {
                    isInvoiceErr = true
                }
            }
            if (isInvoiceErr) {
                toastError("Enter Mandatory Fields")
            } else {
                if (firstName != "" && lastName != "" && designation != "" && institute != "" && mobNo != "" && whatsAppMobNo != "" && (attendeeTypeId == 3 ? educationRoleTypeId != "" : true) &&
                    city != "" && pincode != "" && email != "" && countryId != "" && attendeeTypeId != "") {
                    if (firstNameErr == "" && lastNameErr == "" && designationErr == "" && instituteErr == "" && mobNoErr == "" && educationRoleTypeIdErr == "" &&
                        whatsAppMobNoErr == "" && regStateErr == "" && cityErr == "" && pincodeErr == "" && (emailErr == "" && emailErr != "Please enter proper email." && emailErr != "your emailId already register as a visitor account") && countryIdErr == ""
                        && attendeeTypeErr == "" && daysErr == "" && visaFlag && eduflag
                    ) {
                        if (CoordinatorErrFlag) {

                            if (this.state.GroupDetailsList.length == 0) {
                                toastError("Please Add Atleast 1 Visitor")
                            } else {
                                for (var a = 0; a < GroupDetailsList.length; a++) {
                                    if (GroupDetailsList[a].IsInterestedforSeminar && GroupDetailsList[a].interestSeminarList.length > 0) {
                                        GroupDetailsList[a].interestSeminarList.map((data) => {
                                            var newitem = ''
                                            this.state.seminarInterestListModal.map(item => {
                                                if (data.SeminarID == item.SeminarID) {
                                                    newitem = item
                                                }
                                            })
                                            // if (data.isSelect) {
                                            var isIncluded = false
                                            GroupDetailsList[a].DateArr.map((data2) => {
                                                if (data2.visitDay == moment.utc(newitem.Date).format("DD MMM YYYY")) {
                                                    isIncluded = true
                                                }
                                            })
                                            if (!isIncluded) {
                                                GroupDetailsList[a].DateArr.push({ visitDay: moment.utc(newitem.Date).format("DD MMM YYYY") })
                                            }
                                            // }
                                        })
                                    }
                                    GroupDetailsList[a].isInvoice = 0
                                    GroupDetailsList[a].INVPersonName = ''
                                    GroupDetailsList[a].INVCompanyName = ''
                                    GroupDetailsList[a].INVAddress = ''
                                    GroupDetailsList[a].INVTanNo = ''
                                    GroupDetailsList[a].GSTNo = ''
                                    GroupDetailsList[a].PANNo = ''

                                    GroupDetailsList[a].INVCity_V = ''
                                    GroupDetailsList[a].INVCountryID_V = ''
                                    GroupDetailsList[a].INVState_V = ''
                                    GroupDetailsList[a].INVPinCode_V = ''
                                }
                                this.setState({ GroupDetailsList: GroupDetailsList })
                                var obj = {
                                    'Title': isOtherPreName ? otherName : preName,
                                    'firstName': firstName,
                                    'middleName': middleName,
                                    'lastName': lastName,
                                    'institute': institute,
                                    'isOtherPreName': isOtherPreName,
                                    'otherName': otherName,
                                    'designation': designation,
                                    'mobNo': preMobNo != '' && preMobNo != null ? `${preMobNo}-${mobNo}` : mobNo,
                                    'whatsAppMobNo': preWhatsAppMobNo != '' && preWhatsAppMobNo != null ? `${preWhatsAppMobNo}-${whatsAppMobNo}` : whatsAppMobNo,
                                    'pincode': pincode,
                                    'regState': regState,
                                    'isSameAsMobNo': isSameAsMobNo,
                                    'city': city,
                                    'website': website,
                                    'AccountID': AccountID != null && AccountID != '' ? AccountID : null,
                                    'ExhVisitorID': ExhVisitorID != null && ExhVisitorID != '' ? ExhVisitorID : null,
                                    'email': email,
                                    'telNo': preTelNo != '' && preTelNo != null ? `${preTelNo}-${telNo}` : telNo,
                                    'tel1No': preTel1No != '' && preTel1No != null ? `${preTel1No}-${tel1No}` : tel1No,
                                    'id': 0,
                                    'isCoordinator': true,
                                    'isVisit': this.state.isCoordinatorVisit,
                                    'countryId': countryId,
                                    'DateArr': this.state.isCoordinatorVisit ? list : [],
                                    'ApplicantEmailID': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.ApplicantEmailIDCoordinator : '' : '',
                                    'ApplicantMobileNo': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.ApplicantMobileNoCoordinator : '' : '',
                                    'B2BDepartureDate': this.state.isCoordinatorVisit ? this.state.B2BDepartureDateCoordinator : '',
                                    'B2BPreferredTime': this.state.isCoordinatorVisit ? this.state.B2BPreferredTimeCoordinator : '',
                                    'B2BRemark': this.state.isCoordinatorVisit ? this.state.B2BRemarkCoordinator : '',
                                    'Carparking': false,
                                    'DelegationArrivalDate': this.state.isCoordinatorVisit ? this.state.IsGroupDelegationCoordinator ? this.state.DelegationArrivalDateCoordinator : '' : '',
                                    'DelegationCountryID': this.state.isCoordinatorVisit ? this.state.IsGroupDelegationCoordinator ? this.state.DelegationCountryIDCoordinator : '' : '',
                                    'DelegationDepartureDate': this.state.isCoordinatorVisit ? this.state.IsGroupDelegationCoordinator ? this.state.DelegationDepartureDateCoordinator : '' : '',
                                    'DelegationName': this.state.isCoordinatorVisit ? this.state.IsGroupDelegationCoordinator ? this.state.DelegationNameCoordinator : '' : '',
                                    'DelegationRemark': this.state.isCoordinatorVisit ? this.state.IsGroupDelegationCoordinator ? this.state.DelegationRemarkCoordinator : '' : '',
                                    'ExhibitionID': parseInt(sessionStorage.getItem('sessionExhibitionID')),
                                    'IsGroupDelegation': this.state.isCoordinatorVisit ? this.state.IsGroupDelegationCoordinator : '',
                                    'NameOnPassport': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.NameOnPassportCoordinator : '' : '',
                                    'ParkingCharges': 0,
                                    'PassportExpiryDate': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.PassportExpiryDateCoordinator : '' : '',
                                    'PassportFile': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.PassportFileCoordinator : '' : '',
                                    'PassportFilePath': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.PassportFilePathCoordinator : '' : '',
                                    'PassportFileType': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.PassportFileTypeCoordinator : '' : '',
                                    'PassportIssueDate': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.PassportIssueDateCoordinator : '' : '',
                                    'PassportIssuingCountryID': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.PassportIssuingCountryIDCoordinator : '' : '',
                                    'PassportNo': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator ? this.state.PassportNoCoordinator : '' : '',
                                    'UserID': null,
                                    'areaOfInterestList': [],
                                    'hallChapterList': this.state.isCoordinatorVisit ? this.state.hallChapterListCoordinator : [],
                                    'interestSeminarList': this.state.isCoordinatorVisit ? this.state.interestSeminarListCoordinator : [],
                                    'isVisaAssistance': this.state.isCoordinatorVisit ? this.state.isVisaAssistanceCoordinator : false,
                                    'purposeOfVisitList': [],
                                    'visitorChapterList': this.state.isCoordinatorVisit ? this.state.visitorChapterListCoordinator : [],
                                    'visitorRegNo': this.state.isCoordinatorVisit ? this.state.visitorRegNoCoordinator : '',
                                    'IsInterestedforSeminar': this.state.isInterstOneCoordinator,
                                    'IsInterestedforb2b': this.state.isInterestTwoCoordinator,
                                    'educationRoleTypeId': attendeeTypeId == 3 ? this.state.educationRoleTypeId : '',

                                    'isInvoice': isInvoice,
                                    'INVPersonName': isInvoice ? INVPersonName : '',
                                    'INVCompanyName': isInvoice ? INVCompanyName : '',
                                    'INVAddress': isInvoice ? INVAddress : '',
                                    'INVTanNo': isInvoice ? INVTanNo : '',
                                    'GSTNo': isInvoice ? GSTNo : '',
                                    'PANNo': isInvoice ? PANNo : '',

                                    'INVCity_V': isInvoice ? cityINV : '',
                                    'INVCountryID_V': isInvoice ? countryIdINV : '',
                                    'INVState_V': isInvoice ? regStateINV : '',
                                    'INVPinCode_V': isInvoice ? pincodeINV : '',

                                    'IdentityCardFile': this.state.identityCardFile || '',
                                    'IdentityCardFileType': this.state.identityCardFileType || '',
                                    'IdentityCardPath': this.state.identityCardFilePath || ''
                                }
                                GroupDetailsList.unshift(obj)
                                this.setState({ isSaving: true })
                                if (GroupDetailsList.length > 1) {
                                    this.setState({ isLoading: true })
                                    /// Setting data in session storage For Insert Next
                                    this.props.visitorRegistrationGroupNext_action(countryId, attendeeTypeId, GroupDetailsList)
                                        .then((data) => {
                                            if (data.error != 1) {
                                                console.log("Visitor Registration Next", data.data)
                                                this.setState({ isLoading: false })
                                                sessionStorage.setItem('VisitorTypeID', this.state.VisitorTypeID)
                                                var mobNoArr = []
                                                var emailArr = []
                                                for (var j = 0; j < GroupDetailsList.length; j++) {
                                                    mobNoArr.push(GroupDetailsList[j].mobNo)
                                                    emailArr.push(GroupDetailsList[j].email)
                                                }
                                                mobNoArr.toString()
                                                emailArr.toString()
                                                data.data[0][0].mobNo = mobNoArr.toString()
                                                data.data[0][0].email = emailArr.toString()
                                                sessionStorage.setItem('VisitorDataSS', JSON.stringify(data.data[0][0]))
                                                for (var i = 0; i < data.data[1].length; i++) {
                                                    if (data.data[1][i].isCoordinator == 1) {
                                                        // sessionStorage.setItem('VisitorDataSS', JSON.stringify(data.data[1][i]))
                                                        sessionStorage.setItem('VisitorTypeID', this.state.VisitorTypeID)
                                                        sessionStorage.setItem('countryId', data.data[1][i].CountryID)
                                                        this.setState({ ExhVisitorID: data.data[1][i].ExhVisitorID, AccountID: data.data[1][i].AccountID })
                                                    }
                                                    for (var j = 0; j < GroupDetailsList.length; j++) {
                                                        if (GroupDetailsList[j].email == data.data[1][i].Email) {
                                                            GroupDetailsList[j].AccountID = data.data[1][i].AccountID
                                                            GroupDetailsList[j].ExhVisitorID = data.data[1][i].ExhVisitorID
                                                            GroupDetailsList[j].visitorRegNo = data.data[1][i].visitorRegistrationNo
                                                            if (GroupDetailsList[j].needVisaAssistance) {
                                                                GroupDetailsList[j].passportFileType = null
                                                                GroupDetailsList[j].isPassportFilePresent = true
                                                            }

                                                        }
                                                    }
                                                }

                                                if (mode == 1) {
                                                    GroupDetailsList.shift()
                                                    this.setState({ isSaving: false })
                                                    // this.setState()
                                                    console.log(sessionStorage.getItem('VisitorDataSS'))
                                                    this.setState({ GroupDetailsList: [] }, () => {
                                                        this.getRegistrationDetails()
                                                        console.log(GroupDetailsList)
                                                    })
                                                } else {
                                                    this.props.navigate('/visitorindustrysegment', {
                                                        state: {
                                                            // ExhVisitorID: data.data[0]['ExhVisitorID'],
                                                            countryID: countryId
                                                        }
                                                    })
                                                }
                                            } else {
                                                this.setState({ isLoading: false })
                                                // console.log
                                                toastError(data.msg);
                                            }
                                        })
                                        .catch((err) => {
                                            console.log(err)
                                        })
                                } else {
                                    toastError("add atleast 1 visitor")
                                }
                            }
                        } else {
                            toastError("Enter Coordinator Details")
                        }
                    }
                    else {
                        toastError("Enter Mandatory Fields")
                    }
                }
                else {
                    toastError("Enter Mandatory Fields")
                }
            }
        }, 200);
    }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    //Pincode Search
    onPincodeSearch(e, status) {
        const { pincodeList, tempPincodeList, tempGroupPincodeList, pincode } = this.state
        if (status == 1) {
            if (e.target.value != '') {
                var searchPincodeList = tempGroupPincodeList.filter(data => {
                    return (
                        data
                            .Pincode
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    pincodeModal: e.target.value,
                    pincodeErrModal: "",
                    tempGroupPincodeList: searchPincodeList,
                    isDisplayGroupPincodeList: true
                })
            } else {
                this.setState({
                    pincodeModal: e.target.value,
                    tempGroupPincodeList: pincodeList,
                    isDisplayGroupPincodeList: false
                })
            }
        } else {
            if (e.target.value != '') {
                var searchPincodeList = tempPincodeList.filter(data => {
                    return (
                        data
                            .Pincode
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    pincode: e.target.value,
                    pincodeErr: "",
                    tempPincodeList: searchPincodeList,
                    isDisplayPincodeList: true
                })
            } else {
                this.setState({
                    pincode: e.target.value,
                    tempPincodeList: pincodeList,
                    isDisplayPincodeList: false
                })
            }
        }
    }

    // render pincode
    renderPincodeList() {
        const { tempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPincodeList.length > 0 && tempPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                pincode: data.Pincode,
                                isDisplayPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }

    //Pincode Search
    onPincodeSearchINV(e) {
        const { pincodeList, tempPincodeList, tempINVPincodeList, tempGroupPincodeList, pincode } = this.state
        if (e.target.value != '') {
            var searchPincodeList = tempINVPincodeList.filter(data => {
                return (
                    data
                        .Pincode
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                pincodeINV: e.target.value,
                pincodeINVErr: "",
                tempINVPincodeList: searchPincodeList,
                isDisplayPincodeListINV: true
            })
        } else {
            this.setState({
                pincodeINV: e.target.value,
                tempINVPincodeList: pincodeList,
                isDisplayPincodeListINV: false
            })
        }
    }

    // render pincode
    renderPincodeListINV() {
        const { tempPincodeList, tempINVPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempINVPincodeList.length > 0 && tempINVPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                pincodeINV: data.Pincode,
                                isDisplayPincodeListINV: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }

    renderGroupPincodeList() {
        const { tempPincodeList, tempGroupPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempGroupPincodeList.length > 0 && tempGroupPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                pincodeModal: data.Pincode,
                                isDisplayGroupPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }

    // On Country Select
    onCountrySelect(e, status) {
        const { countryList, GroupDetailsList } = this.state
        var countryId = e.target.value
        if (status == 1) {
            if (this.state.modalID != 'Coordinator') {
                if (this.state.countryId != 91 && countryId == 91) {
                    toastError("Indian Visitor cannot be Registered by International Coordinator")
                } else {
                    this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
                    var countryCode = countryId != '' ? countryList.filter(obj => obj.Code == countryId)[0].CountryCode : ''
                    this.setState({
                        preMobNoModal: `+${countryCode}`,
                        preWhatsAppMobNoModal: `+${countryCode}`
                    })
                    this.getFillList(pincodeActionId, '', '', countryId, '', '')
                    this.getFillList(stateActionId, '', '', countryId, '', '')
                    this.getFillList(cityActionId, '', '', countryId, '', '')
                    setTimeout(() => {
                        this.setState({
                            isDisplayPincodeList: false,
                            isDisplayCityList: false,
                            isDisplayStateList: false,
                            isDisplayGroupPincodeList: false,
                            isDisplayGroupCityList: false,
                            isDisplayGroupStateList: false,
                        })
                    }, 200);
                }
            } else {
                var isIndianVisitor = false
                if (GroupDetailsList.length > 0) {
                    for (var i = 0; i < GroupDetailsList.length; i++) {
                        if (GroupDetailsList[i].countryId == 91) {
                            isIndianVisitor = true
                        }
                    }
                }
                if (isIndianVisitor && countryId != 91) {
                    toastError("International Coordinator cannot have Indian Visitor")
                }
                else {
                    this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
                    var countryCode = countryId != '' ? countryList.filter(obj => obj.Code == countryId)[0].CountryCode : ''
                    this.setState({
                        preMobNoModal: `+${countryCode}`,
                        preWhatsAppMobNoModal: `+${countryCode}`
                    })
                    this.getFillList(pincodeActionId, '', '', countryId, '', '')
                    this.getFillList(stateActionId, '', '', countryId, '', '')
                    this.getFillList(cityActionId, '', '', countryId, '', '')
                    setTimeout(() => {
                        this.setState({
                            isDisplayPincodeList: false,
                            isDisplayCityList: false,
                            isDisplayStateList: false,
                            isDisplayGroupPincodeList: false,
                            isDisplayGroupCityList: false,
                            isDisplayGroupStateList: false,
                        })
                    }, 200);
                }
            }
        } else if (status == 2) {
            this.setState({ passCountry: countryId, passCountryErr: "" })
            // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
            // this.setState({
            //     preMobNoModal: `+${countryCode}`,
            //     preWhatsAppMobNoModal: `+${countryCode}`
            // })
        } else if (status == 3) {
            this.setState({ delegationCountry: countryId, delegationCountryErr: "" })
            // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
            // this.setState({
            //     preMobNoModal: `+${countryCode}`,
            //     preWhatsAppMobNoModal: `+${countryCode}`
            // })
        } else {
            var isIndianVisitor = false
            if (GroupDetailsList.length > 0) {
                for (var i = 0; i < GroupDetailsList.length; i++) {
                    if (GroupDetailsList[i].countryId == 91) {
                        isIndianVisitor = true
                    }
                }
            }
            if (isIndianVisitor && countryId != 91) {
                toastError("International Coordinator cannot have Indian Visitor")
            }
            else {
                this.setState({ countryId: countryId, countryIdErr: "" })
                var countryCode = countryId != '' ? countryList.filter(obj => obj.Code == countryId)[0].CountryCode : ''
                this.setState({
                    preMobNo: `+${countryCode}`,
                    preWhatsAppMobNo: `+${countryCode}`
                })
                // Calling City , State , Pincode filllist on country Select
                this.getFillList(pincodeActionId, '', '', countryId, '', '')
                this.getFillList(stateActionId, '', '', countryId, '', '')
                this.getFillList(cityActionId, '', '', countryId, '', '')
                this.getFillList(GSTvalidationActionId, '', '', countryId, '', '')
            }

        }

        // if (status == 1) {
        //     this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
        //     var countryCode = countryId != '' ? countryList.filter(obj => obj.Code == countryId)[0].CountryCode : ''
        //     this.setState({
        //         preMobNoModal: `+${countryCode}`,
        //         preWhatsAppMobNoModal: `+${countryCode}`
        //     })
        //     this.getFillList(pincodeActionId, '', '', countryId, '', '')
        //     this.getFillList(stateActionId, '', '', countryId, '', '')
        //     this.getFillList(cityActionId, '', '', countryId, '', '')
        //     setTimeout(() => {
        //         this.setState({
        //             isDisplayPincodeList: false,
        //             isDisplayCityList: false,
        //             isDisplayStateList: false,
        //             isDisplayGroupPincodeList: false,
        //             isDisplayGroupCityList: false,
        //             isDisplayGroupStateList: false,
        //         })
        //     }, 200);
        // } else if (status == 2) {
        //     this.setState({ passCountry: countryId, passCountryErr: "" })
        //     // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
        //     // this.setState({
        //     //     preMobNoModal: `+${countryCode}`,
        //     //     preWhatsAppMobNoModal: `+${countryCode}`
        //     // })
        // } else if (status == 3) {
        //     this.setState({ delegationCountry: countryId, delegationCountryErr: "" })
        //     // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
        //     // this.setState({
        //     //     preMobNoModal: `+${countryCode}`,
        //     //     preWhatsAppMobNoModal: `+${countryCode}`
        //     // })
        // } else {
        //     this.setState({ countryId: countryId, countryIdErr: "" })
        //     var countryCode = countryId != '' ? countryList.filter(obj => obj.Code == countryId)[0].CountryCode : ''
        //     this.setState({
        //         preMobNo: `+${countryCode}`,
        //         preWhatsAppMobNo: `+${countryCode}`
        //     })
        //     // Calling City , State , Pincode filllist on country Select
        //     this.getFillList(pincodeActionId, '', '', countryId, '', '')
        //     this.getFillList(stateActionId, '', '', countryId, '', '')
        //     this.getFillList(cityActionId, '', '', countryId, '', '')
        // }
    }

    onCountrySelectINV(e) {
        const { countryList } = this.state
        var countryIdINV = e.target.value
        this.setState({ countryIdINV: countryIdINV, countryIdINVErr: "" })
        // var countryCode = countryIdINV != '' ? countryList.filter(obj => obj.Code == countryIdINV)[0].CountryCode : ''
        // this.setState({
        //     preMobNoModal: `+${countryCode}`,
        //     preWhatsAppMobNoModal: `+${countryCode}`
        // })
        this.getFillList(pincodeActionId, '', '', countryIdINV, '', '')
        this.getFillList(stateActionId, '', '', countryIdINV, '', '')
        this.getFillList(cityActionId, '', '', countryIdINV, '', '')
        setTimeout(() => {
            this.setState({
                isDisplayPincodeListINV: false,
                isDisplayStateListINV: false,
                isDisplayCityListINV: false,
                isDisplayPincodeList: false,
                isDisplayCityList: false,
                isDisplayStateList: false,
                isDisplayGroupPincodeList: false,
                isDisplayGroupCityList: false,
                isDisplayGroupStateList: false,
                // isDisplayGroupPincodeList: false,
                // isDisplayGroupCityList: false,
                // isDisplayGroupStateList: false,
            })
        }, 200);
    }

    // search city
    onCitySearch(e, status) {
        const { cityList, tempCityList, tempGroupCityList } = this.state
        if (status == 1) {
            if (e.target.value != '') {
                var searchCityList = tempGroupCityList.filter(data => {
                    return (
                        data
                            .Description
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    cityModal: e.target.value,
                    cityErrModal: "",
                    tempGroupCityList: searchCityList,
                    isDisplayGroupCityList: true
                })
            } else {
                this.setState({
                    cityModal: e.target.value,
                    tempGroupCityList: cityList,
                    isDisplayGroupCityList: false
                })
            }
        } else {
            if (e.target.value != '') {
                var searchCityList = tempCityList.filter(data => {
                    return (
                        data
                            .Description
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    city: e.target.value,
                    cityErr: "",
                    tempCityList: searchCityList,
                    isDisplayCityList: true
                })
            } else {
                this.setState({
                    city: e.target.value,
                    tempCityList: cityList,
                    isDisplayCityList: false
                })
            }
        }
    }

    // render city
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCityList.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ city: data.Description, isDisplayCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    onCitySearchINV(e, status) {
        const { cityList, tempCityList, tempINVCityList, isDisplayCityListINV } = this.state
        if (e.target.value != '') {
            var searchCityList = tempINVCityList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                cityINV: e.target.value,
                cityINVErr: "",
                tempINVCityList: searchCityList,
                isDisplayCityListINV: true
            })
        } else {
            this.setState({
                cityINV: e.target.value,
                tempINVCityList: cityList,
                isDisplayCityListINV: false
            })
        }
    }

    // render city
    renderCityListINV() {
        const { tempINVCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempINVCityList.length > 0 && tempINVCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ cityINV: data.Description, isDisplayCityListINV: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    renderGroupCityList() {
        const { tempCityList, tempGroupCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempGroupCityList.length > 0 && tempGroupCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ cityModal: data.Description, isDisplayGroupCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // search state
    onStateSearch(e, status) {
        const { tempStateList, stateList, tempGroupStateList } = this.state
        if (status == 1) {
            if (e.target.value != '') {
                var searchStateList = tempGroupStateList.filter(data => {
                    return (
                        data
                            .Description
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                console.log(searchStateList, e.target.value)
                this.setState({
                    regStateModal: e.target.value,
                    regStateErrModal: "",
                    tempGroupStateList: searchStateList,
                    isDisplayGroupStateList: true
                })
            } else {
                this.setState({
                    regStateModal: e.target.value,
                    tempGroupStateList: stateList,
                    isDisplayGroupStateList: false
                })
            }
        } else {
            if (e.target.value != '') {
                var searchStateList = tempStateList.filter(data => {
                    return (
                        data
                            .Description
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                console.log(searchStateList, e.target.value)
                this.setState({
                    stateId: '',
                    regState: e.target.value,
                    regStateErr: "",
                    tempStateList: searchStateList,
                    isDisplayStateList: true
                })
            } else {
                this.setState({
                    stateId: '',
                    regState: e.target.value,
                    tempStateList: stateList,
                    isDisplayStateList: false
                })
            }
        }
    }

    // render state
    renderStateList() {
        const { tempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempStateList.length > 0 && tempStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ regState: data.Description, isDisplayStateList: false, stateId: data.Code }, () => {
                                this.getFillList(stateActionId, "", "", "", '', "", "");

                            })}
                        >{data.Description}</li>

                    ))
                }
            </ul>

        )
    }

    onStateSearchINV(e, status) {
        const { tempStateList, stateList, tempINVStateList } = this.state
        if (e.target.value != '') {
            var searchStateList = tempINVStateList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log(searchStateList, e.target.value)
            this.setState({
                regStateINV: e.target.value,
                regStateINVErr: "",
                tempINVStateList: searchStateList,
                isDisplayStateListINV: true,
                GSTNoErr: ''
            })
        } else {
            this.setState({
                regStateINV: e.target.value,
                tempINVStateList: stateList,
                isDisplayStateListINV: false,
                GSTNoErr: ''
            })
        }
    }

    // render state
    renderStateListINV() {
        const { tempINVStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempINVStateList.length > 0 && tempINVStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ regStateINV: data.Description, isDisplayStateListINV: false, stateIdINV: data.Code }, () => {
                                this.getFillList(stateActionId, "", "", "", '', "", "");

                            })}
                        >{data.Description}</li>

                    ))
                }
            </ul>

        )
    }

    renderGroupStateList() {
        const { tempStateList, tempGroupStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempGroupStateList.length > 0 && tempGroupStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ regStateModal: data.Description, isDisplayGroupStateList: false })}
                        >{data.Description}</li>

                    ))
                }
            </ul>
        )
    }

    // On Same As Mobile No Click
    onSameAsMobNoClick(e, status) {
        const { isSameAsMobNo, mobNo, preMobNo, isSameAsMobNoModal, mobNoModal, preMobNoModal } = this.state
        if (status == 1) {
            this.setState({ isSameAsMobNoModal: !isSameAsMobNoModal })
            var checked = e.target.checked
            if (checked) {
                this.setState({
                    whatsAppMobNoModal: mobNoModal,
                    preWhatsAppMobNoModal: preMobNoModal,
                    whatsAppMobNoErrModal: ""
                })
            } else {
                this.setState({
                    whatsAppMobNoErrModal: "",
                })

            }
        } else {
            this.setState({ isSameAsMobNo: !isSameAsMobNo })
            var checked = e.target.checked
            if (checked) {
                this.setState({
                    whatsAppMobNo: mobNo,
                    preWhatsAppMobNo: preMobNo,
                    whatsAppMobNoErr: ""
                })
            } else {
                this.setState({
                    whatsAppMobNo: "",

                })

            }
        }
    }


    getSeminarGST(State, ExihibitionID, SeminarID, Country) {
        const { countryId } = this.state
        this.setState({ isLoading: true })
        this.props.getSeminarGST_action(State, ExihibitionID, SeminarID, Country)
            .then((data) => {
                if (!data) {
                    this.setState({ isLoading: false })
                    // toastError("Failed to fetch seminar details.")
                    // return
                }
                if (data.error != 1) {
                    this.setState({
                        seminarCharges: countryId == 91 ? data.data[0].IsGSTIncluded == 1 ? data.data[0].INRCGST != 0 && data.data[0].INRSGST != 0 ? (data.data[0].PriceINR - data.data[0].INRSGST - data.data[0].INRCGST) : (data.data[0].PriceINR - data.data[0].INRIGST) : data.data[0].PriceINR : data.data[0].IsGSTIncluded == 1 ? (data.data[0].PriceUSD - data.data[0].USDIGST) : data.data[0].PriceUSD,
                        seminarCGST: countryId == 91 ? data.data[0].INRCGST : 0,
                        seminarSGST: countryId == 91 ? data.data[0].INRSGST : 0,
                        seminarIGST: countryId == 91 ? data.data[0].INRIGST : data.data[0].USDIGST,
                        TotalPayable: countryId == 91 ? data.data[0].IsGSTIncluded == 1 ? data.data[0].PriceINR : data.data[0].INRCGST != 0 && data.data[0].INRSGST != 0 ? (data.data[0].PriceINR + data.data[0].INRSGST + data.data[0].INRCGST) : (data.data[0].PriceINR + data.data[0].INRIGST) : data.data[0].IsGSTIncluded == 1 ? data.data[0].PriceUSD : (data.data[0].PriceUSD + data.data[0].USDIGST),
                        ChargesPop: true
                    })
                    this.setState({ isLoading: false })

                }
            })
    }
    // Get Registration Details
    getRegistrationDetails() {

        setTimeout(() => {
            const { attendeeList, daysList, educationRoleTypeId, primaryChapterListData, level0, level2, level3, level4 } = this.state
            this.setState({ isLoading: true })

            this.props.getVistiorRegistarionDetails_action()
                .then((data) => {
                    if (data.error != 1) {
                        console.log("Get Registration Details", data.data['SelectedVisitDays'])
                        // Updating Attendee List
                        var attendeeId = data.data['registrationDetails'][0]['AttendeeTypeID'] != null ? data.data['registrationDetails'][0]['AttendeeTypeID'] : ''
                        attendeeList.length > 0 && attendeeList.map((item) => {
                            if (item.AttendeeTypeID == attendeeId) {
                                item.isChecked = true
                            }
                        })


                        // Split Phone Numbers and country Code 
                        //  Mobile No
                        var mob1 = data.data['registrationDetails'][0]['MobileNo']
                        const parts = mob1 != '' ? mob1.split("-") : '';
                        const Mob1Code = parts.length > 1 && parts != '' ? parts[0] : ''
                        const Mob1No = parts != '' ? parts.length > 1 ? parts[1] : parts[0] : ''
                        // WhatsApp Mobile No
                        var mob2 = data.data['registrationDetails'][0]['WhatsappNo']
                        const parts2 = mob2 != '' ? mob2.split("-") : ''
                        const Mob2Code = parts2.length > 1 && parts2 != '' ? parts2[0] : ''
                        const Mob2No = parts2 != '' ? parts2.length > 1 ? parts2[1] : parts2[0] : ''
                        // TelePhone No
                        var tel = data.data['registrationDetails'][0]['Telephone']
                        const parts3 = tel != '' ? tel.split("-") : ''
                        const telCode = parts3.length > 1 && parts3 != '' ? parts3[0] : ''
                        const telNumber = parts3 != '' ? parts3.length > 1 ? parts3[1] : parts3[0] : ''
                        // Telephone 1 Mobile No
                        var tel1 = data.data['registrationDetails'][0]['Telephone1']
                        const parts4 = tel1 != '' ? tel1.split("-") : ''
                        const tel1Code = parts4.length > 1 && parts4 != '' ? parts4[0] : ''
                        const tel1Number = parts4 != '' ? parts4.length > 1 ? parts4[1] : parts4[0] : ''

                        // var applicantMob = item['ApplicantMobileNo']
                        // const parts5 = applicantMob != '' ? applicantMob.split("-") : ''
                        // const passMobNoCode = parts5.length > 1 && parts5 != '' ? parts5[0] : ''
                        // const passMobNoNumber = parts5 != '' ? parts5.length > 1 ? parts5[1] : parts5[0] : ''

                        // var mob1 = data.data['registrationDetails'][0]['MobileNo']
                        // const parts = mob1.split("-");
                        // const Mob1Code = parts[0]
                        // const Mob1No = parts[1]
                        // // WhatsApp Mobile No
                        // var mob2 = data.data['registrationDetails'][0]['WhatsappNo']
                        // const parts2 = mob2.split("-")
                        // const Mob2Code = parts2[0]
                        // const Mob2No = parts2[1]
                        // // TelePhone No
                        // var tel = data.data['registrationDetails'][0]['Telephone']
                        // const parts3 = tel.split("-")
                        // const telCode = parts3[0]
                        // const telNumber = parts3[1]
                        // // Telephone 1 Mobile No
                        // var tel1 = data.data['registrationDetails'][0]['Telephone1']
                        // const parts4 = tel1.split("-")
                        // const tel1Code = parts4[0]
                        // const tel1Number = parts4[1]

                        // Days List Prepare on basis on get Days list

                        data.data['registrationDetails'].length > 1 ? sessionStorage.setItem('VisitorTypeID', 2) : sessionStorage.setItem('VisitorTypeID', 1)
                        data.data['registrationDetails'].length > 1 && this.setState({ isFirst: false })
                        // data.data['registrationDetails'].length > 1 ?
                        data.data['registrationDetails'].length > 1 &&
                            data.data['registrationDetails'].map((item, i) => {
                                if (item.isCoordinator == true) {//

                                    var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
                                    daysList.length > 0 && daysList.map((item2) => {
                                        selectedDaysList.length > 0 && selectedDaysList.map((element) => {
                                            if (element.ExhVisitorID == item.ExhVisitorID) {
                                                if (element.VisitDate == item2.VisitDate) {
                                                    item2.isSelect = true
                                                    element.isSelect = true
                                                }
                                            } else {
                                                element.isSelect = false
                                            }
                                        })
                                    })
                                    console.log('daysLIST', daysList)
                                    // var selectedDays = daysList.filter(data => data.isSelect == true)
                                    var listssss = []
                                    selectedDaysList.map((elementt) => {
                                        if (elementt.isSelect) {
                                            var data = {
                                                "visitDay": elementt.VisitDate
                                            }
                                            listssss.push(data)
                                        }
                                    })
                                    // console.log("hgdddhdjdjdjdkdj", daysList, this.state.daysModalList)
                                    this.setState({ DateArrCoordinator: listssss, daysErr: "" })

                                    var chapterListData = []
                                    var selectedChapter = data.data['chapterList'] != null ? data.data['chapterList'] : []
                                    selectedChapter.map((item2) => {
                                        if (item2.ExhVisitorID == item.ExhVisitorID) {
                                            var mapdata = {
                                                "ChapterID": item2.ChapterID,
                                                "ChapterNames": item2['ChapterName'],
                                                "OtherNames": item2.ChapterID == 16 ? item2.other != undefined ? item2.other : '' : ''
                                            }
                                            chapterListData.push(mapdata)
                                        }
                                    })


                                    // Preparing Udt For Hall Chapter List
                                    // var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
                                    // var filerArray = allArray.filter((mapdata) => mapdata.IsCheckbox && mapdata.IsSelect)
                                    var chapterListData2 = []
                                    var selectedhallChapter = data.data['hallChapterList'] != null ? data.data['hallChapterList'] : []
                                    selectedhallChapter.map((item2) => {
                                        if (item2.MappingExhVisitorID == item.ExhVisitorID) {
                                            var mapdata = {
                                                "ChapterID": item2.MappingChapterID,
                                                "ChapterNames": item2.MappingChapterName,
                                                // "OtherNames": ''
                                            }
                                            chapterListData2.push(mapdata)
                                        }
                                    })
                                    var seminarInterestListData = []
                                    var selectedSeminarList = data.data['seminarInterestList'] != null ? data.data['seminarInterestList'] : []
                                    console.log(selectedSeminarList, 'selectedSeminarList')
                                    selectedSeminarList.map((item2) => {
                                        if (item2.ExhVisitorID == item.ExhVisitorID) {
                                            var data = {
                                                "SeminarID": item2.SeminarID,
                                            }
                                            seminarInterestListData.push(data)
                                        }

                                    })
                                    // console.log('item', item.FirstName)
                                    var mob1 = item['MobileNo']
                                    const parts = mob1 != '' ? mob1.split("-") : '';
                                    const Mob1Code = parts.length > 1 && parts != '' ? parts[0] : ''
                                    const Mob1No = parts != '' ? parts.length > 1 ? parts[1] : parts[0] : ''
                                    // WhatsApp Mobile No
                                    var mob2 = item['WhatsappNo']
                                    const parts2 = mob2 != '' ? mob2.split("-") : ''
                                    const Mob2Code = parts2.length > 1 && parts2 != '' ? parts2[0] : ''
                                    const Mob2No = parts2 != '' ? parts2.length > 1 ? parts2[1] : parts2[0] : ''
                                    // TelePhone No
                                    var tel = item['Telephone']
                                    const parts3 = tel != '' ? tel.split("-") : ''
                                    const telCode = parts3.length > 1 && parts3 != '' ? parts3[0] : ''
                                    const telNumber = parts3 != '' ? parts3.length > 1 ? parts3[1] : parts3[0] : ''
                                    // Telephone 1 Mobile No
                                    var tel1 = item['Telephone1']
                                    const parts4 = tel1 != '' ? tel1.split("-") : ''
                                    const tel1Code = parts4.length > 1 && parts4 != '' ? parts4[0] : ''
                                    const tel1Number = parts4 != '' ? parts4.length > 1 ? parts4[1] : parts4[0] : ''

                                    var applicantMob = item['ApplicantMobileNo']
                                    const parts5 = applicantMob != '' ? applicantMob.split("-") : ''
                                    const passMobNoCode = parts5.length > 1 && parts5 != '' ? parts5[0] : ''
                                    const passMobNoNumber = parts5 != '' ? parts5.length > 1 ? parts5[1] : parts5[0] : ''

                                    // var applicantMob = item['ApplicantMobileNo']
                                    // const parts5 = applicantMob != '' ? applicantMob.split("-") : ''
                                    // const passMobNoCode = parts5.length > 1 && parts5 != '' ? parts5[0] : ''
                                    // const passMobNoNumber = parts5 != '' ? parts5.length > 1 ? parts5[1] : parts5[0] : ''

                                    // var mob1 = item['MobileNo']
                                    // const parts = mob1.split("-");
                                    // const Mob1Code = parts[0]
                                    // const Mob1No = parts[1]
                                    // // WhatsApp Mobile No
                                    // var mob2 = item['WhatsappNo']
                                    // const parts2 = mob2.split("-")
                                    // const Mob2Code = parts2[0]
                                    // const Mob2No = parts2[1]
                                    // // TelePhone No
                                    // var tel = item['Telephone']
                                    // const parts3 = tel.split("-")
                                    // const telCode = parts3[0]
                                    // const telNumber = parts3[1]
                                    // // Telephone 1 Mobile No
                                    // var tel1 = item['Telephone1']
                                    // const parts4 = tel1.split("-")
                                    // const tel1Code = parts4[0]
                                    // const tel1Number = parts4[1]

                                    var needVisaAssistance = item.isVisaAssistance
                                    var IsGroupDelegation = item.IsGroupDelegation
                                    var FileName = ''
                                    if (needVisaAssistance) {
                                        var filePath = item['PassportFilePath'] != null ? item['PassportFilePath'] : ''
                                        var array = item['PassportFilePath'] != null && item['PassportFilePath'] != "" ? filePath.split("/") : []
                                        FileName = array.length > 0 ? array[array.length - 1] : ''
                                    }
                                    this.setState({
                                        preName: item.Title != null ? item.Title : '',
                                        firstName: item.FirstName != null ? item.FirstName : '',
                                        middleName: item['MiddleName'] != null ? item['MiddleName'] : '',
                                        lastName: item['LastName'] != null ? item['LastName'] : '',
                                        designation: item['Designation'] != null ? item['Designation'] : '',
                                        institute: item['Institute_Organisation'] != null ? item['Institute_Organisation'] : '',
                                        preMobNo: item['MobileNo'] ? Mob1Code : "",
                                        mobNo: item['MobileNo'] ? Mob1No : "",
                                        preWhatsAppMobNo: item['WhatsappNo'] ? Mob2Code : "",
                                        whatsAppMobNo: item['WhatsappNo'] ? Mob2No : "",
                                        isSameAsMobNo: item['IsSameAsMobileNo'] != null ? item['IsSameAsMobileNo'] : '',
                                        regState: item['State'] != null ? item['State'] : '',
                                        city: item['City'] != null ? item['City'] : '',
                                        pincode: item['Pincode'] != null ? item['Pincode'] : '',
                                        website: item['Website'] != null ? item['Website'] : '',
                                        email: item['Email'] != null ? item['Email'] : '',
                                        preTelNo: item['Telephone'] != null ? telCode : '',
                                        telNo: item['Telephone'] != null ? telNumber : '',
                                        preTel1No: item['Telephone1'] != null ? tel1Code : '',
                                        tel1No: item['Telephone1'] != null ? tel1Number : '',
                                        AccountID: item['AccountID'] != null && item['AccountID'],
                                        ExhVisitorID: item['ExhVisitorID'] != null && item['ExhVisitorID'],
                                        isCoordinatorVisit: item['isVisit'] != null && item['isVisit'],
                                        isFirst: false,
                                        isInterestTwoCoordinator: item['IsInterestedforb2b'] != null && item['IsInterestedforb2b'] != '' ? item['IsInterestedforb2b'] : false,
                                        isInterstOneCoordinator: item['IsInterestedforSeminar'] != null && item['IsInterestedforSeminar'] != '' ? item['IsInterestedforSeminar'] : false,
                                        countryId: item.CountryID,
                                        educationRoleTypeId: item.EducationRoleTypeID,
                                        AccountID: item.AccountID,
                                        ExhVisitorID: item.ExhVisitorID,
                                        daysList: daysList,
                                        ApplicantEmailIDCoordinator: needVisaAssistance ? item.ApplicantEmailID : '',
                                        ApplicantMobileNoCoordinator: needVisaAssistance ? passMobNoNumber ? `${passMobNoCode}-${passMobNoNumber}` : '' : '',
                                        B2BDepartureDateCoordinator: item.B2BDepartureDate != '' && item.B2BDepartureDate != null && item.B2BDepartureDate != '1900-01-01T00:00:00.000Z' ? new Date(item.B2BDepartureDate) : null,
                                        B2BPreferredTimeCoordinator: item.B2BPreferredTime != '' && item.B2BPreferredTime != null ? (item.B2BPreferredTime) : null,
                                        B2BRemarkCoordinator: item.B2BRemark != '' && item.B2BRemark != null ? (item.B2BRemark) : null,
                                        CarparkingCoordinator: false,
                                        DelegationArrivalDateCoordinator: IsGroupDelegation ? new Date(item.DelegationArrivalDate) : null,
                                        DelegationCountryIDCoordinator: IsGroupDelegation ? item.DelegationCountryID : null,
                                        DelegationDepartureDateCoordinator: IsGroupDelegation ? new Date(item.DelegationDepartureDate) : null,
                                        DelegationNameCoordinator: IsGroupDelegation ? item.DelegationName : '',
                                        DelegationRemarkCoordinator: IsGroupDelegation ? item.DelegationRemark : '',
                                        IsGroupDelegationCoordinator: IsGroupDelegation,
                                        // ExhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
                                        NameOnPassportCoordinator: needVisaAssistance ? item.NameOnPassport : '',
                                        PassportExpiryDateCoordinator: needVisaAssistance ? new Date(item.PassportExpiryDate) : null,
                                        PassportFileCoordinator: needVisaAssistance ? FileName : null,
                                        PassportFileNameCoordinator: needVisaAssistance ? FileName : '',
                                        PassportFilePathCoordinator: needVisaAssistance ? filePath : '',
                                        PassportFileTypeCoordinator: null,
                                        PassportIssueDateCoordinator: needVisaAssistance ? new Date(item.PassportIssueDate) : '',
                                        PassportIssuingCountryIDCoordinator: needVisaAssistance ? item.PassportIssuingCountryID : '',
                                        PassportNoCoordinator: needVisaAssistance ? item.PassportNo : '',
                                        // UserID': null,
                                        areaOfInterestListCoordinator: [],
                                        ParkingChargesCoordinator: 0,
                                        hallChapterListCoordinator: chapterListData2,//
                                        interestSeminarListCoordinator: seminarInterestListData,
                                        isVisaAssistanceCoordinator: needVisaAssistance,
                                        purposeOfVisitListCoordinator: [],
                                        visitorChapterListCoordinator: chapterListData,//
                                        visitorRegNoCoordinator: item.VisitorRegistrationNo,
                                        isVisaAppliedCoordinator: needVisaAssistance,
                                        isPassportFilePresentCoordinator: needVisaAssistance ? true : false
                                    }, () => {
                                        if (item.CountryID == 91) {
                                            this.getFillList(pincodeActionId, '', '', item.CountryID, '', '')
                                            this.getFillList(stateActionId, '', '', item.CountryID, '', '')
                                            this.getFillList(cityActionId, '', '', item.CountryID, '', '')
                                        }
                                        setTimeout(() => {

                                            this.setState({
                                                isOpenDropDownState: false,
                                                focusedIndexState: -1,
                                                isOpenDropDownStateModal: false,
                                                focusedIndexStateModal: -1,

                                                isOpenDropDownCity: false,
                                                focusedIndexCity: -1,
                                                isOpenDropDownCityModal: false,
                                                focusedIndexCityModal: -1,

                                                isOpenDropDownPin: false,
                                                focusedIndexPin: -1,
                                                isOpenDropDownPinModal: false,
                                                focusedIndexPinModal: -1,
                                            })
                                        }, 100);
                                    })
                                } else {
                                    var visitDaysArr = []
                                    var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
                                    // daysList.length > 0 && daysList.map((item2) => {
                                    selectedDaysList.length > 0 && selectedDaysList.map((element) => {
                                        if (element.ExhVisitorID == item.ExhVisitorID) {
                                            // if (element.VisitDate == item2.description) {
                                            var mapdata = {
                                                "visitDay": element.VisitDate
                                            }
                                            visitDaysArr.push(mapdata)
                                            // }
                                        }
                                    })
                                    // })
                                    setTimeout(() => {
                                        console.log(this.state.isInterestTwoCoordinator, this.state.isInterstOneCoordinator)
                                    }, 1000);

                                    var chapterListData = []
                                    var selectedChapter = data.data['chapterList'] != null ? data.data['chapterList'] : []
                                    selectedChapter.map((item2) => {
                                        if (item2.ExhVisitorID == item.ExhVisitorID) {
                                            var mapdata = {
                                                "ChapterID": item2.ChapterID,
                                                "ChapterNames": item2['ChapterName'],
                                                "OtherNames": item2.ChapterID == 16 ? item2.other != undefined ? item2.other : '' : ''
                                            }
                                            chapterListData.push(mapdata)
                                        }
                                    })


                                    // Preparing Udt For Hall Chapter List
                                    // var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
                                    // var filerArray = allArray.filter((mapdata) => mapdata.IsCheckbox && mapdata.IsSelect)
                                    var chapterListData2 = []
                                    var selectedhallChapter = data.data['hallChapterList'] != null ? data.data['hallChapterList'] : []
                                    selectedhallChapter.map((item2) => {
                                        if (item2.MappingExhVisitorID == item.ExhVisitorID) {
                                            var mapdata = {
                                                "ChapterID": item2.MappingChapterID,
                                                "ChapterNames": item2.MappingChapterName,
                                                // "OtherNames": ''
                                            }
                                            chapterListData2.push(mapdata)
                                        }
                                    })
                                    var seminarInterestListData = []
                                    var selectedSeminarList = data.data['seminarInterestList'] != null ? data.data['seminarInterestList'] : []
                                    selectedSeminarList.length > 0 && selectedSeminarList.map((item2) => {
                                        if (item2.ExhVisitorID == item.ExhVisitorID) {
                                            var data = {
                                                "SeminarID": item2.SeminarID,
                                            }
                                            seminarInterestListData.push(data)
                                        }

                                    })

                                    var mob1 = item['MobileNo']
                                    const parts = mob1 != '' ? mob1.split("-") : '';
                                    const Mob1Code = parts.length > 1 && parts != '' ? parts[0] : ''
                                    const Mob1No = parts != '' ? parts.length > 1 ? parts[1] : parts[0] : ''
                                    // WhatsApp Mobile No
                                    var mob2 = item['WhatsappNo']
                                    const parts2 = mob2 != '' ? mob2.split("-") : ''
                                    const Mob2Code = parts2.length > 1 && parts2 != '' ? parts2[0] : ''
                                    const Mob2No = parts2 != '' ? parts2.length > 1 ? parts2[1] : parts2[0] : ''
                                    // TelePhone No
                                    var tel = item['Telephone']
                                    const parts3 = tel != '' ? tel.split("-") : ''
                                    const telCode = parts3.length > 1 && parts3 != '' ? parts3[0] : ''
                                    const telNumber = parts3 != '' ? parts3.length > 1 ? parts3[1] : parts3[0] : ''
                                    // Telephone 1 Mobile No
                                    var tel1 = item['Telephone1']
                                    const parts4 = tel1 != '' ? tel1.split("-") : ''
                                    const tel1Code = parts4.length > 1 && parts4 != '' ? parts4[0] : ''
                                    const tel1Number = parts4 != '' ? parts4.length > 1 ? parts4[1] : parts4[0] : ''

                                    var applicantMob = item['ApplicantMobileNo']
                                    const parts5 = applicantMob != '' ? applicantMob.split("-") : ''
                                    const passMobNoCode = parts5.length > 1 && parts5 != '' ? parts5[0] : ''
                                    const passMobNoNumber = parts5 != '' ? parts5.length > 1 ? parts5[1] : parts5[0] : ''

                                    // var mob1 = item['MobileNo']
                                    // const parts = mob1.split("-");
                                    // const Mob1Code = parts[0]
                                    // const Mob1No = parts[1]
                                    // // WhatsApp Mobile No
                                    // var mob2 = item['WhatsappNo']
                                    // const parts2 = mob2.split("-")
                                    // const Mob2Code = parts2[0]
                                    // const Mob2No = parts2[1]
                                    // // TelePhone No
                                    // var tel = item['Telephone']
                                    // const parts3 = tel.split("-")
                                    // const telCode = parts3[0]
                                    // const telNumber = parts3[1]
                                    // // Telephone 1 Mobile No
                                    // var tel1 = item['Telephone1']
                                    // const parts4 = tel1.split("-")
                                    // const tel1Code = parts4[0]
                                    // const tel1Number = parts4[1]
                                    // var passMobNo = item['ApplicantMobileNo']
                                    // const parts5 = passMobNo.split("-")
                                    // const passMobNoCode = parts5[0]
                                    // const passMobNoNumber = parts5[1]
                                    var needVisaAssistance = item.isVisaAssistance
                                    var IsGroupDelegation = item.IsGroupDelegation
                                    var FileName = ''
                                    if (needVisaAssistance) {
                                        var filePath = item['PassportFilePath'] != null ? item['PassportFilePath'] : ''
                                        var array = item['PassportFilePath'] != null && item['PassportFilePath'] != "" ? filePath.split("/") : []
                                        FileName = array.length > 0 ? array[array.length - 1] : ''
                                    }

                                    var obj = {
                                        'Title': item.Title ? item.Title : '',
                                        'firstName': item.FirstName ? item.FirstName : '',
                                        'middleName': item.MiddleName ? item.MiddleName : '',
                                        'lastName': item.LastName ? item.LastName : '',
                                        'institute': item.Institute_Organisation ? item.Institute_Organisation : '',
                                        'isOtherPreName': '',
                                        'otherName': '',
                                        'designation': item.Designation ? item.Designation : '',
                                        'mobNo': Mob1No ? `${Mob1Code}-${Mob1No}` : '',
                                        'whatsAppMobNo': Mob2No ? `${Mob2Code}-${Mob2No}` : '',
                                        'pincode': item.Pincode ? item.Pincode : '',
                                        'regState': item.State ? item.State : '',
                                        'isSameAsMobNo': item.IsSameAsMobileNo ? item.IsSameAsMobileNo : '',
                                        'city': item.City ? item.City : '',
                                        'website': item.Website ? item.Website : '',
                                        'AccountID': item.AccountID ? item.AccountID : '',
                                        'ExhVisitorID': item.ExhVisitorID ? item.ExhVisitorID : '',
                                        'email': item.Email ? item.Email : '',
                                        'telNo': telNumber ? `${telCode}-${telNumber}` : '',
                                        'tel1No': tel1Number ? `${tel1Code}-${tel1Number}` : '',
                                        'id': i + 1,
                                        'isVisit': true,
                                        'IsInterestedforb2b': item.IsInterestedforb2b != null && item.IsInterestedforb2b != '' ? item.IsInterestedforb2b : false,
                                        'IsInterestedforSeminar': item.IsInterestedforSeminar != null && item.IsInterestedforSeminar != '' ? item.IsInterestedforSeminar : false,
                                        'isCoordinator': false,
                                        'countryId': item.CountryID,
                                        'educationRoleTypeId': item.EducationRoleTypeID,
                                        'AccountID': item.AccountID,
                                        'ExhVisitorID': item.ExhVisitorID,
                                        'DateArr': visitDaysArr,////////////////////////
                                        'ApplicantEmailID': needVisaAssistance ? item.ApplicantEmailID : '',
                                        'ApplicantMobileNo': needVisaAssistance ? passMobNoNumber ? `${passMobNoCode}-${passMobNoNumber}` : '' : '',
                                        'B2BDepartureDate': item.B2BDepartureDate != '' && item.B2BDepartureDate != null && item.B2BDepartureDate != '1900-01-01T00:00:00.000Z' ? new Date(item.B2BDepartureDate) : null,
                                        'B2BPreferredTime': item.B2BPreferredTime != '' && item.B2BPreferredTime != null ? (item.B2BPreferredTime) : null,
                                        'B2BRemark': item.B2BRemark != '' && item.B2BRemark != null ? (item.B2BRemark) : null,
                                        'Carparking': false,
                                        'DelegationArrivalDate': IsGroupDelegation ? new Date(item.DelegationArrivalDate) : null,
                                        'DelegationCountryID': IsGroupDelegation ? item.DelegationCountryID : null,
                                        'DelegationDepartureDate': IsGroupDelegation ? new Date(item.DelegationDepartureDate) : null,
                                        'DelegationName': IsGroupDelegation ? item.DelegationName : '',
                                        'DelegationRemark': IsGroupDelegation ? item.DelegationRemark : '',
                                        'IsGroupDelegation': IsGroupDelegation,
                                        'ExhibitionID': parseInt(sessionStorage.getItem('sessionExhibitionID')),
                                        'NameOnPassport': needVisaAssistance ? item.NameOnPassport : '',
                                        'PassportExpiryDate': needVisaAssistance ? new Date(item.PassportExpiryDate) : null,
                                        'PassportFile': needVisaAssistance ? FileName : null,
                                        'PassportFileName': needVisaAssistance ? FileName : '',
                                        'PassportFilePath': needVisaAssistance ? filePath : '',
                                        'PassportFileType': null,
                                        'PassportIssueDate': needVisaAssistance ? new Date(item.PassportIssueDate) : '',
                                        'PassportIssuingCountryID': needVisaAssistance ? item.PassportIssuingCountryID : '',
                                        'PassportNo': needVisaAssistance ? item.PassportNo : '',
                                        'UserID': null,
                                        'areaOfInterestList': [],
                                        'ParkingCharges': 0,
                                        'hallChapterList': chapterListData2,//
                                        'interestSeminarList': seminarInterestListData,
                                        'isVisaAssistance': needVisaAssistance,
                                        'purposeOfVisitList': [],
                                        'visitorChapterList': chapterListData,//
                                        'visitorRegNo': item.VisitorRegistrationNo,
                                        'isVisaApplied': needVisaAssistance,
                                        'isPassportFilePresent': needVisaAssistance ? true : false
                                    }
                                    this.state.GroupDetailsList.push(obj)
                                }
                            })

                        console.log("DEBUG: registrationDetails count:", data.data['registrationDetails'].length, "Entries:", data.data['registrationDetails'].map((r, i) => ({ index: i, name: r.FirstName, isCoordinator: r.isCoordinator, hasIdCardPath: !!r.IdentityCardPath })));
                        if (data.data['registrationDetails'].length == 1) {
                            var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
                            daysList.length > 0 && daysList.map((item2) => {
                                selectedDaysList.length > 0 && selectedDaysList.map((element) => {
                                    // if (element.ExhVisitorID == item2.ExhVisitorID) {/\
                                    if (element.VisitDate == item2.VisitDate) {
                                        item2.isSelect = true
                                        // }
                                    }
                                })
                            })
                            console.log(daysList, attendeeList, this.state.GroupDetailsList)
                            this.setState({
                                isLoading: false,
                                countryId: data.data['registrationDetails'][0]['CountryID'] != null ? data.data['registrationDetails'][0]['CountryID'] : '',
                                VisitorTypeID: data.data['registrationDetails'].length == 1 ? 1 : 2,
                                daysList: daysList

                            })
                        }
                        const coordinatorFilePath = (() => {
                            if (data.data['registrationDetails'].length == 1) {
                                return this.buildDocUrl(data.data['registrationDetails'][0]['IdentityCardPath']);
                            } else {
                                const coordinator = data.data['registrationDetails'].find(item => item.isCoordinator);
                                const path = coordinator ? this.buildDocUrl(coordinator['IdentityCardPath']) : '';
                                console.log("DEBUG: Loading coordinator file path (group):", { isCoordinator: !!coordinator, rawPath: coordinator?.['IdentityCardPath'], builtPath: path });
                                return path;
                            }
                        })();

                        this.setState({
                            attendeeTypeId: data.data['registrationDetails'][0]['AttendeeTypeID'] != null ? data.data['registrationDetails'][0]['AttendeeTypeID'] : '',
                            attendeeList: attendeeList,
                            educationRoleTypeId: data.data['registrationDetails'][0]['EducationRoleTypeID'] != null ? data.data['registrationDetails'][0]['EducationRoleTypeID'] : '',
                            eduRoleName: data.data['registrationDetails'][0]['EducationRoleTypeName'] != null ? data.data['registrationDetails'][0]['EducationRoleTypeName'] : '',
                            VisitorTypeID: data.data['registrationDetails'].length == 1 ? 1 : 2,
                            identityCardFilePath: coordinatorFilePath,

                        })
                        console.log(data.data['registrationDetails'].length == 1, data.data['registrationDetails'][0]['FirstName'])
                        data.data['registrationDetails'].length == 1 && this.setState({
                            preName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Title'] != null && data.data['registrationDetails'][0]['Title'],
                            firstName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['FirstName'] != null && data.data['registrationDetails'][0]['FirstName'],
                            middleName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['MiddleName'] != null && data.data['registrationDetails'][0]['MiddleName'],
                            lastName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['LastName'] != null && data.data['registrationDetails'][0]['LastName'],
                            designation: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Designation'] != null && data.data['registrationDetails'][0]['Designation'],
                            institute: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Institute_Organisation'] != null && data.data['registrationDetails'][0]['Institute_Organisation'],
                            preMobNo: data.data['registrationDetails'][0]['MobileNo'] && Mob1Code,
                            mobNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['MobileNo'] && Mob1No,
                            preWhatsAppMobNo: data.data['registrationDetails'][0]['WhatsappNo'] && Mob2Code,
                            whatsAppMobNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['WhatsappNo'] && Mob2No,
                            isSameAsMobNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['IsSameAsMobileNo'] != null && data.data['registrationDetails'][0]['IsSameAsMobileNo'],
                            regState: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['State'] != null && data.data['registrationDetails'][0]['State'],
                            city: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['City'] != null && data.data['registrationDetails'][0]['City'],
                            isInvoice: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['isInvoice'] != null && data.data['registrationDetails'][0]['isInvoice'],
                            INVAddress: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVAddress_V'] != null && data.data['registrationDetails'][0]['INVAddress_V'],
                            INVCompanyName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVCompanyName_V'] != null && data.data['registrationDetails'][0]['INVCompanyName_V'],
                            INVPersonName: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVPersonName_V'] != null && data.data['registrationDetails'][0]['INVPersonName_V'],
                            INVTanNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVTanNo'] != null && data.data['registrationDetails'][0]['INVTanNo'],
                            GSTNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['GSTNo'] != null && data.data['registrationDetails'][0]['GSTNo'],
                            PANNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['PanNo'] != null && data.data['registrationDetails'][0]['PanNo'],
                            regStateINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVState_V'] != null && data.data['registrationDetails'][0]['INVState_V'],
                            pincodeINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVPinCode_V'] != null && data.data['registrationDetails'][0]['INVPinCode_V'],
                            cityINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVCity_V'] != null && data.data['registrationDetails'][0]['INVCity_V'],
                            countryIdINV: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['INVCountryID_V'] != null && data.data['registrationDetails'][0]['INVCountryID_V'],
                            pincode: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Pincode'] != null && data.data['registrationDetails'][0]['Pincode'],
                            website: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Website'] != null && data.data['registrationDetails'][0]['Website'],
                            email: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Email'] != null && data.data['registrationDetails'][0]['Email'],
                            preTelNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Telephone'] != null && telCode,
                            telNo: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Telephone'] != null && telNumber,
                            preTel1No: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Telephone1'] != null && tel1Code,
                            tel1No: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['Telephone1'] != null && tel1Number,
                            AccountID: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['AccountID'] != null && data.data['registrationDetails'][0]['AccountID'],
                            ExhVisitorID: data.data['registrationDetails'].length == 1 && data.data['registrationDetails'][0]['ExhVisitorID'] != null && data.data['registrationDetails'][0]['ExhVisitorID'],
                        }, () => {
                            if (data.data['registrationDetails'][0]['CountryID'] == 91) {
                                this.getFillList(pincodeActionId, '', '', data.data['registrationDetails'][0]['CountryID'], '', '')
                                this.getFillList(stateActionId, '', '', data.data['registrationDetails'][0]['CountryID'], '', '')
                                this.getFillList(cityActionId, '', '', data.data['registrationDetails'][0]['CountryID'], '', '')
                            }
                            setTimeout(() => {
                                this.setState({
                                    isOpenDropDownState: false,
                                    focusedIndexState: -1,
                                    isOpenDropDownStateModal: false,
                                    focusedIndexStateModal: -1,

                                    isOpenDropDownCity: false,
                                    focusedIndexCity: -1,
                                    isOpenDropDownCityModal: false,
                                    focusedIndexCityModal: -1,

                                    isOpenDropDownPin: false,
                                    focusedIndexPin: -1,
                                    isOpenDropDownPinModal: false,
                                    focusedIndexPinModal: -1,
                                })
                            }, 100);
                        })
                        if (data.data['registrationDetails'].length == 1) {
                            this.getFillList(pincodeActionId, '', '', data.data['registrationDetails'][0]['INVCountryID_V'], '', '')
                            this.getFillList(stateActionId, '', '', data.data['registrationDetails'][0]['INVCountryID_V'], '', '')
                            this.getFillList(cityActionId, '', '', data.data['registrationDetails'][0]['INVCountryID_V'], '', '')
                        }
                        data.data['registrationDetails'].length > 1 &&
                            data.data['registrationDetails'].map(item3 => {
                                if (item3.isCoordinator) {
                                    this.setState({
                                        isInvoice: item3['isInvoice'] != null && item3['isInvoice'],
                                        INVAddress: item3['INVAddress_V'] != null && item3['INVAddress_V'],
                                        INVCompanyName: item3['INVCompanyName_V'] != null && item3['INVCompanyName_V'],
                                        INVPersonName: item3['INVPersonName_V'] != null && item3['INVPersonName_V'],
                                        INVTanNo: item3['INVTanNo'] != null && item3['INVTanNo'],
                                        GSTNo: item3['GSTNo'] != null && item3['GSTNo'],
                                        PANNo: item3['PanNo'] != null && item3['PanNo'],
                                        regStateINV: item3['INVState_V'] != null && item3['INVState_V'],
                                        pincodeINV: item3['INVPinCode_V'] != null && item3['INVPinCode_V'],
                                        cityINV: item3['INVCity_V'] != null && item3['INVCity_V'],
                                        countryIdINV: item3['INVCountryID_V'] != null && item3['INVCountryID_V'],
                                    }, () => {
                                        this.getFillList(pincodeActionId, '', '', item3['INVCountryID_V'], '', '')
                                        this.getFillList(stateActionId, '', '', item3['INVCountryID_V'], '', '')
                                        this.getFillList(cityActionId, '', '', item3['INVCountryID_V'], '', '')
                                    })
                                }

                            })
                        this.setState({ isLoading: false })
                        console.log(this.state.GroupDetailsList, data.data['registrationDetails'][0], '0.0.0.0.0.0.0.0.0.0.0.0.0.0.0')
                    } else {
                        toastError(data.msg)
                        this.setState({ isLoading: false })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            setTimeout(() => {
            }, 500);
        }, 400);
    }
    // // On File Pick
    // onFilePick = async (e, file, key) => {
    //     e.preventDefault()
    //     console.log("File01010101------", file, key)
    //     const { } = this.state
    //     if (file[0]['size'] >= 5 * 1024 * 1024) {
    //         toastError('File size more than 5mb are not allow.')
    //     } else {
    //         var image = '';
    //         if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
    //             file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
    //             file[0]['name'].toString().toLowerCase().includes('.png') ||
    //             file[0]['name'].toString().toLowerCase().includes('.jpg')
    //         ) {

    //             if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
    //                 file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
    //                 file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
    //             ) {
    //                 image = await this.resizeFile(file[0]);
    //                 if (key == 1) {
    //                     this.setState({ photoFile: image })
    //                 } else if (key == 2) {
    //                     this.setState({ photoIdFile: image })
    //                 } else if (key == 3) {
    //                     this.setState({ vaccineCertificateFile: image })
    //                 }
    //             }
    //             else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
    //                 image = await this.onPdfSelect(file[0]);
    //                 if (key == 1) {
    //                     this.setState({ photoFile: image })
    //                 } else if (key == 2) {
    //                     this.setState({ photoIdFile: image })
    //                 } else if (key == 3) {
    //                     this.setState({ vaccineCertificateFile: image })
    //                 }
    //             }

    //             var fileType = file[0]['type']
    //             var fileTypeList;
    //             if (fileType.includes("/")) {
    //                 fileTypeList = fileType.split("/")
    //             }
    //             if (key == 1) {
    //                 this.setState({ photoFileType: image })
    //             } else if (key == 2) {
    //                 this.setState({ photoIdFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
    //             } else if (key == 3) {
    //                 this.setState({ vaccineCertificateFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
    //             }
    //         } else {
    //             toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
    //         }
    //     }
    // }

    // // If Pdf is selected in file
    // onPdfSelect = (file) =>
    //     new Promise((resolve) => {
    //         let base64;
    //         // FileReader function for read the file.
    //         let fileReader = new FileReader();
    //         // Onload of file read the file content
    //         fileReader.onload = function (fileLoadedEvent) {
    //             base64 = fileLoadedEvent.target.result;
    //             // Print data in console
    //             resolve(base64);
    //         };
    //         // Convert data to base64
    //         fileReader.readAsDataURL(file);
    //     });

    // // File resize
    // resizeFile = (file) =>
    //     new Promise((resolve) => {
    //         Resizer.imageFileResizer(
    //             file,
    //             500,
    //             600,
    //             'JPEG',
    //             80,
    //             0,
    //             (uri) => {
    //                 resolve(uri);
    //             },
    //             "base64",
    //             300,
    //             300,
    //         );
    //     });

    // // on Cross click
    // onCrossClick(key) {

    //     if (key == 1) {
    //         this.setState({ photoFile: "" })
    //         document.getElementById("photoFile").value = ""
    //     } else if (key == 2) {
    //         this.setState({ photoIdFile: "" })
    //         document.getElementById("photoIdFile").value = ""
    //     } else if (key == 3) {
    //         this.setState({ vaccineCertificateFile: "" })
    //         document.getElementById("vaccFile").value = ""
    //     }
    // }

    renderPassCountryList(id) {
        const { tempPassCountryList, } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPassCountryList.length > 0 && tempPassCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => sessionStorage.getItem('VisitorTypeID') == 2 ? this.onVisitorCountryselect(id, data.Description, data.Code) : this.setState({
                                passCountry: data.Description, passCountryId: data.Code,
                                isDisplayPassCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // On PassPort Country Search
    onPassportCountrySearch(e, id) {
        const { passCountryList, tempPassCountryList, visitorGroupList } = this.state
        // this.setState({ passCountry: '' })
        if (e.target.value != '') {
            console.log("tempPassCountryList ++++----------->", tempPassCountryList)

            var searchCoutryList = tempPassCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)
            // sessionStorage.getItem('VisitorTypeID') == 1 && 
            this.setState({
                passCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                passCountryErr: '',
                tempPassCountryList: searchCoutryList,
                isDisplayPassCountryList: true
            })
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            //     console.log("searchCoutryList ++++----------->", e.target.value)
            //     visitorGroupList[id].isDisplayPassCountryList = true
            //     visitorGroupList[id].passCountryErr = ''
            //     visitorGroupList[id].passCountry = e.target.value
            //     this.setState({ visitorGroupList: visitorGroupList, tempPassCountryList: searchCoutryList, })
            // }
        }
        else {
            // sessionStorage.getItem('VisitorTypeID') == 1 && 
            this.setState({
                passCountry: e.target.value,
                tempPassCountryList: passCountryList,
                isDisplayPassCountryList: false
            })
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            //     visitorGroupList[id].isDisplayPassCountryList = false
            //     visitorGroupList[id].passCountry = e.target.value
            //     this.setState({ visitorGroupList: visitorGroupList, tempPassCountryList: passCountryList, })
            // }
        }
    }

    // On File Pick
    onFilePick = async (e, file, key, i) => {
        e.preventDefault()
        const { visitorGroupList } = this.state
        console.log("File01010101------", file, key)
        const { } = this.state
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    passportFile: '',
                    passPortFileName: '',
                    passportFileType: '',
                    passportFilePath: '',
                })
                document.getElementById("passportFile").value = ""
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        if (key == 1) {
                            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                            //     visitorGroupList[i].passportFile = image
                            //     visitorGroupList[i].passportFileErr = ''
                            //     this.setState({ visitorGroupList: visitorGroupList })
                            // } else {
                            this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                            // }
                        } else if (key == 2) {
                            this.setState({ visitorLetterFile: image })
                        }
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        if (key == 1) {
                            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                            //     visitorGroupList[i].passportFile = image
                            //     this.setState({ visitorGroupList: visitorGroupList })
                            // } else {
                            this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                            // }
                            // this.setState({ passportFile: image, passportFileErr: "" })
                        } else if (key == 2) {
                            this.setState({ visitorLetterFile: image })
                        }
                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    if (key == 1) {
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                        //     this.setState({ visitorGroupList: visitorGroupList })
                        // } else {
                        this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                        // }
                    } else if (key == 2) {
                        this.setState({ visitorLetterFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    this.setState({
                        passportFile: '',
                        passPortFileName: '',
                        passportFileType: '',
                        passportFilePath: '',
                    })
                    document.getElementById("passportFile").value = ""

                    // if (key == 1) {
                    //     this.setState({ passportFile: "" })
                    //     document.getElementById("passportFile").value = ""
                    // } else if (key == 2) {
                    //     this.setState({ visitorLetterFile: "" })
                    //     document.getElementById("visitorLetter").value = ""
                    // }
                }
            }
        }
        else {
            this.setState({
                passportFile: '',
                passPortFileName: '',
                passportFileType: '',
                passportFilePath: '',
            })
            document.getElementById("passportFile").value = ""
        }
    }

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    // Identity card resize at 60% quality
    resizeIdentityCard = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                60,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    // Builds a single, clean absolute URL for a stored document path. The API may return this as an
    // array (often with duplicate entries) or as a comma-joined/base-URL-prefixed string; normalize all
    // of those to one relative path with exactly one base URL prepended.
    buildDocUrl = (path) => {
        if (path == null) return ''
        const rel = (Array.isArray(path) ? path : path.toString().split(','))
            .map(p => (p == null ? '' : p.toString().split(DOC_BASE_URL).pop().trim())) // drop any base URL(s) baked into each segment
            .filter(p => p != '')[0] || ''                                              // take the first non-empty path (duplicates are identical)
        return rel ? `${DOC_BASE_URL}${rel}` : ''
    }

    onIdentityCardFilePick = async (e, mode) => {
        const file = e.target.files
        if (file.length > 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                return
            }
            const name = file[0]['name'].toString().toLowerCase()
            if (name.includes('.pdf') || name.includes('.jpeg') || name.includes('.png') || name.includes('.jpg')) {
                let result
                let fileType
                if (name.includes('.pdf')) {
                    result = await this.onPdfSelect(file[0])
                    fileType = 'pdf'
                } else {
                    result = await this.resizeIdentityCard(file[0])
                    fileType = 'image'
                }
                if (mode == 1) {
                    // A new file is picked to replace the existing one, so clear the previous saved path — only the updated file should be sent.
                    console.log("DEBUG: File picked in modal mode:", { name: file[0]['name'], fileType, resultLength: result ? result.length : 0 })
                    this.setState({ identityCardFileModal: result, identityCardFileTypeModal: fileType, identityCardFileNameModal: file[0]['name'], identityCardFileErrModal: '', identityCardFilePathModal: '' })
                } else {
                    // A new file is picked to replace the existing one, so clear the previous saved path — only the updated file should be sent.
                    this.setState({ identityCardFile: result, identityCardFileType: fileType, identityCardFileName: file[0]['name'], identityCardFileErr: '', identityCardFilePath: '' })
                }
            } else {
                toastError('Only jpg, jpeg, png and pdf files are allowed.')
            }
        }
    }

    // on Cross click
    onCrossClick(key, mode) {
        const { passportFileType, isPassportFilePresent, passportFile, visitorGroupList } = this.state
        // i = i - 1
        // console.log(isPassportFilePresent, i + 1)
        // if (sessionStorage.getItem('VisitorTypeID') == 1) {
        console.log('isPassportFilePresent', isPassportFilePresent)
        if (isPassportFilePresent) {
            const { isOpen3 } = this.state
            this.setState({ isOpen3: !isOpen3 })
            console.log("condition------------1111111111")
        } else {
            console.log("condition------------2222222222")
            if (key == 1) {
                if (mode == 1) {
                    this.setState({ passportFile: "", isVisaApplied: false })
                } else {
                    this.setState({ passportFile: "", isVisaApplied: false })
                    document.getElementById("passportFile").value = ""
                }
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        }
        // }
        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
        //     if (isPassportFilePresent) {
        //         const { isOpen3 } = this.state
        //         this.setState({ isOpen3: !isOpen3, docDelAccountID: visitorGroupList[i].AccountID, docDelExhVisitorID: visitorGroupList[i].ExhVisitorID })
        //         console.log("condition------------1111111111")
        //     } else {
        //         console.log("condition------------2222222222")
        //         if (key == 1) {
        //             if (sessionStorage.getItem('VisitorTypeID') == 2) {
        //                 console.log(i + 1)
        //                 visitorGroupList[i].passportFile = ''
        //                 this.setState({ visitorGroupList: visitorGroupList })
        //                 document.getElementById(`path${i}`).value = ""
        //             } else {
        //                 this.setState({ passportFile: "" })
        //                 document.getElementById("passportFile").value = ""
        //             }
        //         } else if (key == 2) {
        //             this.setState({ visitorLetterFile: "" })
        //             document.getElementById("visitorLetter").value = ""
        //         }
        //     }
        // }
    }

    //On Country Search In Personal Information
    onPersonalCountrySearch(e) {
        const { personalCountryList, tempPersonalCountryList } = this.state
        this.setState({ personalCountry: '' })
        if (e.target.value != '') {
            console.log("tempPersonalCountryList ++++----------->", tempPersonalCountryList)

            var searchCoutryList = tempPersonalCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                personalCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                personalCountryErr: '',
                tempPersonalCountryList: searchCoutryList,
                isDisplayPersonalCountryList: true
            })
        }
        else {

            this.setState({
                personalCountry: e.target.value,
                tempPersonalCountryList: personalCountryList,
                isDisplayPersonalCountryList: false
            })
        }
    }

    // Render Country List in Personal Information
    renderPersonalCountryList() {
        const { tempPersonalCountryList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPersonalCountryList.length > 0 && tempPersonalCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                personalCountry: data.Description, personalCountryId: data.Code,
                                isDisplayPersonalCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // On Select Attendee 
    onAttendeeSelect(e) {
        const { attendeeList, eduRoleName, GroupDetailsList, educationRoleTypeId, educationRoleTypeIdModal, educationRoleTypeList } = this.state
        var checked = e.target.checked
        var id = e.target.value
        attendeeList.length > 0 && attendeeList.map((data) => {
            if (checked) {
                if (id == data.AttendeeTypeID) {
                    data.isChecked = true
                    this.setState({ attendeeTypeId: data.AttendeeTypeID, attendeeTypeErr: "" })
                    if (id == 3) {
                        if (educationRoleTypeId != '') {
                            educationRoleTypeList.length > 0 && educationRoleTypeList.map((elem) => {
                                if (educationRoleTypeId == elem.EducationRoleTypeID) {
                                    this.setState({ designation: elem.EducationRoleTypeName })
                                }
                            })
                        } else {
                            this.setState({ designation: '' })
                        }
                        if (GroupDetailsList.length > 0) {
                            GroupDetailsList.map((item) => {
                                if (item.educationRoleTypeId != '') {
                                    educationRoleTypeList.length > 0 && educationRoleTypeList.map((elem) => {
                                        if (item.educationRoleTypeId == elem.EducationRoleTypeID) {
                                            item.designation = elem.EducationRoleTypeName
                                            this.setState({ designation: elem.EducationRoleTypeName })
                                        }
                                    })
                                }
                                else {
                                    item.designation = ''
                                }
                            })
                            this.setState({ GroupDetailsList: GroupDetailsList })
                        }
                    }
                } else {
                    data.isChecked = false
                }
            } else {
                data.isChecked = false
            }
        })
        console.log("attendeeList------->", attendeeList)
        this.setState({ attendeeList: attendeeList, educationRoleTypeIdErr: "", educationRoleTypeIdErrModal: "" })
    }

    // On Select Attendee 
    onEduRoleSelect(e, mode) {
        const { educationRoleTypeList, designation, educationRoleTypeId } = this.state
        var id = e.target.value
        // var id = e.target.value
        // console.log(educationRoleTypeList, e.target)

        educationRoleTypeList.length > 0 && educationRoleTypeList.map((data) => {
            if (id == data.EducationRoleTypeID) {
                if (id == 5) {
                    if (mode == 1) {
                        this.setState({ designationModal: '', eduRoleNameModal: data.EducationRoleTypeName })
                    } else {
                        this.setState({ designation: '', eduRoleName: data.EducationRoleTypeName })
                    }
                } else {
                    if (mode == 1) {
                        this.setState({ designationModal: data.EducationRoleTypeName, designationErrModal: '', eduRoleNameModal: data.EducationRoleTypeName })
                    } else {
                        this.setState({ designation: data.EducationRoleTypeName, designationErr: '', eduRoleName: data.EducationRoleTypeName })
                    }
                }
            }
        })
        if (mode == 1) {
            this.setState({ educationRoleTypeIdModal: id, educationRoleTypeIdErrModal: "" })
        } else {
            this.setState({ educationRoleTypeId: id, educationRoleTypeIdErr: "" })
        }
        // console.log("attendeeList------->", educationRoleTypeList)
        // this.setState({ educationRoleTypeList: educationRoleTypeList, designation: '' })
    }

    // Email Verify after Input
    verifyEmail(e, status) {
        const { GroupDetailsList, isModalEdit, ExhVisitorID, ExhVisitorIDModal, modalID } = this.state
        var value = e.target.value
        // 'Coordinator'
        console.log(isModalEdit, modalID, GroupDetailsList, status)
        var ListofEmailsArr = []
        if (this.state.email != '' && this.state.email != null) {
            ListofEmailsArr.push()
        }
        if (value != "") {
            var sameEmail = false
            if (GroupDetailsList.length > 0) {
                console.log(0)
                if (status == 1) {
                    if (!isModalEdit) {
                        for (var i = 0; i < GroupDetailsList.length; i++) {
                            if (GroupDetailsList[i].email == value) {
                                sameEmail = true
                                break
                            }
                        }
                        if (this.state.email == value) {
                            sameEmail = true
                        }
                    } else {
                        console.log(1, modalID)
                        // if (modalID != 'Coordinator') {
                        console.log(2)
                        for (var i = 0; i < GroupDetailsList.length; i++) {
                            console.log(3)
                            if (modalID != i) {
                                console.log(4)
                                if (GroupDetailsList[i].email == value) {
                                    sameEmail = true
                                    break
                                }
                            }
                        }
                        // }
                    }
                } else {
                    for (var i = 0; i < GroupDetailsList.length; i++) {
                        if (GroupDetailsList[i].email == value) {
                            sameEmail = true
                            break
                        }
                    }
                }
            }
            if (status == 1) {
                if (GroupDetailsList.length == 0) {
                    if (!isModalEdit) {
                        if (this.state.email == value) {
                            sameEmail = true
                        }
                    }
                }
                if (this.state.email == value && modalID != 'Coordinator') {
                    sameEmail = true
                }
            }
            if (!sameEmail) {
                var emailError = emailValidator(value)
                if (emailError != '') {
                    status == 1 ? this.setState({ emailErrModal: emailError }) : this.setState({ emailErr: emailError })
                    return
                } else {
                    this.setState({ isLoading: true })
                    this.props.verifyVisitorEmail_action(value, status == 1 ? ExhVisitorIDModal : ExhVisitorID)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isLoading: false })
                                if (data.data['ErrMsg'] != "" && data.data['ErrMsg'] != null) {
                                    status == 1 ? this.setState({ emailErrModal: data.data['ErrMsg'] }) : this.setState({ emailErr: data.data['ErrMsg'] })
                                } else {
                                    status == 1 ? this.setState({ emailErrModal: '' }) : this.setState({ emailErr: "" })
                                }
                            } else {
                                this.setState({ isLoading: false })
                                status == 1 ? this.setState({ emailErrModal: '' }) : this.setState({ emailErr: "" })
                            }

                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            }
            else {
                status == 1 ? this.setState({ emailErrModal: "Please enter different Email" }) : this.setState({ emailErr: "Please enter different Email" })
            }


        } else {
            status == 1 ? this.setState({ emailErrModal: "Please enter Email" }) : this.setState({ emailErr: "Please enter Email" })
        }
    }

    onPreviousClick(e) {
        e.preventDefault();
        const win = window.location.replace('https://corporate.india-itme.com/', '_blank');
        if (win != null) {
            win.focus();
        }
    }

    inputValidateIndustrySegment() {
        const { passName, applicantMobNo, applicantEmail, passNo, passDate, passExipryDate, passCountryId, needVisaAssistance,
            passportFile, level1, delegationCountry, visitPurposeList, isGrpDelegation, leader, delegationCountryId, arrivalDate, departureDate,
            delegationRemark, chapterList, isInterestTwo, prefTime, visitorGroupList, preffDate, b2bRemark, primaryChapterListData, level2, level3, level4 } = this.state

        if (!(chapterList.some(obj => obj.IsSelect == true))) {
            this.setState({ chapterErr: "Please Select Industry Segment" })
        }
        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)
        if (!(filerArray.some(obj => obj.IsSelect == true))) {
            this.setState({ ChapterHallErr: "Please Select Product" })
        }
        if (isGrpDelegation) {
            if (leader == "") {
                this.setState({ leaderErr: "Please enter Leader/Organisation" });
            }
            if (delegationCountry == "") {
                this.setState({ delegationCountryErr: "Please enter Country" });
            }
            if (arrivalDate == "") {
                this.setState({ arrivalDateErr: "Please enter Arrival Date" });
            }
            if (departureDate == "") {
                this.setState({ departureDateErr: "Please enter Departure Date" });
            }
            if (delegationRemark == "") {
                this.setState({ delegationRemarkErr: "Please enter Delegation Remark" });
            }
        }
        else {
            this.setState({
                leaderErr: "",
                delegationCountryErr: "",
                arrivalDateErr: "",
                departureDateErr: "",
                delegationRemarkErr: "",
            })
        }
        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
            }
            if (applicantMobNo == "") {
                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email " });
            }

            if (passNo == "") {
                this.setState({ passNoErr: "Please enter Passport No " });
            }
            if (passDate == "") {
                this.setState({ passDateErr: "Please enter Passport Date " });
            }
            if (passExipryDate == "") {
                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
            }
            if (passCountryId == "") {
                this.setState({ passCountryErr: "Please Select Country " });
            }
            if (passportFile == "") {
                this.setState({ passportFileErr: "Please Upload File " });
            }
            if (applicantEmail != "") {
                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {
                    this.setState({ applicantEmailErr: emailError })
                    return
                }
            }

        }
        else {
            this.setState({
                passNameErr: "",
                applicantMobNoErr: "",
                applicantEmailErr: "",
                passNoErr: "",
                passDateErr: "",
                passExipryDateErr: "",
                passCountryErr: "",
                passportFileErr: ""
            })
        }

    }

    cancelModal() {
        const { chapterList, daysModalList, modalID, interestListModal, primaryChapterListData, seminarInterestListModal, applicantMobNo, level0, level2, level3, level4 } = this.state
        primaryChapterListData.length > 0 && primaryChapterListData.map(item => {
            // item.IsCheckbox = false
            item.IsSelect = false
        })
        level0.length > 0 && level0.map(item => {
            // item.IsCheckbox = false
            item.IsSelect = false
        })
        level2.length > 0 && level2.map(item => {
            // item.IsCheckbox = false
            item.IsSelect = false
        })
        level3.length > 0 && level3.map(item => {
            // item.IsCheckbox = false
            item.IsSelect = false
        })
        level4.length > 0 && level4.map(item => {
            // item.IsCheckbox = false
            item.IsSelect = false
        })
        chapterList.length > 0 && chapterList.map(item => {
            // item.IsCheckbox = false
            item.IsSelect = false
        })
        daysModalList.length > 0 && daysModalList.map(item => {
            // item.IsCheckbox = false
            item.isSelect = false
        })
        seminarInterestListModal.length > 0 && seminarInterestListModal.map(item => {
            // item.IsCheckbox = false
            item.isSelect = false
        })
        interestListModal.length > 0 && interestListModal.map((data) => {
            data.isSelect = false
        })
        // var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        this.setState({
            isOtherPreNameModal: false, otherNameModal: '', emailErrModal: '', firstNameModal: '', firstNameErrModal: '', prenameModal: 'Mr', middleNameModal: '', lastNameModal: '', lastNameErrModal: '', designationModal: '', designationErrModal: '', instituteModal: '', instituteErrModal: '', mobNoModal: '', mobNoErrModal: '', preMobNoModal: '', whatsAppMobNoModal: '', whatsAppMobNoErrModal: '', countryIdErrModal: '', preWhatsAppMobNoModal: '', isSameAsMobNoModal: false, pincodeModal: '', pincodeErrModal: '', regStateModal: '', regStateErrModal: '', cityModal: '', cityErrModal: '', websiteModal: '', emailModal: '', telNoModal: '', preTelNoModal: '', tel1NoModal: '', preTel1NoModal: '', isOpen: false, countryIdModal: '', applicantEmail: '',
            applicantMobNo: '', preApplicantMobNo: '', passCountryErr: '', passNameErr: '', passNoErr: '', passportFileErr: '', educationRoleTypeIdModal: '', educationRoleTypeIdErrModal: '', arrivalDate: '', delegationCountry: '', departureDate: '', leader: '', delegationRemark: '', isGrpDelegation: false, passName: '', passExipryDate: '', passportFilePath: '', passportFileType: '', passDate: '', passCountry: '', passNo: '', needVisaAssistance: false, primaryChapterListData: primaryChapterListData, level0: level0, level2: level2, level3: level3, level4: level4, chapterList: chapterList, seminarInterestListModal: seminarInterestListModal, preffDateModal: '', prefTimeModal: '', b2bRemarkModal: '', isInterestTwo: false, isInterstOne: false, interestListModal: interestListModal,
            //  daysModalList: daysModalList,
            tempObj: {}, modalStep2: false, passportFile: '', passportFileType: '', passPortFileName: '', isVisaApplied: false, isPassportFilePresent: false,

            isOpenDropDownState: false,
            focusedIndexState: -1,
            isOpenDropDownStateModal: false,
            focusedIndexStateModal: -1,

            isOpenDropDownCity: false,
            focusedIndexCity: -1,
            isOpenDropDownCityModal: false,
            focusedIndexCityModal: -1,

            isOpenDropDownPin: false,
            focusedIndexPin: -1,
            isOpenDropDownPinModal: false,
            focusedIndexPinModal: -1,
        })
        this.setState({ activeModalStep: 1, modalID: '' })

    }

    handleAddGroupDetail(status) {
        const { GroupDetailsList, isOtherPreNameModal, pricingList, otherNameModal, emailErrModal, firstNameModal, firstNameErrModal, prenameModal, middleNameModal, lastNameModal, lastNameErrModal, designationModal, designationErrModal, other, otherName, instituteModal, instituteErrModal, mobNoModal, mobNoErrModal, preMobNoModal, whatsAppMobNoModal, whatsAppMobNoErrModal, preWhatsAppMobNoModal, isSameAsMobNoModal, pincodeModal, pincodeErrModal, regStateModal, modalID, regStateErrModal, cityModal, cityErrModal, websiteModal, daysModalList, isInterestTwo, isInterstOne, emailModal, telNoModal, level2, level0, level3, level4, primaryChapterListData, chapterErr, chapterList, ChapterHallErr, isGrpDelegation, leader, leaderErr, delegationCountry, isDisplayDelegationCountryList, delegationCountryErr, arrivalDate, departureDate, arrivalDateErr, departureDateErr, delegationRemarkErr, delegationRemark, passCountry, passCountryErr, passCountryList, passDate, passDateErr, passExipryDate, passExipryDateErr, passName, passNameErr, passNo, passNoErr, passPortFileName, passportFile, passportFileErr, passportFilePath, passportFileType, isCoordinatorVisit, isDisplayPassCountryList, isFirst, isModalEdit, isOpen2, isOtherOpen, isPassportFilePresent, isVisaApplied, needVisaAssistance, AccountID, activeModalStep, applicantEmail, applicantEmailErr, applicantMobNo, applicantMobNoErr, preApplicantMobNo, primaryChapterListLevel3, primaryChapterListLevel4, educationRoleTypeId, attendeeTypeId, daysModalErr, preTelNoModal, tel1NoModal, preTel1NoModal, countryId, countryIdModal, seminarInterestListModal, educationRoleTypeIdModal, tempObj, email } = this.state
        console.log("status-->", status)
        console.log("GroupDetailsList-->", GroupDetailsList, isModalEdit, this.state.modalStep2)
        if (status == 1) {
            this.inputValidateGroup()
            var emailErr = false
            // !isModalEdit && !this.state.modalStep2 && GroupDetailsList.length > 0 && GroupDetailsList.map(item => {
            //     if (item.email == emailModal) {
            //         toastError("Please enter different email")
            //         emailErr = true
            //     }
            // })
            // if (email == emailModal) {
            //     emailErr = true
            // }
            var daysListValidation = false
            for (var i = 0; i < this.state.daysModalList.length; i++) {
                if (this.state.daysModalList[i].isSelect == true) {
                    daysListValidation = true
                }
            }
            // preparing Selected Days for udt
            var selectedDays = []
            // selectedDays = daysList.filter(data => data.isSelect == true)
            selectedDays = daysModalList.filter(data => data.isSelect == true)
            var list = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                list.push(data)
            })
            console.log(GroupDetailsList, "lplp", firstNameModal, instituteModal, lastNameModal, mobNoModal, whatsAppMobNoModal, pincodeModal, regStateModal, cityModal, designationModal, emailModal, list)
            var modalErr = true
            var errtoShow = ''
            setTimeout(() => {
                if (attendeeTypeId == 3) {
                    if (educationRoleTypeIdModal == '') {
                        this.setState({ educationRoleTypeIdErrModal: "Please Select Education Role Type" });
                    }
                }
                if (list.length == 0) {
                    this.setState({ daysModalErr: "Please select visit days" });
                    modalErr = false
                } else {
                    var toreturn = true
                    var visitDaysNoArr = []

                    if (pricingList.length != 0) {
                        console.log(daysModalList, list)
                        for (var i = 0; i < pricingList.length; i++) {
                            visitDaysNoArr.push(pricingList[i].VisitDays)
                            if (pricingList[i].VisitDays == list.length) {
                                toreturn = false
                                break
                            }
                        }
                        if (toreturn) {
                            errtoShow = `Visit pass only allowed for ${visitDaysNoArr.toString()} days`
                            modalErr = false
                        }
                    } else {

                    }
                }
                if (firstNameModal == "") {
                    this.setState({ firstNameErrModal: "Please enter first name" });
                    modalErr = false
                }
                if (lastNameModal == "") {
                    this.setState({ lastNameErrModal: "Please enter last name" });
                    modalErr = false
                }
                if (designationModal == "") {
                    this.setState({ designationErrModal: "Please enter designation" });
                    modalErr = false
                }
                if (instituteModal == "") {
                    this.setState({ instituteErrModal: "Please enter institue/Organization" });
                    modalErr = false
                }
                if (preMobNoModal == "") {
                    this.setState({ mobNoErrModal: "Please enter pre mobile no" });
                    modalErr = false
                }
                if (mobNoModal == "") {
                    this.setState({ mobNoErrModal: "Please enter mobile no" });
                    modalErr = false
                }
                if (preWhatsAppMobNoModal == "") {
                    this.setState({ whatsAppMobNoErrModal: "Please enter pre whatsapp no" });
                    modalErr = false
                }
                if (whatsAppMobNoModal == "") {
                    this.setState({ whatsAppMobNoErrModal: "Please enter whatsapp no" });
                    modalErr = false
                }
                if (countryIdModal == "") {
                    this.setState({ countryIdErrModal: "Please select Country" });
                    modalErr = false
                }
                // if (photoFile == "") {
                //     this.setState({ photoFileErr: "Please upload photo" });
                // }
                // if (photoIdFile == "") {
                //     this.setState({ photoIdFileErr: "Please upload photo ID" });
                // }
                if (regStateModal == "" && countryIdModal == "91") {
                    this.setState({ regStateErrModal: "Please enter province/state" });
                    modalErr = false
                }
                if (cityModal == "") {
                    this.setState({ cityErrModal: "Please enter city" });
                    modalErr = false
                }
                if (pincodeModal == "") {
                    this.setState({ pincodeErrModal: "Please enter Pincode" });
                    modalErr = false
                }
                if (emailModal == "") {
                    this.setState({ emailErrModal: "Please enter Email" });
                    modalErr = false
                }
                if (emailModal != "") {
                    var emailError = emailValidator(emailModal)
                    if (emailError != '') {
                        this.setState({ emailErrModal: emailError })
                        modalErr = false
                        // return
                    }
                }
                if (modalErr && !emailErrModal) {
                    var emailError = emailValidator(emailModal)
                    if (emailError != '') {
                        return
                    } else {
                        if (!emailErr) {
                            if (!this.state.isModalEdit && !this.state.modalStep2) {
                                var obj = {
                                    'Title': isOtherPreNameModal ? otherNameModal : prenameModal,
                                    'firstName': firstNameModal,
                                    'middleName': middleNameModal,
                                    'lastName': lastNameModal,
                                    'institute': instituteModal,
                                    'isOtherPreName': isOtherPreNameModal,
                                    'otherName': otherNameModal,
                                    'designation': designationModal,
                                    'mobNo': preMobNoModal != '' && preMobNoModal != null ? `${preMobNoModal}-${mobNoModal}` : mobNoModal,
                                    'whatsAppMobNo': preWhatsAppMobNoModal != '' && preWhatsAppMobNoModal != null ? `${preWhatsAppMobNoModal}-${whatsAppMobNoModal}` : whatsAppMobNoModal,
                                    'pincode': pincodeModal,
                                    'countryId': countryIdModal,
                                    'educationRoleTypeId': educationRoleTypeIdModal,
                                    'regState': regStateModal,
                                    'isSameAsMobNo': isSameAsMobNoModal,
                                    'city': cityModal,
                                    'website': websiteModal,
                                    'AccountID': null,
                                    'ExhVisitorID': null,
                                    'email': emailModal,
                                    'telNo': preTelNoModal != '' && preTelNoModal != null ? `${preTelNoModal}-${telNoModal}` : telNoModal,
                                    'tel1No': preTel1NoModal != '' && preTel1NoModal != null ? `${preTel1NoModal}-${tel1NoModal}` : tel1NoModal,
                                    'id': GroupDetailsList.length + 1,
                                    'isCoordinator': false,
                                    'isVisit': true,
                                    'DateArr': list,

                                }
                                // GroupDetailsList.push(obj)
                                this.setState({ activeModalStep: 2, modalStep2: true, tempObj: obj, preApplicantMobNo: preMobNoModal, applicantMobNo: mobNoModal, applicantEmail: emailModal, leader: this.state.DelegationNameCoordinator, delegationRemark: this.state.DelegationRemarkCoordinator, departureDate: this.state.DelegationDepartureDateCoordinator, arrivalDate: this.state.DelegationArrivalDateCoordinator, delegationCountry: this.state.DelegationCountryIDCoordinator })
                                // this.setState({
                                //     isOtherPreNameModal: false, otherNameModal: '', emailErrModal: '', firstNameModal: '', firstNameErrModal: '', prenameModal: '', middleNameModal: '', lastNameModal: '', lastNameErrModal: '', designationModal: '', designationErrModal: '', instituteModal: '', instituteErrModal: '', mobNoModal: '', mobNoErrModal: '', preMobNoModal: '', whatsAppMobNoModal: '', whatsAppMobNoErrModal: '', preWhatsAppMobNoModal: '', isSameAsMobNoModal: false, pincodeModal: '', pincodeErrModal: '', regStateModal: '', regStateErrModal: '', cityModal: '', cityErrModal: '', websiteModal: '', emailModal: '', telNoModal: '', preTelNoModal: '', tel1NoModal: '', preTel1NoModal: '', isOpen: false
                                // })
                                // setTimeout(() => {
                                //     toastSuccess("visitor added successfully")
                                // }, 200);


                            } else {
                                if (this.state.modalID == 'Coordinator') {
                                    this.setState({
                                        preName: isOtherPreNameModal ? otherNameModal : prenameModal,
                                        firstName: firstNameModal,
                                        middleName: middleNameModal,
                                        lastName: lastNameModal,
                                        institute: instituteModal,
                                        isOtherPreName: isOtherPreNameModal,
                                        otherName: otherNameModal,
                                        designation: designationModal,
                                        mobNo: mobNoModal,
                                        whatsAppMobNo: whatsAppMobNoModal,
                                        pincode: pincodeModal,
                                        regState: regStateModal,
                                        countryId: countryIdModal,
                                        educationRoleTypeId: educationRoleTypeIdModal,
                                        isSameAsMobNo: isSameAsMobNoModal,
                                        city: cityModal,
                                        website: websiteModal,
                                        email: emailModal,
                                        telNo: telNoModal,
                                        tel1No: tel1NoModal,
                                        DateArrCoordinator: list
                                    })
                                    this.state.daysList.map(element => {
                                        element.isSelect = false
                                    })
                                    console.log('....', this.state.daysList, list)
                                    for (var i = 0; i < list.length; i++) {
                                        for (var j = 0; j < this.state.daysList.length; j++) {
                                            // console.log(this.state.daysList[j].VisitDate, list[i].visitDay)
                                            if (this.state.daysList[j].VisitDate == list[i].visitDay) {
                                                console.log('ttt')
                                                this.state.daysList[j].isSelect = true
                                            }
                                        }
                                    }
                                }
                                GroupDetailsList.length > 0 && GroupDetailsList.map((item, index) => {
                                    if (this.state.modalID == index && this.state.modalID != 'Coordinator') {
                                        GroupDetailsList[index].Title = isOtherPreNameModal ? otherNameModal : prenameModal
                                        GroupDetailsList[index].firstName = firstNameModal
                                        GroupDetailsList[index].middleName = middleNameModal
                                        GroupDetailsList[index].lastName = lastNameModal
                                        GroupDetailsList[index].institute = instituteModal
                                        GroupDetailsList[index].isOtherPreName = isOtherPreNameModal
                                        GroupDetailsList[index].otherName = otherNameModal
                                        GroupDetailsList[index].designation = designationModal
                                        GroupDetailsList[index].mobNo = preMobNoModal != '' && preMobNoModal != null ? `${preMobNoModal}-${mobNoModal}` : mobNoModal
                                        GroupDetailsList[index].whatsAppMobNo = preWhatsAppMobNoModal != '' && preWhatsAppMobNoModal != null ? `${preWhatsAppMobNoModal}-${whatsAppMobNoModal}` : whatsAppMobNoModal
                                        GroupDetailsList[index].pincode = pincodeModal
                                        GroupDetailsList[index].regState = regStateModal
                                        GroupDetailsList[index].countryId = countryIdModal
                                        GroupDetailsList[index].educationRoleTypeId = educationRoleTypeIdModal
                                        GroupDetailsList[index].isSameAsMobNo = isSameAsMobNoModal
                                        GroupDetailsList[index].city = cityModal
                                        GroupDetailsList[index].website = websiteModal
                                        GroupDetailsList[index].email = emailModal
                                        GroupDetailsList[index].telNo = preTelNoModal != '' && preTelNoModal != null ? `${preTelNoModal}-${telNoModal}` : telNoModal
                                        GroupDetailsList[index].tel1No = preTel1NoModal != '' && preTel1NoModal != null ? `${preTel1NoModal}-${tel1NoModal}` : tel1NoModal
                                        GroupDetailsList[index].DateArr = list
                                    } else {

                                    }
                                })
                                this.setState({ activeModalStep: 2, GroupDetailsList: GroupDetailsList })

                                // this.setState({
                                //     isOtherPreNameModal: false, otherNameModal: '', emailErrModal: '', firstNameModal: '', firstNameErrModal: '', prenameModal: '', middleNameModal: '', lastNameModal: '', lastNameErrModal: '', designationModal: '', designationErrModal: '', instituteModal: '', instituteErrModal: '', mobNoModal: '', mobNoErrModal: '', preMobNoModal: '', whatsAppMobNoModal: '', whatsAppMobNoErrModal: '', preWhatsAppMobNoModal: '', isSameAsMobNoModal: false, pincodeModal: '', pincodeErrModal: '', regStateModal: '', regStateErrModal: '', cityModal: '', cityErrModal: '', websiteModal: '', emailModal: '', telNoModal: '', preTelNoModal: '', tel1NoModal: '', preTel1NoModal: '', isOpen: false, GroupDetailsList: GroupDetailsList, isModalEdit: false
                                // })
                                // setTimeout(() => {
                                //     toastSuccess("visitor update successfully")
                                // }, 200);
                            }
                        } else {
                            toastError("Please enter different email")
                        }
                    }
                } else {
                    toastError(errtoShow != '' ? errtoShow : "Please enter mandatory fields")
                    console.log("lplplllllllllllllllllllll")
                }
            }, 200);

        } else {
            this.inputValidateIndustrySegment()
            // Preparing Udt For Chapter List
            const selectedChapter = chapterList.filter(data => data.IsSelect == true)
            var chapterListData = []
            selectedChapter.map((data) => {
                var data = {
                    "ChapterID": data.IndustrySegmentID,
                    "ChapterNames": data['Industrial Segment'],
                    "OtherNames": data.IndustrySegmentID == 16 ? other : ''
                }
                chapterListData.push(data)
            })


            // Preparing Udt For Hall Chapter List
            var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
            var filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)
            var chapterListData2 = []
            filerArray.map((data) => {
                var data = {
                    "ChapterID": data.ChapterID,
                    "ChapterNames": data.ChapterName,
                    // "OtherNames": ''

                }
                chapterListData2.push(data)
            })

            const selectedSeminarList = seminarInterestListModal.filter(data => data.isSelect == true)
            var seminarInterestListData = []
            selectedSeminarList.map((data) => {
                var data = {
                    "SeminarID": data.SeminarID,
                }
                seminarInterestListData.push(data)
            })


            setTimeout(() => {
                var visaFlag = true
                var grpDelFlag = true
                if (isGrpDelegation) {
                    if (leader == "") {
                        this.setState({ leaderErr: "Please enter Leader/Organisation" });
                        grpDelFlag = false
                    }
                    if (delegationCountry == "") {
                        this.setState({ delegationCountryErr: "Please enter Country" });
                        grpDelFlag = false
                    }
                    if (arrivalDate == "") {
                        this.setState({ arrivalDateErr: "Please enter Arrival Date" });
                        grpDelFlag = false
                    }
                    if (departureDate == "") {
                        this.setState({ departureDateErr: "Please enter Departure Date" });
                        grpDelFlag = false
                    }
                    if (delegationRemark == "") {
                        this.setState({ delegationRemarkErr: "Please enter Delegation Remark" });
                        grpDelFlag = false
                    }
                }
                console.log('00000000000000000000000000000000000000000000000000000000000000000000000', passDate, '00000000000000000000000000000000000000000000000000000000000000000000000', passExipryDate)
                if (needVisaAssistance) {
                    if (passName == "") {
                        this.setState({ passNameErr: "Please enter Name " });
                        visaFlag = false
                    }
                    if (passCountry == "" || passCountry == 0 || passCountry == null) {
                        this.setState({ passCountryErr: "Please select country " });
                        visaFlag = false
                    }
                    if (applicantMobNo == "") {
                        this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
                        visaFlag = false
                    }
                    if (applicantEmail == "") {
                        this.setState({ applicantEmailErr: "Please enter Email " });
                        visaFlag = false
                    }

                    if (passNo == "") {
                        this.setState({ passNoErr: "Please enter Passport No " });
                        visaFlag = false
                    }
                    if (passDate == "" || passDate == "") {
                        this.setState({ passDateErr: "Please enter Passport Date " });
                        visaFlag = false
                    }
                    if (passExipryDate == "" || passExipryDate == null) {
                        this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
                        visaFlag = false
                    }
                    if (passportFile == "" || passportFile == null) {
                        this.setState({ passportFileErr: "Please Upload File " });
                        visaFlag = false
                    }
                    if (applicantEmail != "") {
                        var emailError = emailValidator(applicantEmail)
                        if (emailError != '') {
                            this.setState({ applicantEmailErr: emailError })
                            visaFlag = false
                            // return
                        }
                    }

                }
                var intrestErr = false
                if (seminarInterestListData.length == 0 && this.state.isInterstOne) {
                    this.setState({ SeminarErrModal: "Please select Seminar" })
                    intrestErr = true
                }
                // if (this.state.isInterestTwo) {
                //     if (this.state.preffDateModal == "") {
                //         this.setState({ preffDateErrModal: "Please select preffered date" })
                //         intrestErr = true
                //     }
                //     if (this.state.prefTimeModal == "") {
                //         this.setState({ preffTimeErrModal: "Please select preffered time" })
                //         intrestErr = true
                //     }
                //     // if (this.state.b2bRemarkModal == "") {
                //     //     this.setState({ b2bRemarkErrModal: "Please enter remark" })
                //     //     intrestErr = true
                //     // }
                // }
                if ((chapterListData2.length != 0 && chapterListData.length != 0) && visaFlag && chapterErr == "" && grpDelFlag && ChapterHallErr == "" && !intrestErr) {
                    if (this.state.isModalEdit) {
                        if (this.state.isModalEdit) if (modalID == 'Coordinator') {
                            this.setState({
                                ApplicantEmailIDCoordinator: needVisaAssistance ? applicantEmail : '',
                                ApplicantMobileNoCoordinator: needVisaAssistance ? preApplicantMobNo != null && preApplicantMobNo != '' ? `${preApplicantMobNo}-${applicantMobNo}` : applicantMobNo : '',
                                B2BDepartureDateCoordinator: isInterestTwo ? this.state.preffDateModal : '',
                                B2BPreferredTimeCoordinator: isInterestTwo ? this.state.prefTimeModal : '',
                                B2BRemarkCoordinator: isInterestTwo ? this.state.b2bRemarkModal : '',
                                CarparkingCoordinator: false,
                                isInterestTwoCoordinator: isInterestTwo,
                                isInterstOneCoordinator: this.state.isInterstOne,
                                DelegationArrivalDateCoordinator: isGrpDelegation ? arrivalDate : null,
                                DelegationCountryIDCoordinator: isGrpDelegation ? delegationCountry : null,
                                DelegationDepartureDateCoordinator: isGrpDelegation ? departureDate : null,
                                DelegationNameCoordinator: isGrpDelegation ? leader : '',
                                DelegationRemarkCoordinator: isGrpDelegation ? delegationRemark : '',
                                // ExhibitionIDCoordinator: parseInt(sessionStorage.getItem('sessionExhibitionID')),
                                IsGroupDelegationCoordinator: isGrpDelegation,
                                NameOnPassportCoordinator: needVisaAssistance ? passName : '',
                                ParkingChargesCoordinator: 0,
                                PassportExpiryDateCoordinator: needVisaAssistance ? passExipryDate : null,
                                PassportFileCoordinator: needVisaAssistance ? passportFile : null,
                                PassportFileNameCoordinator: needVisaAssistance ? passPortFileName : null,
                                PassportFilePathCoordinator: needVisaAssistance ? passportFilePath : '',
                                PassportFileTypeCoordinator: needVisaAssistance ? passportFileType : '',
                                PassportIssueDateCoordinator: needVisaAssistance ? passDate : null,
                                PassportIssuingCountryIDCoordinator: needVisaAssistance ? passCountry : null,
                                PassportNoCoordinator: needVisaAssistance ? passNo : '',
                                UserIDCoordinator: null,
                                areaOfInterestListCoordinator: [],
                                hallChapterListCoordinator: chapterListData2,
                                interestSeminarListCoordinator: this.state.isInterstOne ? seminarInterestListData : [],
                                isVisaAssistanceCoordinator: needVisaAssistance,
                                purposeOfVisitListCoordinator: [],
                                visitorChapterListCoordinator: chapterListData,
                                // visitorRegNoCoordinator: null,
                                isVisaAppliedCoordinator: needVisaAssistance,
                                isPassportFilePresentCoordinator: this.state.isPassportFilePresentCoordinator,
                                identityCardFileCoordinator: this.state.identityCardFileModal,
                                identityCardFileTypeCoordinator: this.state.identityCardFileTypeModal,
                                identityCardFileNameCoordinator: this.state.identityCardFileNameModal,
                                identityCardFilePathCoordinator: this.state.identityCardFilePathModal,
                            })
                            console.log("DEBUG: Saving coordinator (step 2 complete):", { identityCardFile: this.state.identityCardFile ? `Present (${this.state.identityCardFile.length} chars)` : 'EMPTY', identityCardFileName: this.state.identityCardFileName })
                        } else {
                            GroupDetailsList.length > 0 && GroupDetailsList.map((item, index) => {
                                if (this.state.modalID == index) {
                                    GroupDetailsList[index].ApplicantEmailID = needVisaAssistance ? applicantEmail : ''
                                    GroupDetailsList[index].ApplicantMobileNo = needVisaAssistance ? preApplicantMobNo != null && preApplicantMobNo != '' ? `${preApplicantMobNo}-${applicantMobNo}` : applicantMobNo : ''
                                    GroupDetailsList[index].B2BDepartureDate = isInterestTwo ? this.state.preffDateModal : ''
                                    GroupDetailsList[index].B2BPreferredTime = isInterestTwo ? this.state.prefTimeModal : ''
                                    GroupDetailsList[index].B2BRemark = isInterestTwo ? this.state.b2bRemarkModal : ''
                                    GroupDetailsList[index].Carparking = false
                                    GroupDetailsList[index].IsInterestedforb2b = isInterestTwo
                                    GroupDetailsList[index].IsInterestedforSeminar = this.state.isInterstOne
                                    GroupDetailsList[index].DelegationArrivalDate = isGrpDelegation ? arrivalDate : null
                                    GroupDetailsList[index].DelegationCountryID = isGrpDelegation ? delegationCountry : null
                                    GroupDetailsList[index].DelegationDepartureDate = isGrpDelegation ? departureDate : null
                                    GroupDetailsList[index].DelegationName = isGrpDelegation ? leader : ''
                                    GroupDetailsList[index].DelegationRemark = isGrpDelegation ? delegationRemark : ''
                                    GroupDetailsList[index].ExhibitionID = parseInt(sessionStorage.getItem('sessionExhibitionID'))
                                    GroupDetailsList[index].IsGroupDelegation = isGrpDelegation
                                    GroupDetailsList[index].NameOnPassport = needVisaAssistance ? passName : ''
                                    GroupDetailsList[index].ParkingCharges = 0
                                    GroupDetailsList[index].PassportExpiryDate = needVisaAssistance ? passExipryDate : null
                                    GroupDetailsList[index].PassportFile = needVisaAssistance ? passportFile : null
                                    GroupDetailsList[index].PassportFileName = needVisaAssistance ? passPortFileName : null
                                    GroupDetailsList[index].PassportFilePath = needVisaAssistance ? passportFilePath : ''
                                    GroupDetailsList[index].PassportFileType = needVisaAssistance ? passportFileType : ''
                                    GroupDetailsList[index].PassportIssueDate = needVisaAssistance ? passDate : null
                                    GroupDetailsList[index].PassportIssuingCountryID = needVisaAssistance ? passCountry : null
                                    GroupDetailsList[index].PassportNo = needVisaAssistance ? passNo : ''
                                    GroupDetailsList[index].UserID = null
                                    GroupDetailsList[index].areaOfInterestList = []
                                    GroupDetailsList[index].hallChapterList = chapterListData2
                                    GroupDetailsList[index].interestSeminarList = this.state.isInterstOne ? seminarInterestListData : []
                                    GroupDetailsList[index].isVisaAssistance = needVisaAssistance
                                    GroupDetailsList[index].purposeOfVisitList = []
                                    GroupDetailsList[index].visitorChapterList = chapterListData
                                    // GroupDetailsList[index].visitorRegNo = null
                                    GroupDetailsList[index].isVisaApplied = needVisaAssistance
                                    GroupDetailsList[index].isPassportFilePresent = false
                                }
                            })
                            this.setState({ GroupDetailsList: GroupDetailsList })
                        }
                    }
                    else {
                        tempObj.ApplicantEmailID = needVisaAssistance ? applicantEmail : ''
                        tempObj.ApplicantMobileNo = needVisaAssistance ? preApplicantMobNo != null && preApplicantMobNo != '' ? `${preApplicantMobNo}-${applicantMobNo}` : applicantMobNo : ''
                        tempObj.B2BDepartureDate = isInterestTwo ? this.state.preffDateModal : ''
                        tempObj.B2BPreferredTime = isInterestTwo ? this.state.prefTimeModal : ''
                        tempObj.B2BRemark = isInterestTwo ? this.state.b2bRemarkModal : ''
                        tempObj.Carparking = false
                        tempObj.IsInterestedforb2b = isInterestTwo
                        tempObj.IsInterestedforSeminar = this.state.isInterstOne
                        tempObj.DelegationArrivalDate = isGrpDelegation ? arrivalDate : null
                        tempObj.DelegationCountryID = isGrpDelegation ? delegationCountry : null
                        tempObj.DelegationDepartureDate = isGrpDelegation ? departureDate : null
                        tempObj.DelegationName = isGrpDelegation ? leader : ''
                        tempObj.DelegationRemark = isGrpDelegation ? delegationRemark : ''
                        tempObj.ExhibitionID = parseInt(sessionStorage.getItem('sessionExhibitionID'))
                        tempObj.IsGroupDelegation = isGrpDelegation
                        tempObj.NameOnPassport = needVisaAssistance ? passName : ''
                        tempObj.ParkingCharges = 0
                        tempObj.PassportExpiryDate = needVisaAssistance ? passExipryDate : null
                        tempObj.PassportFile = needVisaAssistance ? passportFile : null
                        tempObj.PassportFileName = needVisaAssistance ? passPortFileName : null
                        tempObj.PassportFilePath = needVisaAssistance ? passportFilePath : ''
                        tempObj.PassportFileType = needVisaAssistance ? passportFileType : ''
                        tempObj.PassportIssueDate = needVisaAssistance ? passDate : null
                        tempObj.PassportIssuingCountryID = needVisaAssistance ? passCountry : null
                        tempObj.PassportNo = needVisaAssistance ? passNo : ''
                        tempObj.UserID = null
                        tempObj.areaOfInterestList = []
                        tempObj.hallChapterList = chapterListData2
                        tempObj.interestSeminarList = this.state.isInterstOne ? seminarInterestListData : []
                        tempObj.isVisaAssistance = needVisaAssistance
                        tempObj.purposeOfVisitList = []
                        tempObj.visitorChapterList = chapterListData
                        // tempObj.visitorRegNo = null
                        tempObj.isVisaApplied = needVisaAssistance
                        tempObj.isPassportFilePresent = false

                        GroupDetailsList.push(tempObj)
                        this.setState({ GroupDetailsList: GroupDetailsList, })
                    }
                    this.cancelModal()
                    modalID != 'Coordinator' && toastSuccess("Visitor Added Successfully")
                }
                else {
                    toastError("Please enter mandatory fields")
                    console.log("lplplllllllllllllllllllll")
                }
            }, 200);
        }
        setTimeout(() => {
            console.log(this.state.GroupDetailsList)
        }, 1000);
    }

    handleEditGroup(i) {
        const { GroupDetailsList, isOtherPreNameModal, otherNameModal, emailErrModal, firstNameModal, firstNameErrModal, prenameModal, middleNameModal, lastNameModal, lastNameErrModal, designationModal, designationErrModal, instituteModal, instituteErrModal, mobNoModal, mobNoErrModal, preMobNoModal, whatsAppMobNoModal, whatsAppMobNoErrModal, preWhatsAppMobNoModal, isSameAsMobNoModal, pincodeModal, pincodeErrModal, regStateModal, regStateErrModal, cityModal, cityErrModal, websiteModal, emailModal, telNoModal, preTelNoModal, tel1NoModal, preTel1NoModal, daysModalList, chapterList, primaryChapterListData, level0, level2, leader, level3, level4, mobNo, whatsAppMobNo, tel1No, telNo, ApplicantMobileNoCoordinator, ExhVisitorID, AccountID, preName, middleName, lastName, firstName, designation, institute, isSameAsMobNo, seminarInterestListModal, B2BDepartureDateCoordinator, interestSeminarListCoordinator, pincode, regState, city, website, email, countryId, daysList, interestListModal, educationRoleTypeId } = this.state
        console.log(GroupDetailsList, this.state.DateArrCoordinator, 'llllllllllllllll')
        if (i == 'Coordinator') {
            this.state.DateArrCoordinator.length > 0 && this.state.DateArrCoordinator.map(item2 => {
                daysModalList.length > 0 && daysModalList.map(item => {
                    if (item.Code == item2.visitDay) {
                        item.isSelect = true
                    }
                })
            })
            this.state.visitorChapterListCoordinator.length > 0 && this.state.visitorChapterListCoordinator.map(item2 => {
                chapterList.length > 0 && chapterList.map(item => {
                    if (item.IndustrySegmentID == item2.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            var SelectedHallChapters = this.state.hallChapterListCoordinator != null ? this.state.hallChapterListCoordinator : []
            primaryChapterListData.length > 0 && primaryChapterListData.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            level2.length > 0 && level2.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            level3.length > 0 && level3.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            level4.length > 0 && level4.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            seminarInterestListModal.length > 0 && seminarInterestListModal.map((item) => {
                interestSeminarListCoordinator.length > 0 && interestSeminarListCoordinator.map((element) => {
                    if (element.SeminarID == item.SeminarID) {
                        item.isSelect = true
                    }
                })
            })
            interestListModal.length > 0 && interestListModal.map((data) => {
                if (data.AreaofInterestID == 2) {
                    if (this.state.isInterestTwoCoordinator) {
                        data.isSelect = true
                    }
                }
                if (data.AreaofInterestID == 1) {
                    if (this.state.isInterstOneCoordinator) {
                        data.isSelect = true
                    }
                }
            })
            console.log("interestSeminarListCoordinator", interestSeminarListCoordinator)
            var mob1 = mobNo
            const parts = mob1 != '' ? mob1.split("-") : '';
            const Mob1Code = parts.length > 1 && parts != '' ? parts[0] : ''
            const Mob1No = parts != '' ? parts.length > 1 ? parts[1] : parts[0] : ''
            // WhatsApp Mobile No
            var mob2 = whatsAppMobNo
            const parts2 = mob2 != '' ? mob2.split("-") : ''
            const Mob2Code = parts2.length > 1 && parts2 != '' ? parts2[0] : ''
            const Mob2No = parts2 != '' ? parts2.length > 1 ? parts2[1] : parts2[0] : ''
            // TelePhone No
            var tel = telNo
            const parts3 = tel != '' ? tel.split("-") : ''
            const telCode = parts3.length > 1 && parts3 != '' ? parts3[0] : ''
            const telNumber = parts3 != '' ? parts3.length > 1 ? parts3[1] : parts3[0] : ''
            // Telephone 1 Mobile No
            var tel1 = tel1No
            const parts4 = tel1 != '' ? tel1.split("-") : ''
            const tel1Code = parts4.length > 1 && parts4 != '' ? parts4[0] : ''
            const tel1Number = parts4 != '' ? parts4.length > 1 ? parts4[1] : parts4[0] : ''

            var applicantMob = ApplicantMobileNoCoordinator
            const parts5 = applicantMob != '' ? applicantMob.split("-") : ''
            const applicantMobCode = parts5.length > 1 && parts5 != '' ? parts5[0] : ''
            const applicantMobNumber = parts5 != '' ? parts5.length > 1 ? parts5[1] : parts5[0] : ''
            console.log(mobNo, ';;;', this.state.preMobNo, ';;;', ApplicantMobileNoCoordinator, ';;', Mob1Code, ';;;', Mob1No)
            this.setState({
                // isOtherPreNameModal: false,//
                // otherNameModal: GroupDetailsList[i],//
                // emailErrModal: GroupDetailsList[i],
                ExhVisitorIDModal: ExhVisitorID,
                AccountIDModal: AccountID,
                firstNameModal: firstName,
                // firstNameErrModal: GroupDetailsList[i],
                prenameModal: preName,
                middleNameModal: middleName,
                lastNameModal: lastName,
                // lastNameErrModal: GroupDetailsList[i],
                designationModal: designation,
                // designationErrModal: GroupDetailsList[i],
                instituteModal: institute,
                // instituteErrModal: GroupDetailsList[i],
                mobNoModal: mobNo,
                // mobNoErrModal: Mob1No,
                preMobNoModal: this.state.preMobNo,
                whatsAppMobNoModal: whatsAppMobNo,
                // whatsAppMobNoErrModal: GroupDetailsList[i],
                preWhatsAppMobNoModal: this.state.preWhatsAppMobNo,
                isSameAsMobNoModal: isSameAsMobNo,
                pincodeModal: pincode,
                // pincodeErrModal: GroupDetailsList[i],
                regStateModal: regState,
                // regStateErrModal: GroupDetailsList[i],
                cityModal: city,
                // cityErrModal: GroupDetailsList[i],
                websiteModal: website,
                emailModal: email,
                // emailerModal: GroupDetailsList[i],
                telNoModal: telNumber,
                preTelNoModal: telCode,
                tel1NoModal: tel1Number,
                preTel1NoModal: tel1Code,
                preffDateModal: this.state.B2BDepartureDateCoordinator,
                prefTimeModal: this.state.B2BPreferredTimeCoordinator,
                b2bRemarkModal: this.state.B2BRemarkCoordinator,
                isInterestTwo: this.state.isInterestTwoCoordinator,
                isInterstOne: this.state.isInterstOneCoordinator,
                isOpen: true,
                modalID: i,
                isModalEdit: true,
                countryIdModal: countryId,
                educationRoleTypeIdModal: educationRoleTypeId,
                preApplicantMobNo: ApplicantMobileNoCoordinator != '' ? applicantMobCode : this.state.preMobNo,
                applicantMobNo: ApplicantMobileNoCoordinator != '' ? applicantMobNumber : mobNo,
                arrivalDate: this.state.DelegationArrivalDateCoordinator,
                delegationCountry: this.state.DelegationCountryIDCoordinator,
                departureDate: this.state.DelegationDepartureDateCoordinator,
                leader: this.state.DelegationNameCoordinator,
                delegationRemark: this.state.DelegationRemarkCoordinator,
                isGrpDelegation: this.state.IsGroupDelegationCoordinator,
                passName: this.state.NameOnPassportCoordinator,
                passportFileType: this.state.PassportFileTypeCoordinator,
                passportFile: this.state.PassportFileCoordinator,
                passportFilePath: this.state.PassportFilePathCoordinator,
                passPortFileName: this.state.PassportFileNameCoordinator,
                passDate: this.state.PassportIssueDateCoordinator,
                passExipryDate: this.state.PassportExpiryDateCoordinator,
                passCountry: this.state.PassportIssuingCountryIDCoordinator,
                passNo: this.state.PassportNoCoordinator,
                applicantEmail: this.state.ApplicantEmailIDCoordinator != '' ? this.state.ApplicantEmailIDCoordinator : this.state.email,
                needVisaAssistance: this.state.isVisaAssistanceCoordinator,
                primaryChapterListData: primaryChapterListData,
                level0: level0,
                level2: level2,
                level3: level3,
                level4: level4,
                daysModalList: daysModalList,
                chapterList: chapterList,
                isVisaApplied: this.state.isVisaAppliedCoordinator,
                isPassportFilePresent: this.state.isPassportFilePresentCoordinator,
                modalStep2: true

            }, () => {
                if (countryId == 91) {
                    this.getFillList(pincodeActionId, '', '', countryId, '', '')
                    this.getFillList(stateActionId, '', '', countryId, '', '')
                    this.getFillList(cityActionId, '', '', countryId, '', '')

                }
                setTimeout(() => {
                    this.setState({
                        isOpenDropDownState: false,
                        focusedIndexState: -1,
                        isOpenDropDownStateModal: false,
                        focusedIndexStateModal: -1,

                        isOpenDropDownCity: false,
                        focusedIndexCity: -1,
                        isOpenDropDownCityModal: false,
                        focusedIndexCityModal: -1,

                        isOpenDropDownPin: false,
                        focusedIndexPin: -1,
                        isOpenDropDownPinModal: false,
                        focusedIndexPinModal: -1,
                    })
                }, 100);
            })
        } else {
            GroupDetailsList[i].DateArr.length > 0 && GroupDetailsList[i].DateArr.map(item2 => {
                daysModalList.length > 0 && daysModalList.map(item => {
                    if (item.Code == item2.visitDay) {
                        item.isSelect = true
                    }
                })
            })
            GroupDetailsList[i].visitorChapterList.length > 0 && GroupDetailsList[i].visitorChapterList.map(item2 => {
                chapterList.length > 0 && chapterList.map(item => {
                    if (item.IndustrySegmentID == item2.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            var SelectedHallChapters = GroupDetailsList[i]['hallChapterList'] != null ? GroupDetailsList[i]['hallChapterList'] : []
            primaryChapterListData.length > 0 && primaryChapterListData.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            level2.length > 0 && level2.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            level3.length > 0 && level3.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            level4.length > 0 && level4.map((item) => {
                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                    if (element.ChapterID == item.ChapterID) {
                        item.IsSelect = true
                    }
                })
            })
            seminarInterestListModal.length > 0 && seminarInterestListModal.map((item) => {
                GroupDetailsList[i]['interestSeminarList'].length > 0 && GroupDetailsList[i]['interestSeminarList'].map((element) => {
                    if (element.SeminarID == item.SeminarID) {
                        item.isSelect = true
                    }
                })
            })
            interestListModal.length > 0 && interestListModal.map((data) => {
                if (data.AreaofInterestID == 2) {
                    if (GroupDetailsList[i].IsInterestedforb2b) {
                        data.isSelect = true
                    }
                }
                if (data.AreaofInterestID == 1) {
                    if (GroupDetailsList[i].IsInterestedforSeminar) {
                        data.isSelect = true
                    }
                }
            })
            var mob1 = GroupDetailsList[i].mobNo
            const parts = mob1 != '' ? mob1.split("-") : '';
            const Mob1Code = parts.length > 1 && parts != '' ? parts[0] : ''
            const Mob1No = parts != '' ? parts.length > 1 ? parts[1] : parts[0] : ''
            // WhatsApp Mobile No
            var mob2 = GroupDetailsList[i].whatsAppMobNo
            const parts2 = mob2 != '' ? mob2.split("-") : ''
            const Mob2Code = parts2.length > 1 && parts2 != '' ? parts2[0] : ''
            const Mob2No = parts2 != '' ? parts2.length > 1 ? parts2[1] : parts2[0] : ''
            // TelePhone No
            var tel = GroupDetailsList[i].telNo
            const parts3 = tel != '' ? tel.split("-") : ''
            const telCode = parts3.length > 1 && parts3 != '' ? parts3[0] : ''
            const telNumber = parts3 != '' ? parts3.length > 1 ? parts3[1] : parts3[0] : ''
            // Telephone 1 Mobile No
            var tel1 = GroupDetailsList[i].tel1No
            const parts4 = tel1 != '' ? tel1.split("-") : ''
            const tel1Code = parts4.length > 1 && parts4 != '' ? parts4[0] : ''
            const tel1Number = parts4 != '' ? parts4.length > 1 ? parts4[1] : parts4[0] : ''

            var applicantMob = GroupDetailsList[i].ApplicantMobileNo
            const parts5 = applicantMob != '' ? applicantMob.split("-") : ''
            const applicantMobCode = parts5.length > 1 && parts5 != '' ? parts5[0] : ''
            const applicantMobNumber = parts5 != '' ? parts5.length > 1 ? parts5[1] : parts5[0] : ''
            this.setState({
                // isOtherPreNameModal: false,//
                // otherNameModal: GroupDetailsList[i],//
                // emailErrModal: GroupDetailsList[i],
                ExhVisitorIDModal: GroupDetailsList[i].ExhVisitorID,
                AccountIDModal: GroupDetailsList[i].AccountID,
                firstNameModal: GroupDetailsList[i].firstName,
                // firstNameErrModal: GroupDetailsList[i],
                prenameModal: GroupDetailsList[i].Title,
                middleNameModal: GroupDetailsList[i].middleName,
                lastNameModal: GroupDetailsList[i].lastName,
                // lastNameErrModal: GroupDetailsList[i],
                designationModal: GroupDetailsList[i].designation,
                // designationErrModal: GroupDetailsList[i],
                instituteModal: GroupDetailsList[i].institute,
                // instituteErrModal: GroupDetailsList[i],
                mobNoModal: Mob1No,
                // mobNoErrModal: Mob1No,
                preffDateModal: GroupDetailsList[i].B2BDepartureDate,
                prefTimeModal: GroupDetailsList[i].B2BPreferredTime,
                b2bRemarkModal: GroupDetailsList[i].B2BRemark,
                preMobNoModal: Mob1Code,
                whatsAppMobNoModal: Mob2No,
                // whatsAppMobNoErrModal: GroupDetailsList[i],
                preWhatsAppMobNoModal: Mob2Code,
                isSameAsMobNoModal: GroupDetailsList[i].isSameAsMobNo,
                pincodeModal: GroupDetailsList[i].pincode,
                // pincodeErrModal: GroupDetailsList[i],
                regStateModal: GroupDetailsList[i].regState,
                // regStateErrModal: GroupDetailsList[i],
                cityModal: GroupDetailsList[i].city,
                // cityErrModal: GroupDetailsList[i],
                websiteModal: GroupDetailsList[i].website,
                emailModal: GroupDetailsList[i].email,
                // emailerModal: GroupDetailsList[i],
                telNoModal: telNumber,
                preTelNoModal: telCode,
                tel1NoModal: tel1Number,
                preTel1NoModal: tel1Code,
                isOpen: true,
                modalID: i,
                isModalEdit: true,
                countryIdModal: GroupDetailsList[i].countryId,
                educationRoleTypeIdModal: GroupDetailsList[i].educationRoleTypeId,
                preApplicantMobNo: applicantMobCode,
                applicantMobNo: applicantMobNumber,
                arrivalDate: GroupDetailsList[i].DelegationArrivalDate,
                delegationCountry: GroupDetailsList[i].DelegationCountryID,
                departureDate: GroupDetailsList[i].DelegationDepartureDate,
                leader: GroupDetailsList[i].DelegationName,
                delegationRemark: GroupDetailsList[i].DelegationRemark,
                isGrpDelegation: GroupDetailsList[i].IsGroupDelegation,
                passName: GroupDetailsList[i].NameOnPassport,
                passportFileType: GroupDetailsList[i].PassportFileType,
                passportFile: GroupDetailsList[i].PassportFile,
                passportFilePath: GroupDetailsList[i].PassportFilePath,
                passPortFileName: GroupDetailsList[i].PassportFileName,
                passDate: GroupDetailsList[i].PassportIssueDate,
                passExipryDate: GroupDetailsList[i].PassportExpiryDate,
                passCountry: GroupDetailsList[i].PassportIssuingCountryID,
                passNo: GroupDetailsList[i].PassportNo,
                applicantEmail: GroupDetailsList[i].ApplicantEmailID,
                needVisaAssistance: GroupDetailsList[i].isVisaAssistance,
                primaryChapterListData: primaryChapterListData,
                level0: level0,
                level2: level2,
                level3: level3,
                level4: level4,
                daysModalList: daysModalList,
                chapterList: chapterList,
                isVisaApplied: GroupDetailsList[i].isVisaApplied,
                isPassportFilePresent: GroupDetailsList[i].isPassportFilePresent,
                modalStep2: true,
                isInterestTwo: GroupDetailsList[i].IsInterestedforb2b,
                isInterstOne: GroupDetailsList[i].IsInterestedforSeminar,

            }, () => {
                if (GroupDetailsList[i].countryId == 91) {
                    this.getFillList(pincodeActionId, '', '', GroupDetailsList[i].countryId, '', '')
                    this.getFillList(stateActionId, '', '', GroupDetailsList[i].countryId, '', '')
                    this.getFillList(cityActionId, '', '', GroupDetailsList[i].countryId, '', '')

                }
                setTimeout(() => {
                    this.setState({
                        isOpenDropDownState: false,
                        focusedIndexState: -1,
                        isOpenDropDownStateModal: false,
                        focusedIndexStateModal: -1,

                        isOpenDropDownCity: false,
                        focusedIndexCity: -1,
                        isOpenDropDownCityModal: false,
                        focusedIndexCityModal: -1,

                        isOpenDropDownPin: false,
                        focusedIndexPin: -1,
                        isOpenDropDownPinModal: false,
                        focusedIndexPinModal: -1,
                    })
                }, 100);
            })
        }
        setTimeout(() => {
            // console.log(GroupDetailsList[i].B2BDepartureDate != '' && GroupDetailsList[i].B2BDepartureDate != '1900-01-01T00:00:00.000Z' && GroupDetailsList[i].B2BPreferredTime != '' && GroupDetailsList[i].B2BRemark != '' && GroupDetailsList[i].B2BDepartureDate != null && GroupDetailsList[i].B2BPreferredTime != null && GroupDetailsList[i].B2BRemark != null)

            console.log(i, GroupDetailsList, primaryChapterListData, level0, level2, level3, level4)
        }, 500);
    }

    // render Visa Application
    renderGroupList() {
        const { GroupDetailsList } = this.state
        var visitorDaysArr = []
        GroupDetailsList.map(item => {
            item.displayDateArr = []
            item.DateArr.length > 0 && item.DateArr.map(item2 => {
                item.displayDateArr.push(item2.visitDay)
            })
            item.displayDateArr.join(',')
            // item.displayDateArr = tempArr
        })
        console.log('07082025', GroupDetailsList)
        return (
            <ul class="list-group " style={{ position: 'relative', zIndex: 1 }}>
                {
                    GroupDetailsList.length > 0 && GroupDetailsList.map((data, index) => (<>
                        {data.isCoordinator != true && <li class="list-group-item" key={Math.random()}>
                            <div className="row" style={{ display: 'inline' }}>
                                <h5 className="" style={{ color: "#0056ff" }}>Visitor {this.state.isSaving ? index : ++index}</h5>
                                <div className="row" style={{ display: 'inline' }}>
                                    <button
                                        type="button"
                                        className="btn btn-warning rounded-3"
                                        style={{ marginRight: '10px', width: '100px', float: 'right' }}
                                        onClick={() => this.handleEditGroup(index - 1)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger rounded-3"
                                        style={{ marginRight: '10px', width: '100px', float: 'right' }}
                                        onClick={() => this.handleDeleteAddedVisitor(index)}
                                    >
                                        delete
                                    </button>
                                </div>
                            </div>
                            <div className="added-more p-3 rounded-2">
                                <div className="row mt-4">
                                    <div className="col-md-4">
                                        <h6>First Name: {data.firstName}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Middle Name: {data.middleName}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Last Name: {data.lastName}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>Designation: {data.designation}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Institue/Organisation: {data.institute}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Mobile: {data.mobNo}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>WhatsApp No:  {data.whatsAppMobNo}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Pincode: {data.pincode}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>State: {data.regState}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>City: {data.city}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Website: {data.website}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Email: {data.email}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>Telephone: {data.telNo}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Telephone 1: {data.tel1No}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Visit Days: {data.DateArr.length > 0 ? data.DateArr.map((item, i) => (
                                            `${item.visitDay}${i != data.DateArr.length - 1 ? ',  ' : ''}`
                                        )) : ''}</h6>
                                    </div>
                                </div>
                            </div>
                            <hr className="m-1" />

                        </li>}
                    </>
                    ))
                }
            </ul>
        )
    }

    handleDeleteAddedVisitor(id) {
        // const { GroupDetailsList } = this.state
        // console.log(GroupDetailsList[id], id)
        // GroupDetailsList.splice(id, 1)
        // this.setState({ GroupDetailsList: GroupDetailsList })
        const { GroupDetailsList, AccountIDModal, ExhVisitorID, ExhVisitorIDModal } = this.state
        // console.log(GroupDetailsList[id - 1], id)
        // if (GroupDetailsList[id - 1].AccountID != '' && GroupDetailsList[id - 1].AccountID != null && GroupDetailsList[id - 1].ExhVisitorID != '' && GroupDetailsList[id - 1].ExhVisitorID != null) {
        //     this.setState({ isOpen5: true, AccountIDModal: GroupDetailsList[id - 1].AccountID, ExhVisitorIDModal: GroupDetailsList[id - 1].ExhVisitorID })
        // } else {
        //     GroupDetailsList.splice(id - 1, 1)
        //     this.setState({ GroupDetailsList: GroupDetailsList })
        // }

        console.log(GroupDetailsList[id - 1], id)
        this.setState({ isOpen5: true, AccountIDModal: GroupDetailsList[id - 1].AccountID, ExhVisitorIDModal: GroupDetailsList[id - 1].ExhVisitorID, deleteID: id })
    }

    toggleModel(status) {
        console.log('statuss', status)
        const { isOpen, isFirst } = this.state
        const { countryId, attendeeTypeId, city, preMobNo, mobNo, regState, designation, photoFile, lastName, photoIdFile, gender,
            institute, firstName, preWhatsAppMobNo, whatsAppMobNo, pincode, email, firstNameErr, lastNameErr, designationErr,
            instituteErr, mobNoErr, whatsAppMobNoErr, regStateErr, cityErr, pincodeErr, emailErr, preName, middleName,
            isSameAsMobNo, website, preTelNo, preTel1No, hallChapterListCoordinator, visitorChapterListCoordinator, isCoordinatorVisit, daysList, telNo, isModalEdit, modalStep2, activeModalStep, tel1No, countryIdErr, attendeeTypeErr, daysErr, educationRoleTypeId, educationRoleTypeIdErr, emailModal } = this.state
        this.inputValidate(1)
        var selectedDays = []
        selectedDays = this.state.isCoordinatorVisit ? daysList.filter(data => data.isSelect == true) : []
        var coVisitFlag = true
        if (isCoordinatorVisit) {
            if (hallChapterListCoordinator.length == 0) {
                coVisitFlag = false
            }
            if (visitorChapterListCoordinator.length == 0) {
                coVisitFlag = false
            }
        }
        setTimeout(() => {
            console.log(selectedDays)
            if (firstName != "" && lastName != "" && designation != "" && institute != "" && mobNo != "" && whatsAppMobNo != "" &&
                city != "" && pincode != "" && email != "" && countryId != "" && attendeeTypeId != "") {
                if (firstNameErr == "" && lastNameErr == "" && designationErr == "" && instituteErr == "" && mobNoErr == "" && educationRoleTypeIdErr == "" &&
                    whatsAppMobNoErr == "" && regStateErr == "" && cityErr == "" && pincodeErr == "" && (emailErr == "" && emailErr != "Please enter proper email." && emailErr != "your emailId already register as a visitor account") && countryIdErr == "" && attendeeTypeErr == "" && (this.state.isCoordinatorVisit ? selectedDays.length > 0 : true)
                ) {
                    if (status == 2) {
                        if (coVisitFlag) {
                            this.setState({ isOpen2: true, isFirst: false, instituteModal: this.state.institute, websiteModal: this.state.website, preWhatsAppMobNoModal: this.state.preWhatsAppMobNo, preMobNoModal: this.state.preMobNo, whatsAppMobNoModal: this.state.whatsAppMobNoModal, instituteErrModal: '', countryIdModal: this.state.countryId, isModalEdit: false, activeModalStep: 1, regStateModal: this.state.regState, cityModal: this.state.city, pincodeModal: this.state.pincode }, () => {
                                this.setState({
                                    isOpenDropDownState: false,
                                    focusedIndexState: -1,
                                    isOpenDropDownStateModal: false,
                                    focusedIndexStateModal: -1,

                                    isOpenDropDownCity: false,
                                    focusedIndexCity: -1,
                                    isOpenDropDownCityModal: false,
                                    focusedIndexCityModal: -1,

                                    isOpenDropDownPin: false,
                                    focusedIndexPin: -1,
                                    isOpenDropDownPinModal: false,
                                    focusedIndexPinModal: -1,
                                })
                            })
                        } else {
                            toastError("please enter Coordinator Details details")
                        }
                    } else if (status == 'Coordinator') {
                        this.setState({
                            isOpenDropDownState: false,
                            focusedIndexState: -1,
                            isOpenDropDownStateModal: false,
                            focusedIndexStateModal: -1,

                            isOpenDropDownCity: false,
                            focusedIndexCity: -1,
                            isOpenDropDownCityModal: false,
                            focusedIndexCityModal: -1,

                            isOpenDropDownPin: false,
                            focusedIndexPin: -1,
                            isOpenDropDownPinModal: false,
                            focusedIndexPinModal: -1,
                        }, () => {
                            this.handleEditGroup(status)
                        })
                    } else {
                        if (coVisitFlag) {
                            if (status == 1) {
                                this.setState({ isCoordinatorVisit: true })
                            }
                            this.setState({ isOpen: !isOpen, isModalEdit: false, activeModalStep: 1, instituteModal: this.state.institute, websiteModal: this.state.website, preWhatsAppMobNoModal: this.state.preWhatsAppMobNo, preMobNoModal: this.state.preMobNo, whatsAppMobNoModal: this.state.whatsAppMobNoModal, instituteErrModal: '', isOpen2: false, countryIdModal: this.state.countryId, regStateModal: this.state.regState, cityModal: this.state.city, pincodeModal: this.state.pincode }, () => {
                                this.setState({
                                    isOpenDropDownState: false,
                                    focusedIndexState: -1,
                                    isOpenDropDownStateModal: false,
                                    focusedIndexStateModal: -1,

                                    isOpenDropDownCity: false,
                                    focusedIndexCity: -1,
                                    isOpenDropDownCityModal: false,
                                    focusedIndexCityModal: -1,

                                    isOpenDropDownPin: false,
                                    focusedIndexPin: -1,
                                    isOpenDropDownPinModal: false,
                                    focusedIndexPinModal: -1,
                                })
                            })
                            // if (isFirst) {
                            //     this.setState({ isOpen2: true, isFirst: false })
                            // }
                        } else {
                            toastError("please enter Coordinator Details details")
                        }
                    }
                } else {
                    toastError("please enter Mandatory details")
                }
            } else {
                toastError("please enter Mandatory details")
            }
            console.log(this.state.daysList, this.state.daysModalList)
        })
    }

    // toggleModel2() {
    //     const { isOpen, isFirst } = this.state
    //     this.setState({ isOpen: !isOpen, instituteModal: this.state.institute, websiteModal: this.state.website, preWhatsAppMobNoModal: this.state.preWhatsAppMobNo, preMobNoModal: this.state.preMobNo, whatsAppMobNoModal: this.state.whatsAppMobNoModal, instituteErrModal: '' })
    //     if (isFirst) {
    //         this.setState({ isOpen2: true, isFirst: false })
    //     }
    // }
    handleDelete(e) {
        e.preventDefault()
        const { isOpen3, docDelAccountID, docDelExhVisitorID, ExhVisitorIDModal, GroupDetailsList, AccountIDModal, modalID, PassportFileCoordinator, PassportFileNameCoordinator, PassportFileTypeCoordinator, isPassportFilePresentCoordinator, PassportFilePathCoordinator, visitorGroupList } = this.state
        this.setState({ isLoading: true })
        this.props.delVisaDoc_action(AccountIDModal, ExhVisitorIDModal)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Passport Document Deleted SuccessFully")
                    // sessionStorage.getItem('VisitorTypeID') == 1 && this.setState({ passportFile: "", passPortFileName: "", isPassportFilePresent: false })
                    if (modalID == 'Coordinator') {
                        this.setState({ PassportFileCoordinator: '', isVisaAppliedCoordinator: false, PassportFileTypeCoordinator: '', PassportFileNameCoordinator: '', isPassportFilePresentCoordinator: false, PassportFilePathCoordinator: '' })
                    } else {
                        GroupDetailsList.map(item => {
                            console.log(AccountIDModal, item, item.AccountID)
                            if (item.AccountID == AccountIDModal) {
                                item.PassportFile = ''
                                item.PassportFileType = ''
                                item.PassportFileName = ''
                                item.PassportFilePath = ''
                                item.isPassportFilePresent = false
                                item.isVisaApplied = false
                            }
                        })
                    }
                    this.setState({ isLoading: false, isOpen3: !isOpen3, passportFile: '', passportFileType: '', isVisaApplied: false, passPortFileName: '', isPassportFilePresent: false, passportFilePath: '' })
                    // sessionStorage.getItem('VisitorTypeID') == 2 && this.setState({ visitorGroupList: visitorGroupList })
                    // this.getVisitorRegistrationDetails()
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    // On Select Interests
    onSelectInterest(e) {
        const { interestListModal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        console.log(code, checked)
        interestListModal.length > 0 && interestListModal.map((data) => {
            if (checked) {

                if (code == data.AreaofInterestID) {
                    data.isSelect = true
                    if (code == 1) {
                        this.setState({
                            isInterstOne: true
                        })
                    } else if (code == 2) {
                        this.setState({ isInterestTwo: true })
                    }

                }
            }
            else {
                if (code == data.AreaofInterestID) {
                    data.isSelect = false
                    if (code == 1) {
                        this.setState({
                            isInterstOne: false
                        })
                    } else if (code == 2) {
                        this.setState({ isInterestTwo: false })
                    }
                }
            }
        })
        console.log("hgdddhdjdjdjdkdj", interestListModal)
        this.setState({ interestListModal: interestListModal })
    }

    onFileClick() {
        // this.toggleModal()
        const url = "images/B2BEXHIBITOR.pdf"
        window.open(url, "_blank");
    }

    handlePrefTime(e) {
        const prefTiming = e.target.value;
        if (prefTiming >= '10:00' && prefTiming <= '18:00') {
            this.setState({ prefTimeModal: prefTiming, preffTimeErrModal: '', });
        } else {
            toastError('Preferred time must be between 10:00 and 18:00')
        }
    }

    // onCheckedSeminar(e, id) {
    //     const { seminarInterestListModal } = this.state
    //     const checked = e.target.checked
    //     seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
    //         if (data.SeminarID == id) {
    //             if (checked) {
    //                 data.isSelect = true
    //             } else {
    //                 data.isSelect = false
    //             }
    //         }
    //     })
    //     console.log("aaaaaaaaaaa", seminarInterestListModal)
    //     this.setState({ seminarInterestListModal: seminarInterestListModal })
    // }

    onCheckedSeminar(e, id) {
        const { seminarInterestListModal } = this.state
        const checked = e.target.checked
        if (checked != undefined) {
            seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
                if (data.SeminarID == id) {
                    if (checked) {
                        data.isSelect = true
                        var isIncluded = false
                        this.state.daysModalList.map((data2) => {
                            if (data2.isSelect) {
                                if (data2.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                    isIncluded = true
                                }
                            }
                        })
                        // setTimeout(() => {
                        if (!isIncluded) {
                            this.setState({ toShowExtraDaysinPop: true, ChargesPop: true })
                        } else {
                            this.setState({ toShowExtraDaysinPop: false, ChargesPop: data.SeminarTypeID == 3 ? true : false })
                        }
                        // }, 0);
                    } else {
                        data.isSelect = false
                        this.setState({ toShowExtraDaysinPop: false })
                    }
                    if (data.SeminarTypeID != 3) {
                        this.setState({ TotalPayable: '' })
                    }
                }
            })
        } else {
            seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
                if (data.SeminarID == id) {
                    if (data.isSelect) {
                        data.isSelect = false
                        this.setState({ toShowExtraDaysinPop: false })
                    } else {
                        data.isSelect = true
                        var isIncluded = false
                        this.state.daysModalList.map((data2) => {
                            if (data2.isSelect) {
                                if (data2.VisitDate == moment.utc(data.Date).format("DD MMM YYYY")) {
                                    isIncluded = true
                                }
                            }
                        })
                        // setTimeout(() => {
                        if (!isIncluded) {
                            this.setState({ toShowExtraDaysinPop: true, ChargesPop: true })
                        } else {
                            this.setState({ toShowExtraDaysinPop: false, ChargesPop: data.SeminarTypeID == 3 ? true : false })
                        }
                        // }, 5);
                    }
                    if (data.SeminarTypeID != 3) {
                        this.setState({ TotalPayable: '' })
                    }
                }
            })
        }
        console.log("aaaaaaaaaaa", e.target.checked, seminarInterestListModal)
        this.setState({})
    }


    handleDeleteVisitor() {
        const { GroupDetailsList, AccountIDModal, AccountID, deleteID, ExhVisitorID, ExhVisitorIDModal } = this.state
        // this.setState({ isLoading: true })
        // this.props.deleteVisitor_action(AccountIDModal, ExhVisitorIDModal)
        //     .then((data) => {
        //         if (data.error != 1) {
        //             var id = ''
        //             GroupDetailsList.length > 0 && GroupDetailsList.map((item, i) => {
        //                 if (item.AccountID == AccountIDModal) id = i
        //             })
        //             GroupDetailsList.splice(id, 1)
        //             this.setState({ GroupDetailsList: GroupDetailsList, isOpen5: false })
        //             this.setState({ isLoading: false })
        //         }
        //     })

        // const { GroupDetailsList, AccountIDModal, DelegateRegistrationIDModal, deleteID } = this.state
        if (GroupDetailsList[deleteID - 1].AccountID != '' && GroupDetailsList[deleteID - 1].AccountID != null && GroupDetailsList[deleteID - 1].ExhVisitorID != '' && GroupDetailsList[deleteID - 1].ExhVisitorID != null) {
            this.setState({ isLoading: true })
            this.props.deleteVisitor_action(AccountIDModal, ExhVisitorIDModal)
                .then((data) => {
                    if (data.error != 1) {
                        var id = ''
                        GroupDetailsList.length > 0 && GroupDetailsList.map((item, i) => {
                            if (item.AccountID == AccountIDModal) id = i
                        })
                        GroupDetailsList.splice(id, 1)
                        this.setState({ GroupDetailsList: GroupDetailsList, isOpen5: false })
                        this.setState({ isLoading: false })
                    }
                })
        } else {
            GroupDetailsList.splice(deleteID - 1, 1)
            this.setState({ GroupDetailsList: GroupDetailsList, isOpen5: false })
        }
    }

    // componentDidUpdate(prevProps, prevState) {
    //     const { isOpen, isOpen2, isOpen3, isOpen4 } = this.state
    //     // When modal opens, disable scroll on body
    //     if ((isOpen || isOpen2 || isOpen3 || isOpen4) && !(prevState.isOpen || prevState.isOpen2 || prevState.isOpen3 || prevState.isOpen4)) {
    //         document.body.classList.add('no-scroll');
    //     }

    //     // When modal closes, enable scroll on body
    //     if (!(isOpen || isOpen2 || isOpen3 || isOpen4) && (prevState.isOpen || prevState.isOpen2 || prevState.isOpen3 || prevState.isOpen4)) {
    //         document.body.classList.remove('no-scroll');
    //     }
    // }

    handleSearchChange = (event, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ regState: event.target.value, isOpenDropDownState: event.target.value.length > 0, tempStateList: this.filterItems(event.target.value, mode, status), focusedIndexState: -1, regStateErr: '' });
            }
            else if (status == 1) {
                console.log(event, 'event')
                this.setState({ regStateModal: event.target.value, isOpenDropDownStateModal: event.target.value.length > 0, tempStateListModal: this.filterItems(event.target.value, mode, status), focusedIndexStateModal: -1, regStateErrModal: '' });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: event.target.value, isOpenDropDownCity: event.target.value.length > 0, tempCityList: this.filterItems(event.target.value, mode, status), focusedIndexCity: -1, cityErr: '' });
            }
            else if (status == 1) {
                this.setState({ cityModal: event.target.value, isOpenDropDownCityModal: event.target.value.length > 0, tempCityListModal: this.filterItems(event.target.value, mode, status), focusedIndexCityModal: -1, cityErrModal: '' });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: event.target.value, isOpenDropDownPin: event.target.value.length > 0, tempPincodeList: this.filterItems(event.target.value, mode, status), focusedIndexPin: -1, pincodeErr: '' });
            }
            else if (status == 1) {
                this.setState({ pincodeModal: event.target.value, isOpenDropDownPinModal: event.target.value.length > 0, tempPincodeListModal: this.filterItems(event.target.value, mode, status), focusedIndexPinModal: -1, pincodeErrModal: '' });
            }
        }
    };

    filterItems = (searchTerm, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                console.log('this.state.stateListModal', this.state.stateListModal)
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 1) {
            if (status == 0) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 2) {
            if (status == 0) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        }
    };

    // Handle selecting an option from the dropdown
    handleSelect = (option, mode, status) => {
        console.log(option)
        if (mode == 0) {
            if (status == 0) {
                this.setState({ regState: option.Description, focusedIndexState: -1, tempStateList: [], isOpenDropDownState: false, }, () => {
                    // this.callStateList(option.Description, option.Code)
                });
            } else if (status == 1) {
                this.setState({ regStateModal: option.Description, focusedIndexStateModal: -1, tempCityListModal: [], isOpenDropDownStateModal: false, });
                // this.callStateListModal(option.Description, option.Code)

            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: option.Description, focusedIndexCity: -1, tempCityList: [], isOpenDropDownCity: false, });
            } else if (status == 1) {
                this.setState({ cityModal: option.Description, focusedIndexCityModal: -1, tempStateListModal: [], isOpenDropDownCityModal: false, });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: option.Pincode, focusedIndexPin: -1, tempCityList: [], isOpenDropDownPin: false, });
            } else if (status == 1) {
                this.setState({ pincodeModal: option.Pincode, focusedIndexPinModal: -1, tempCityListModal: [], isOpenDropDownPinModal: false, });
            }
        }
    };

    handleKeyDown = (e, mode, status) => {
        const { focusedIndexState, tempPincodeList, tempPincodeListModal, focusedIndexPin, focusedIndexPinModal, tempStateList, focusedIndexStateModal, tempStateListModal, tempCityList, focusedIndexCity, focusedIndexCityModal, tempCityListModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexState: Math.min(focusedIndexState + 1, tempStateList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexState: Math.max(focusedIndexState - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexState >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempStateList[focusedIndexState], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    console.log(tempStateListModal.length)
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexStateModal: Math.min(focusedIndexStateModal + 1, tempStateListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexStateModal: Math.max(focusedIndexStateModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexStateModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempStateListModal[focusedIndexStateModal], mode, status);
                }
            }
        } else if (mode == 1) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexCity: Math.min(focusedIndexCity + 1, tempCityList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexCity: Math.max(focusedIndexCity - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCity >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempCityList[focusedIndexCity], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexCityModal: Math.min(focusedIndexCityModal + 1, tempCityListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexCityModal: Math.max(focusedIndexCityModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCityModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempCityListModal[focusedIndexCityModal], mode, status);
                }
            }
        } else if (mode == 2) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexPin: Math.min(focusedIndexPin + 1, tempPincodeList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexPin: Math.max(focusedIndexPin - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPin >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempPincodeList[focusedIndexPin], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    // Move focus down
                    this.setState({
                        focusedIndexPinModal: Math.min(focusedIndexPinModal + 1, tempPincodeListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    // Move focus up
                    this.setState({
                        focusedIndexPinModal: Math.max(focusedIndexPinModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPinModal >= 0) {
                    // Select the focused item when Enter is pressed
                    this.handleSelect(tempPincodeListModal[focusedIndexPinModal], mode, status);
                }
            }
        }
    };

    handleHover = (index, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ focusedIndexState: index });
            } else if (status == 1) {
                this.setState({ focusedIndexStateModal: index });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ focusedIndexCity: index });
            } else if (status == 1) {
                this.setState({ focusedIndexCityModal: index });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ focusedIndexPin: index });
            } else if (status == 1) {
                this.setState({ focusedIndexPinModal: index });
            }
        }
    };

    scrollIntoView = (mode, status) => {
        // console.log(mode, status)
        const { focusedIndexState, focusedIndexStateModal, focusedIndexPin, focusedIndexPinModal, focusedIndexCity, focusedIndexCityModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexState];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexStateModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom < dropdownBottom) {
                //     dropdownMenu.scrollTop =-50;
                //     console.log(dropdownMenu.scrollTop )
                // }
                // else if (itemTop > dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexStateModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 1) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexCity];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexCityModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom > dropdownBottom) {
                //     dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                // }
                // else if (itemTop < dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexCityModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 2) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexPin];
                if (!focusedItem) return;

                // Scroll the dropdown menu if the focused item is not fully visible
                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;
                console.log('+++++++++++++++++++++++++++++x')
                console.log(dropdownTop)
                console.log(dropdownBottom)
                console.log(itemTop)
                console.log(itemBottom)
                console.log(menuTop)
                console.log(menuHeight)

                // Check if the focused item is outside the visible area and adjust the scroll
                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                // const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                // if (!dropdownMenu) return;

                // const focusedItem = dropdownMenu.children[focusedIndexPinModal];
                // if (!focusedItem) return;

                // // Scroll the dropdown menu if the focused item is not fully visible
                // const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                // const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                // const itemTop = focusedItem.getBoundingClientRect().top;
                // const itemBottom = focusedItem.getBoundingClientRect().bottom;
                // const menuTop = dropdownMenu.scrollTop;
                // const menuHeight = dropdownMenu.offsetHeight;
                // console.log('+++++++++++++++++++++++++++++x')
                // console.log(dropdownTop)
                // console.log(dropdownBottom)
                // console.log(itemTop)
                // console.log(itemBottom)
                // console.log(menuTop)
                // console.log(menuHeight)

                // // Check if the focused item is outside the visible area and adjust the scroll
                // if (itemBottom > dropdownBottom) {
                //     dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                // }
                // else if (itemTop < dropdownTop) {
                //     dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                // }

                const dropdownMenu = document.querySelector('.modal .dropdown-menu');
                // if (!dropdownMenu || focusedIndexStateModal < 0 || !tempList[focusedIndexStateModal]) return;

                const focusedItem = dropdownMenu.children[focusedIndexPinModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                // Calculate the offsets relative to the modal
                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;

                // Optional: Debugging output to help you visualize the position values
                console.log('dropdownTop:', dropdownTop);
                console.log('dropdownBottom:', dropdownBottom);
                console.log('itemTop:', itemTop);
                console.log('itemBottom:', itemBottom);
                console.log('menuTop:', menuTop);

                setTimeout(() => {
                    // Check if the focused item is outside the visible area and adjust the scroll
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        }
    };

    onStep2Click() {
        const { GroupDetailsList, isOtherPreNameModal, otherNameModal, emailErrModal, firstNameModal, firstNameErrModal, prenameModal, middleNameModal, lastNameModal, lastNameErrModal, designationModal, designationErrModal, other, otherName, instituteModal, instituteErrModal, mobNoModal, mobNoErrModal, preMobNoModal, whatsAppMobNoModal, whatsAppMobNoErrModal, preWhatsAppMobNoModal, isSameAsMobNoModal, pincodeModal, pincodeErrModal, regStateModal, modalID, regStateErrModal, cityModal, cityErrModal, websiteModal, daysModalList, isInterestTwo, isInterstOne, emailModal, telNoModal, level2, level0, level3, level4, primaryChapterListData, chapterErr, chapterList, ChapterHallErr, isGrpDelegation, leader, leaderErr, delegationCountry, isDisplayDelegationCountryList, delegationCountryErr, arrivalDate, departureDate, arrivalDateErr, departureDateErr, delegationRemarkErr, delegationRemark, passCountry, passCountryErr, passCountryList, passDate, passDateErr, passExipryDate, passExipryDateErr, passName, passNameErr, passNo, passNoErr, passPortFileName, passportFile, passportFileErr, passportFilePath, passportFileType, isCoordinatorVisit, isDisplayPassCountryList, isFirst, isModalEdit, isOpen2, isOtherOpen, isPassportFilePresent, isVisaApplied, needVisaAssistance, AccountID, activeModalStep, applicantEmail, applicantEmailErr, applicantMobNo, applicantMobNoErr, preApplicantMobNo, primaryChapterListLevel3, primaryChapterListLevel4, daysModalErr, preTelNoModal, tel1NoModal, preTel1NoModal, countryId, countryIdModal, seminarInterestListModal, tempObj, email } = this.state
        // if (status == 1) {
        console.log(".......................................................")
        this.inputValidateGroup()
        var emailErr = false
        // !isModalEdit && !this.state.modalStep2 && GroupDetailsList.length > 0 && GroupDetailsList.map(item => {
        //     if (item.email == emailModal) {
        //         toastError("Please enter different email")
        //         emailErr = true
        //     }
        // })
        // if (email == emailModal) {
        //     emailErr = true
        // }
        var daysListValidation = false
        for (var i = 0; i < this.state.daysModalList.length; i++) {
            if (this.state.daysModalList[i].isSelect == true) {
                daysListValidation = true
            }
        }
        // preparing Selected Days for udt
        var selectedDays = []
        // selectedDays = daysList.filter(data => data.isSelect == true)
        selectedDays = daysModalList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        console.log(GroupDetailsList, "lplp", firstNameModal, instituteModal, lastNameModal, mobNoModal, whatsAppMobNoModal, pincodeModal, regStateModal, cityModal, designationModal, emailModal, list)
        var modalErr = true
        setTimeout(() => {
            if (list.length == 0) {
                this.setState({ daysModalErr: "Please select visit days" });
                modalErr = false
            }
            if (firstNameModal == "") {
                this.setState({ firstNameErrModal: "Please enter first name" });
                modalErr = false
            }
            if (lastNameModal == "") {
                this.setState({ lastNameErrModal: "Please enter last name" });
                modalErr = false
            }
            if (designationModal == "") {
                this.setState({ designationErrModal: "Please enter designation" });
                modalErr = false
            }
            if (instituteModal == "") {
                this.setState({ instituteErrModal: "Please enter institue/Organization" });
                modalErr = false
            }
            if (mobNoModal == "") {
                this.setState({ mobNoErrModal: "Please enter mobile no" });
                modalErr = false
            }
            if (whatsAppMobNoModal == "") {
                this.setState({ whatsAppMobNoErrModal: "Please enter whatsapp no" });
                modalErr = false
            }
            if (countryIdModal == "") {
                this.setState({ countryIdErrModal: "Please select Country" });
                modalErr = false
            }
            // if (photoFile == "") {
            //     this.setState({ photoFileErr: "Please upload photo" });
            // }
            // if (photoIdFile == "") {
            //     this.setState({ photoIdFileErr: "Please upload photo ID" });
            // }
            if (regStateModal == "" && countryIdModal == "91") {
                this.setState({ regStateErrModal: "Please enter province/state" });
                modalErr = false
            }
            if (cityModal == "") {
                this.setState({ cityErrModal: "Please enter city" });
                modalErr = false
            }
            if (pincodeModal == "") {
                this.setState({ pincodeErrModal: "Please enter Pincode" });
                modalErr = false
            }
            if (emailModal == "") {
                this.setState({ emailErrModal: "Please enter Email" });
                modalErr = false
            }
            if (emailModal != "") {
                var emailError = emailValidator(emailModal)
                if (emailError != '') {
                    this.setState({ emailErrModal: emailError })
                    modalErr = false
                    // return
                }
            }
            if (modalErr && !emailErrModal) {
                var emailError = emailValidator(emailModal)
                if (emailError != '') {
                    return
                } else {
                    if (!emailErr) {
                        if (!this.state.isModalEdit && !this.state.modalStep2) {
                            var obj = {
                                'Title': isOtherPreNameModal ? otherNameModal : prenameModal,
                                'firstName': firstNameModal,
                                'middleName': middleNameModal,
                                'lastName': lastNameModal,
                                'institute': instituteModal,
                                'isOtherPreName': isOtherPreNameModal,
                                'otherName': otherNameModal,
                                'designation': designationModal,
                                'mobNo': preMobNoModal != '' && preMobNoModal != null ? `${preMobNoModal}-${mobNoModal}` : mobNoModal,
                                'whatsAppMobNo': preWhatsAppMobNoModal != '' && preWhatsAppMobNoModal != null ? `${preWhatsAppMobNoModal}-${whatsAppMobNoModal}` : whatsAppMobNoModal,
                                'pincode': pincodeModal,
                                'countryId': countryIdModal,
                                'regState': regStateModal,
                                'isSameAsMobNo': isSameAsMobNoModal,
                                'city': cityModal,
                                'website': websiteModal,
                                'AccountID': null,
                                'ExhVisitorID': null,
                                'email': emailModal,
                                'telNo': preTelNoModal != '' && preTelNoModal != null ? `${preTelNoModal}-${telNoModal}` : telNoModal,
                                'tel1No': preTel1NoModal != '' && preTel1NoModal != null ? `${preTel1NoModal}-${tel1NoModal}` : tel1NoModal,
                                'id': GroupDetailsList.length + 1,
                                'isCoordinator': false,
                                'isVisit': true,
                                'DateArr': list,

                            }
                            // GroupDetailsList.push(obj)
                            this.setState({ activeModalStep: 2, modalStep2: true, tempObj: obj, preApplicantMobNo: preMobNoModal, applicantMobNo: mobNoModal, applicantEmail: emailModal, leader: this.state.DelegationNameCoordinator, delegationRemark: this.state.DelegationRemarkCoordinator, departureDate: this.state.DelegationDepartureDateCoordinator, arrivalDate: this.state.DelegationArrivalDateCoordinator, delegationCountry: this.state.DelegationCountryIDCoordinator })
                            // this.setState({
                            //     isOtherPreNameModal: false, otherNameModal: '', emailErrModal: '', firstNameModal: '', firstNameErrModal: '', prenameModal: '', middleNameModal: '', lastNameModal: '', lastNameErrModal: '', designationModal: '', designationErrModal: '', instituteModal: '', instituteErrModal: '', mobNoModal: '', mobNoErrModal: '', preMobNoModal: '', whatsAppMobNoModal: '', whatsAppMobNoErrModal: '', preWhatsAppMobNoModal: '', isSameAsMobNoModal: false, pincodeModal: '', pincodeErrModal: '', regStateModal: '', regStateErrModal: '', cityModal: '', cityErrModal: '', websiteModal: '', emailModal: '', telNoModal: '', preTelNoModal: '', tel1NoModal: '', preTel1NoModal: '', isOpen: false
                            // })
                            // setTimeout(() => {
                            //     toastSuccess("visitor added successfully")
                            // }, 200);


                        } else {
                            if (this.state.modalID == 'Coordinator') {
                                this.setState({
                                    preName: isOtherPreNameModal ? otherNameModal : prenameModal,
                                    firstName: firstNameModal,
                                    middleName: middleNameModal,
                                    lastName: lastNameModal,
                                    institute: instituteModal,
                                    isOtherPreName: isOtherPreNameModal,
                                    otherName: otherNameModal,
                                    designation: designationModal,
                                    mobNo: mobNoModal,
                                    whatsAppMobNo: whatsAppMobNoModal,
                                    pincode: pincodeModal,
                                    regState: regStateModal,
                                    countryId: countryIdModal,
                                    isSameAsMobNo: isSameAsMobNoModal,
                                    city: cityModal,
                                    website: websiteModal,
                                    email: emailModal,
                                    telNo: telNoModal,
                                    tel1No: tel1NoModal,
                                    DateArrCoordinator: list
                                })
                                this.state.daysList.map(element => {
                                    element.isSelect = false
                                })
                                console.log('....', this.state.daysList, list)
                                for (var i = 0; i < list.length; i++) {
                                    for (var j = 0; j < this.state.daysList.length; j++) {
                                        // console.log(this.state.daysList[j].VisitDate, list[i].visitDay)
                                        if (this.state.daysList[j].VisitDate == list[i].visitDay) {
                                            console.log('ttt')
                                            this.state.daysList[j].isSelect = true
                                        }
                                    }
                                }
                            }
                            GroupDetailsList.length > 0 && GroupDetailsList.map((item, index) => {
                                if (this.state.modalID == index && this.state.modalID != 'Coordinator') {
                                    GroupDetailsList[index].Title = isOtherPreNameModal ? otherNameModal : prenameModal
                                    GroupDetailsList[index].firstName = firstNameModal
                                    GroupDetailsList[index].middleName = middleNameModal
                                    GroupDetailsList[index].lastName = lastNameModal
                                    GroupDetailsList[index].institute = instituteModal
                                    GroupDetailsList[index].isOtherPreName = isOtherPreNameModal
                                    GroupDetailsList[index].otherName = otherNameModal
                                    GroupDetailsList[index].designation = designationModal
                                    GroupDetailsList[index].mobNo = preMobNoModal != '' && preMobNoModal != null ? `${preMobNoModal}-${mobNoModal}` : mobNoModal
                                    GroupDetailsList[index].whatsAppMobNo = preWhatsAppMobNoModal != '' && preWhatsAppMobNoModal != null ? `${preWhatsAppMobNoModal}-${whatsAppMobNoModal}` : whatsAppMobNoModal
                                    GroupDetailsList[index].pincode = pincodeModal
                                    GroupDetailsList[index].regState = regStateModal
                                    GroupDetailsList[index].countryId = countryIdModal
                                    GroupDetailsList[index].isSameAsMobNo = isSameAsMobNoModal
                                    GroupDetailsList[index].city = cityModal
                                    GroupDetailsList[index].website = websiteModal
                                    GroupDetailsList[index].email = emailModal
                                    GroupDetailsList[index].telNo = preTelNoModal != '' && preTelNoModal != null ? `${preTelNoModal}-${telNoModal}` : telNoModal
                                    GroupDetailsList[index].tel1No = preTel1NoModal != '' && preTel1NoModal != null ? `${preTel1NoModal}-${tel1NoModal}` : tel1NoModal
                                    GroupDetailsList[index].DateArr = list
                                } else {

                                }
                            })
                            this.setState({ activeModalStep: 2, GroupDetailsList: GroupDetailsList })

                            // this.setState({
                            //     isOtherPreNameModal: false, otherNameModal: '', emailErrModal: '', firstNameModal: '', firstNameErrModal: '', prenameModal: '', middleNameModal: '', lastNameModal: '', lastNameErrModal: '', designationModal: '', designationErrModal: '', instituteModal: '', instituteErrModal: '', mobNoModal: '', mobNoErrModal: '', preMobNoModal: '', whatsAppMobNoModal: '', whatsAppMobNoErrModal: '', preWhatsAppMobNoModal: '', isSameAsMobNoModal: false, pincodeModal: '', pincodeErrModal: '', regStateModal: '', regStateErrModal: '', cityModal: '', cityErrModal: '', websiteModal: '', emailModal: '', telNoModal: '', preTelNoModal: '', tel1NoModal: '', preTel1NoModal: '', isOpen: false, GroupDetailsList: GroupDetailsList, isModalEdit: false
                            // })
                            // setTimeout(() => {
                            //     toastSuccess("visitor update successfully")
                            // }, 200);
                        }
                    } else {
                        toastError("Please enter different email")
                    }
                }
            } else {
                toastError("Please enter mandatory fields")
                console.log("lplplllllllllllllllllllll")
            }
        }, 200);

        // }
    }

    onGSTchange(value) {
        const { GSTNo, GSTNoErr, gstValidtionList, regStateINV, stateIdINV, regState, stateId } = this.state
        var code = value
        console.log(code.length, 'rere', stateIdINV)
        if (code.length >= 2) {
            var code = value.slice(0, 2)
            console.log(code.length, gstValidtionList, 'rere')
            console.log('stateId', stateIdINV)
            for (var i = 0; i < gstValidtionList.length; i++) {
                if (stateIdINV != '' && stateIdINV != null) {
                    if (gstValidtionList[i].StateID == stateIdINV) {
                        const errMsg = gstNoValidator(value)
                        console.log("errMsg-->", errMsg)
                        if (errMsg != '') {
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            console.log("2--->",)
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else {
                            this.setState({
                                GSTNo: value,
                                GSTNoErr: ''
                            })
                        }
                    } else {
                        this.setState({
                            GSTNo: value,
                        });
                    }
                } else {
                    if (gstValidtionList[i].StateName.trim().toLowerCase() == regStateINV.trim().toLowerCase()) {
                        const errMsg = gstNoValidator(value)
                        console.log("errMsg-->", errMsg)
                        if (errMsg != '') {
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            console.log("2--->",)
                            this.setState({
                                GSTNoErr: "Please enter proper gst no",
                                GSTNo: value,
                                // GSTNo: ''
                            });
                        } else {
                            this.setState({
                                GSTNo: value,
                                GSTNoErr: ''
                            })
                        }
                    } else {
                        this.setState({
                            GSTNo: value,
                        });
                    }
                }
                // console.log(code, gstValidtionList[i].StateID, stateId, parseInt(gstValidtionList[i].GSTCode))
            }
        }
        else {
            this.setState({
                GSTNo: value,
            });
        }
    }

    checkStateName(value, flag) {
        const { isLoading, stateList } = this.state
        if (value == '' || value == undefined || value == null) {
            return
        }
        var isMatched = false
        for (var i = 0; i < stateList.length; i++) {
            if (stateList[i].Description.trim().toLowerCase() == value.trim().toLowerCase()) {
                isMatched = true
            }
        }
        if (!isMatched) {
            toastError("Please enter proper State")
            if (flag == 0) {
                this.setState({ regStateErr: "Please enter proper State" })
            } else if (flag == 1) {
                this.setState({ regStateINVErr: "Please enter proper State" })
            }
        }
    }

    checknoOfVisitDays(days) {
        const { isLoading, daysModalList } = this.state
        var toreturn = true
        for (var i = 0; i < daysModalList.length; i++) {
            if (daysModalList[i].VisitDays == days.length) {
                toreturn = false
                break
            }
        }
        return toreturn
    }
    calculateRowspan(data) {
        // Create a map to count children for each parent seminar
        const parentChildMap = {};

        // Initialize Rowspan for each item and count the children
        data.forEach(item => {
            item.Rowspan = 0; // Default Rowspan for all items

            if (item.ParentSeminarID !== null) {
                // Increment child count for the parent
                parentChildMap[item.ParentSeminarID] = (parentChildMap[item.ParentSeminarID] || 0) + 1;
            }
        });

        // Assign Rowspan to parent seminars
        data.forEach(item => {
            if (item.ParentSeminarID === null) {
                // If it's a parent, Rowspan is itself plus its children
                item.Rowspan = (parentChildMap[item.SeminarID] || 0) + 1;
            }
        });

        return data;
    }

    checkCorrespondence() {
        if (
            this.state.INVPersonName == this.state.firstName &&
            this.state.INVCompanyName == this.state.institute &&
            this.state.countryIdINV == this.state.countryId &&
            this.state.pincodeINV == this.state.pincode &&
            this.state.regStateINV == this.state.regState &&
            this.state.cityINV == this.state.city) {
            this.setState({ isSameAsAbove: true })
        } else {
            this.setState({ isSameAsAbove: false })
        }
    }
    render() {
        const { isLoading, isOpen4, country, countryList, countryId, daysList, firstName, middleName, lastName, preName, GroupDetailsList,
            isOtherPreName, otherName, gender, designation, institute, preMobNo, mobNo, preWhatsAppMobNo, whatsAppMobNo, pricingList,
            add1, add2, add3, pincode, city, regState, website, gstNo, panNo, email, preTelNo, telNo, tel1No, preTel1No,
            isDisplayPincodeList, isDisplayCityList, isDisplayStateList, isSameAsMobNo, vaccineCertificateFile, photoFile,
            photoIdFile, countryIdErr, attendeeTypeErr, cityErr, preMobNoErr, mobNoErr, regStateErr, designationErr, photoFileErr,
            lastNameErr, photoIdFileErr, genderErr, instituteErr, firstNameErr, isOpen, preWhatsAppMobNoErr, whatsAppMobNoErr, personalCountryId,
            personalCountry, isDisplayPersonalCountryList, personalCountryErr, attendeeList, attendeeTypeId, pincodeErr, emailErr, daysErr, isExhbitionClosed,
            isOtherPreNameModal, otherNameModal, emailErrModal, firstNameModal, firstNameErrModal, prenameModal, middleNameModal, lastNameModal, lastNameErrModal, designationModal, designationErrModal, instituteModal, instituteErrModal, mobNoModal, mobNoErrModal, preMobNoModal, whatsAppMobNoModal, whatsAppMobNoErrModal, preWhatsAppMobNoModal, isSameAsMobNoModal, pincodeModal, pincodeErrModal, regStateModal, regStateErrModal, cityModal, cityErrModal, websiteModal, emailModal, telNoModal, preTelNoModal, tel1NoModal, preTel1NoModal, tempCityList, tempGroupCityList, tempGroupPincodeList, tempGroupStateList, tempPersonalCountryList, tempPincodeList, tempStateList, isDataLoad, isDisplayGroupCityList, isDisplayGroupPersonalCountryList, isDisplayGroupPincodeList, isDisplayGroupStateList, preffDateModal, preffDateErrModal, prefTimeModal, preffTimeErrModal, b2bRemarkModal, b2bRemarkErrModal, level2, level0, level3, level4, primaryChapterListData, chapterErr, chapterList, ChapterHallErr,
            isGrpDelegation, leader, leaderErr, delegationCountry, isDisplayDelegationCountryList, delegationCountryErr, arrivalDate, departureDate, arrivalDateErr, departureDateErr, delegationRemarkErr, delegationRemark, isOpen3,
            INVPersonName, INVCompanyName, INVAddress, INVTanNo, GSTNo, PANNo, INVPersonNameErr, INVCompanyNameErr, INVAddressErr, INVTanNoErr, GSTNoErr, PANNoErr,
            passCountry, passCountryErr, passCountryList, passDate, passDateErr, passExipryDate, passExipryDateErr, passName, passNameErr, passNo, passNoErr, passPortFileName, passportFile, passportFileErr, passportFilePath, passportFileType, isCoordinatorVisit, isDisplayPassCountryList, isFirst, isModalEdit, isOpen2, isOtherOpen, isPassportFilePresent, isVisaApplied, needVisaAssistance, AccountID, activeModalStep, applicantEmail, applicantEmailErr, applicantMobNo, applicantMobNoErr, isregistrationLinkClosed, preApplicantMobNo, DATALOADEDIncomp, primaryChapterListLevel3, primaryChapterListLevel4, isExhibitionFree, countryIdINV, requestPop,
            pincodeINV, isInterestTwo, isInterestTwoCoordinator, isInterstOne, isInterstOneCoordinator, isInvoice, isOpen5, isOpenDropDownCity, isOpenDropDownCityModal, isOpenDropDownPin, isOpenDropDownPinModal, isOpenDropDownState, isOpenDropDownStateModal, isPassportFilePresentCoordinator, isShowIntrestList, isVisaAssistanceCoordinator,
            regStateINV,
            modalID,
            countryIdINVErr,
            pincodeINVErr, seminarInterestListModal,
            isDisplayPincodeListINV,
            isDisplayStateListINV,
            regStateINVErr, isOpenConfirmationModal,
            isDisplayCityListINV,
            cityINVErr,
            cityINV,
            eduRoleName, eduRoleNameModal,
            identityCardFile, identityCardFileType, identityCardFileErr, identityCardFileName, identityCardFilePath,
            identityCardFileModal, identityCardFileTypeModal, identityCardFileErrModal, identityCardFileNameModal, identityCardFilePathModal } = this.state

        const allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        const filerArray = allArray.filter((data) => data.IsCheckbox && data.IsSelect)


        var toShowEduRole = false
        attendeeList.length > 0 && attendeeList.map((data) => {
            if (data.AttendeeTypeName == "Education Sector & Others") {
                if (data.isChecked) {
                    toShowEduRole = true
                }
            }
        })

        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };

        console.log('modallllid', this.state.countryId, modalID)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {console.log('isopennn', (isOpen || isOpen2 || isOpen3 || isOpen4))}
                <ToastContainer />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {sessionStorage.getItem('VisitorDataSS') != null && JSON.parse(sessionStorage.getItem('DATALOADEDIncomp')) ? < VisitorHeader /> : this.state.isDataLoad && < VisitorHeader />}
                {sessionStorage.getItem('isVisitorRegistrationOpen') != null && sessionStorage.getItem('isVisitorRegistrationOpen') != 0 ?
                    <div
                        className="main-content app-content mt-0"
                        style={{ marginInlineStart: 0 }}
                    >
                        <div className="side-app">
                            <div className="container-fluid p-0">
                                <div className="row m-0">
                                    <div
                                        className="breadcrumb-scroll-fixed p-0"
                                    >
                                        <h6 className="mb-0 p-2 text-white">Visitor Registration form</h6>
                                    </div>
                                </div>
                            </div>
                            {console.log(this.state.interestListModal)}
                            {!isregistrationLinkClosed ? (
                                <div className="needs-validation after-step admin-top-space">
                                    <div id="Menu1">
                                        <div id="section-1">
                                            {/* <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg">
                                                            <p className="mb-0">Country</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-4 mb-3">
                                                <div className="d-flex">
                                                    <label className="mt-3 w-auto" >
                                                        Select Country
                                                        <span className="text-red">*</span>

                                                    </label>
                                                    {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{countryIdErr}</span>}
                                                </div>
                                                <select className="form-control" value={countryId}
                                                    onChange={(e) => this.onCountrySelect(e)}
                                                >
                                                    <option>Select Your Country</option>
                                                    {
                                                        countryList.length > 0 && countryList.map((data) => (
                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div> */}
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-0">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0 fw-semibold">
                                                                    Visitor Type <span className="text-red">*</span>
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.visitorTypeErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            this.state.visitorTypeList.length > 0 && this.state.visitorTypeList.map((data) => (
                                                                <div className="col-sm-5" key={data.VisitorTypeID}>
                                                                    <label className="d-flex">
                                                                        <input type="radio" name="vistorType" value={data.VisitorTypeID}
                                                                            checked={data.VisitorTypeID == this.state.VisitorTypeID}
                                                                            // onChange={e => this.setState({ attendeeType: "Business Visitor" })}
                                                                            onChange={(e) => this.setState({ VisitorTypeID: data.VisitorTypeID, GroupDetailsList: [], visitorTypeErr: '' })}
                                                                        />
                                                                        {data.VisitorType}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0 fw-semibold">
                                                                    Attendee Type <span className="text-red">*</span>
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{attendeeTypeErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            attendeeList.length > 0 && attendeeList.map((data) => (
                                                                <div className="col-sm-4" key={data.AttendeeTypeID}>
                                                                    <label className="d-flex">
                                                                        <input type="radio" name="attendeeType" value={data.AttendeeTypeID}
                                                                            checked={data.isChecked}
                                                                            // onChange={e => this.setState({ attendeeType: "Business Visitor" })}
                                                                            onChange={(e) => this.onAttendeeSelect(e)}
                                                                        />
                                                                        {data.AttendeeTypeName}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0 fw-semibold">{this.state.VisitorTypeID == 2 ? 'Coordinator Information' : 'Personal Information'}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.VisitorTypeID == 2 && <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-3">
                                                                <input type="checkbox" name="fav_language"
                                                                    value={this.state.isCoordinatorVisit} checked={this.state.isCoordinatorVisit}
                                                                    onClick={(e) => this.setState({ isCoordinatorVisit: !this.state.isCoordinatorVisit })}
                                                                />
                                                                is Coordinator Visiting?
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-xl-3 mt-3">
                                                            <label>
                                                                First Name <span className="text-red">*</span>
                                                            </label>

                                                            <div className="name-input-group">
                                                                {/* Prefix */}
                                                                <select
                                                                    className="form-control name-prefix"
                                                                    value={preName}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            preName: e.target.value,
                                                                            isOtherPreName: e.target.value === "Other",
                                                                            otherName: ""
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="Mr">Mr</option>
                                                                    <option value="Ms">Ms</option>
                                                                    <option value="DR">DR</option>
                                                                    <option value="Prof">Prof</option>
                                                                    <option value="Other">Other</option>
                                                                </select>

                                                                {/* Other prefix */}
                                                                {isOtherPreName && (
                                                                    <input
                                                                        type="text"
                                                                        className="form-control name-other"
                                                                        maxLength="40"
                                                                        placeholder="Other"
                                                                        value={otherName}
                                                                        onChange={(e) =>
                                                                            this.setState({ otherName: e.target.value })
                                                                        }
                                                                    />
                                                                )}

                                                                {/* First name */}
                                                                <input
                                                                    type="text"
                                                                    className="form-control name-no"
                                                                    maxLength="50"
                                                                    placeholder="First Name"
                                                                    value={firstName}
                                                                    onChange={(e) =>
                                                                        this.setState({ firstName: e.target.value, firstNameErr: "" })
                                                                    }
                                                                />
                                                            </div>

                                                            {firstNameErr && (
                                                                <span className="text-danger d-block">{firstNameErr}</span>
                                                            )}
                                                        </div>

                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Middle Name</label>
                                                            <input type="text" className="form-control" value={middleName}
                                                                maxLength={'50'}
                                                                onChange={(e) => this.setState({ middleName: e.target.value })}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Last Name
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={lastName} maxLength={'50'}
                                                                onChange={(e) => this.setState({ lastName: e.target.value, lastNameErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{lastNameErr}</span>}
                                                        </div>

                                                        <div className="col-xl-3">
                                                            <div className="d-flex">
                                                                <label className="mt-3 w-auto" >
                                                                    Select Country
                                                                    <span className="text-red">*</span>

                                                                </label>
                                                                {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{countryIdErr}</span>}
                                                            </div>
                                                            <select className="form-control" value={countryId}
                                                                onChange={(e) => this.onCountrySelect(e)}
                                                            >
                                                                <option value={''}>Select Your Country</option>
                                                                {
                                                                    countryList.length > 0 && countryList.map((data) => (
                                                                        <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row">

                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                Institute/Organisation <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={institute} maxLength={'500'}
                                                                onChange={(e) => this.setState({ institute: e.target.value, instituteErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{instituteErr}</span>}

                                                        </div>
                                                        <div className="col-sm-3 mt-2">
                                                            <label className="d-flex">
                                                                Mobile No <span className="rad-star text-danger">*</span>
                                                            </label>

                                                            <div className="phone-input-group">
                                                                {/* ISD */}
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off" readOnly
                                                                    placeholder="ISD"
                                                                    maxLength={'4'}
                                                                    value={preMobNo}
                                                                />

                                                                {/* Mobile number */}
                                                                <input
                                                                    type="tel"
                                                                    className="form-control phone-no"
                                                                    placeholder="Mobile No"
                                                                    value={mobNo}
                                                                    maxLength="10"
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) =>
                                                                        e.target.value >= 0 &&
                                                                        this.setState({ mobNo: e.target.value, mobNoErr: "" })
                                                                    }
                                                                />
                                                            </div>

                                                            {mobNoErr && (
                                                                <span className="text-danger d-block mt-1">{mobNoErr}</span>
                                                            )}
                                                        </div>

                                                        <div className="col-sm-3 mt-2">
                                                            <label className="d-flex">
                                                                WhatsApp Mobile No <span className="rad-star text-danger">*</span>
                                                            </label>

                                                            <div className="phone-input-group">
                                                                {/* ISD */}
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off" readOnly
                                                                    placeholder="ISD"
                                                                    maxLength={'4'}
                                                                    value={preWhatsAppMobNo}
                                                                />

                                                                {/* WhatsApp Number */}
                                                                <input
                                                                    type="tel"
                                                                    className="form-control phone-no"
                                                                    placeholder="WhatsApp Mobile No"
                                                                    value={whatsAppMobNo}
                                                                    maxLength="10"
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) =>
                                                                        e.target.value >= 0 &&
                                                                        this.setState({
                                                                            whatsAppMobNo: e.target.value,
                                                                            whatsAppMobNoErr: ""
                                                                        })
                                                                    }
                                                                />
                                                            </div>

                                                            {whatsAppMobNoErr && (
                                                                <span className="text-danger d-block mt-1">
                                                                    {whatsAppMobNoErr}
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-6">
                                                                <input type="checkbox" name="fav_language"
                                                                    value={isSameAsMobNo} checked={isSameAsMobNo}
                                                                    onClick={(e) => this.onSameAsMobNoClick(e)}
                                                                />
                                                                Same as Mobile No
                                                            </label>
                                                        </div>
                                                        {toShowEduRole && <div className="col-xl-3">
                                                            <div className="d-flex">
                                                                <label className="w-auto mt-2" >
                                                                    Education Role
                                                                    <span className="text-red">*</span>

                                                                </label>

                                                            </div>
                                                            <select className="form-control" value={this.state.educationRoleTypeId}
                                                                onChange={(e) => this.onEduRoleSelect(e)}
                                                            >
                                                                <option value={''}>Select Education Role</option>
                                                                {
                                                                    this.state.educationRoleTypeList.length > 0 && this.state.educationRoleTypeList.map((data) => (
                                                                        <option key={data.EducationRoleTypeID} value={data.EducationRoleTypeID} >{data.EducationRoleTypeName}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{this.state.educationRoleTypeIdErr}</span>}
                                                        </div>}
                                                        {toShowEduRole && <div className="col-xl-3">
                                                            <div className="d-flex">
                                                                <label className="w-auto mt-2">
                                                                    Institute Identity Card <span className="text-red">*</span>
                                                                    {identityCardFilePath ? <a href={identityCardFilePath} target="_blank" rel="noreferrer" className="ms-2 text-primary" style={{ fontSize: '12px', fontWeight: 'normal' }}>View</a> : null}
                                                                </label>
                                                            </div>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                onChange={(e) => this.onIdentityCardFilePick(e)}
                                                            />
                                                            {identityCardFileName ? <span className="text-success mt-1 d-block" style={{ fontSize: '12px' }}>{identityCardFileName}</span> : null}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{identityCardFileErr}</span>}
                                                        </div>}
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                Designation <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={designation} maxLength={'50'} disabled={toShowEduRole && this.state.educationRoleTypeId != 5}
                                                                onChange={(e) => this.setState({ designation: e.target.value, designationErr: "", })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{designationErr}</span>}

                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                Pincode/Zipcode<span className="rad-star text-danger">*</span>
                                                            </label>
                                                            {/* {
                                                            countryId == "91" &&
                                                            // <input type="number" className="form-control" value={pincode}
                                                            //     maxLength={6} onChange={(e) => this.onPincodeSearch(e)}
                                                            // />
                                                            <input type="text" className="form-control" value={pincode}
                                                                maxLength={6} onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.onPincodeSearch(e) : null}
                                                            />
                                                        }
                                                        {
                                                            countryId != "91" &&
                                                            <input type="text" className="form-control" value={pincode}
                                                                maxLength={10} onChange={(e) => this.onPincodeSearch(e)}
                                                                onInput={toInputUppercase}
                                                            />
                                                        }
                                                        {isDisplayPincodeList && this.renderPincodeList()} */}
                                                            <Form.Control
                                                                type="text"
                                                                // placeholder="Search..."
                                                                value={pincode}
                                                                maxLength={countryId == "91" ? 6 : 10}
                                                                // onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.handleSearchChange(e, 2, 0) : null}
                                                                // onChange={this.handleSearchChange}
                                                                onFocus={() => pincode.length > 0 && this.setState({ isOpenDropDownPin: true })}
                                                                // onBlur={() => this.setState({ isOpenDropDownPin: false })}
                                                                onBlur={() => setTimeout(() => {
                                                                    this.setState({ isOpenDropDownPin: false })
                                                                }, 500)}
                                                                onKeyDown={(e) => this.handleKeyDown(e, 2, 0)}
                                                                autoFocus
                                                            />

                                                            {/* Dropdown options - shown only if there are results */}
                                                            {isOpenDropDownPin && tempPincodeList.length > 0 && (
                                                                <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                    {tempPincodeList.map((item, index) => (
                                                                        <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 2, 0)}
                                                                            // className={this.state.focusedIndexPin === index ? 'text-white' : 'none'}
                                                                            style={{
                                                                                whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                backgroundColor: this.state.focusedIndexPin === index ? '#a4c2df' : 'transparent',
                                                                            }}
                                                                            onMouseEnter={() => this.handleHover(index, 2, 0)}
                                                                        >
                                                                            {item.Pincode}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            )}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErr}</span>}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                State/Province
                                                                {countryId == "91" && <span className="red-star text-danger">*</span>}
                                                            </label>
                                                            {/* <input type="text" className="form-control" value={regState} maxLength={'50'}
                                                            onChange={(e) => this.onStateSearch(e)}
                                                        />
                                                        {isDisplayStateList && this.renderStateList()} */}
                                                            <Form.Control
                                                                type="text"
                                                                // placeholder="Search..."
                                                                value={regState}
                                                                onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                                // onChange={this.handleSearchChange}
                                                                onFocus={() => regState.length > 0 && this.setState({ isOpenDropDownState: true })}
                                                                // onBlur={() => this.setState({ isOpenDropDownState: false })}
                                                                onBlur={(e) => setTimeout(() => {
                                                                    this.setState({ isOpenDropDownState: false }, () => { countryId == "91" && this.checkStateName(e.target.value, 0) })
                                                                }, 500)}
                                                                onKeyDown={(e) => this.handleKeyDown(e, 0, 0)}
                                                                autoFocus
                                                            />

                                                            {/* Dropdown options - shown only if there are results */}
                                                            {isOpenDropDownState && tempStateList.length > 0 && (
                                                                <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                    {tempStateList.map((item, index) => (
                                                                        <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 0, 0)}
                                                                            // className={this.state.focusedIndexState === index ? 'text-white' : 'none'}
                                                                            style={{
                                                                                whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                backgroundColor: this.state.focusedIndexState === index ? '#a4c2df' : 'transparent',
                                                                            }}
                                                                            onMouseEnter={() => this.handleHover(index, 0, 0)}
                                                                        >
                                                                            {item.Description}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            )}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{regStateErr}</span>}
                                                        </div>

                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">City
                                                                <span className="red-star text-danger">*</span>
                                                            </label>
                                                            {/* <input type="text" className="form-control" value={city} maxLength={'50'}
                                                            onChange={(e) => this.onCitySearch(e)} />
                                                        {isDisplayCityList && this.renderCityList()} */}
                                                            <Form.Control
                                                                type="text"
                                                                // placeholder="Search..."
                                                                value={city}
                                                                onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 1, 0)}
                                                                // onChange={this.handleSearchChange}
                                                                onFocus={() => city.length > 0 && this.setState({ isOpenDropDownCity: true })}
                                                                // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                                                onBlur={() => setTimeout(() => {
                                                                    this.setState({ isOpenDropDownCity: false })
                                                                }, 500)}
                                                                onKeyDown={(e) => this.handleKeyDown(e, 1, 0)}
                                                                autoFocus
                                                            />

                                                            {/* Dropdown options - shown only if there are results */}
                                                            {isOpenDropDownCity && tempCityList.length > 0 && (
                                                                <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                    {tempCityList.map((item, index) => (
                                                                        <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 1, 0)}
                                                                            // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                            style={{
                                                                                whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                backgroundColor: this.state.focusedIndexCity === index ? '#a4c2df' : 'transparent',
                                                                            }}
                                                                            onMouseEnter={() => this.handleHover(index, 1, 0)}
                                                                        >
                                                                            {item.Description}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            )}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{cityErr}</span>}
                                                        </div>

                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2"> Website</label>
                                                            <input type="text" className="form-control" value={website} maxLength={'50'}
                                                                onChange={(e) => this.setState({ website: e.target.value })}
                                                            />
                                                        </div>
                                                        {/* <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> GST No</label>
                                                    <input type="text" className="form-control" value={gstNo}
                                                        onChange={(e) => this.setState({ gstNo: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> PAN No</label>
                                                    <input type="text" className="form-control" value={panNo}
                                                        onChange={(e) => this.setState({ panNo: e.target.value })}
                                                    />
                                                </div> */}
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2"> Email
                                                                <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={email} maxLength={'50'}
                                                                onChange={(e) => this.setState({ email: e.target.value, emailErr: "" })}
                                                                onBlur={(e) => this.verifyEmail(e)}
                                                                autoComplete="new-password"
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{emailErr}</span>}
                                                        </div>
                                                        <div className="col-sm-3 mt-2">
                                                            <label className="d-flex">Telephone No</label>

                                                            <div className="phone-input-group">
                                                                {/* STD Code */}
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off"
                                                                    placeholder="STD"
                                                                    maxLength={'4'}
                                                                    value={preTelNo}
                                                                    onChange={(e) =>
                                                                        this.setState({ preTelNo: e.target.value })
                                                                    }
                                                                />

                                                                {/* Telephone Number */}
                                                                <input
                                                                    type="tel"
                                                                    className="form-control phone-no"
                                                                    placeholder="Telephone No"
                                                                    value={telNo}
                                                                    maxLength="10"
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.preventMinus(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) =>
                                                                        e.target.value >= 0 &&
                                                                        this.setState({ telNo: e.target.value })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-3 mt-2">
                                                            <label className="d-flex">Telephone No 1</label>

                                                            <div className="phone-input-group">
                                                                {/* STD Code */}
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off"
                                                                    placeholder="STD"
                                                                    maxLength={'4'}
                                                                    value={preTel1No}
                                                                    onChange={(e) =>
                                                                        this.setState({ preTel1No: e.target.value })
                                                                    }
                                                                />

                                                                {/* Telephone Number */}
                                                                <input
                                                                    type="tel"
                                                                    className="form-control phone-no"
                                                                    placeholder="Telephone No 1"
                                                                    value={tel1No}
                                                                    maxLength="10"
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) =>
                                                                        e.target.value >= 0 &&
                                                                        this.setState({ tel1No: e.target.value })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg " style={{ display: 'flex' }}>
                                                                <label className="ms-3" >
                                                                    <input type="checkbox" name="fav_language"
                                                                        value={this.state.isInvoice} checked={this.state.isInvoice}
                                                                        onClick={(e) => this.setState({
                                                                            isInvoice: !this.state.isInvoice,
                                                                            INVPersonNameErr: '',
                                                                            INVCompanyNameErr: '',
                                                                            INVAddressErr: '',
                                                                            INVTanNoErr: '',
                                                                            GSTNoErr: '',
                                                                            PANNoErr: '',
                                                                            countryIdINVErr: '',
                                                                            regStateINVErr: '',
                                                                            cityINVErr: '',
                                                                            pincodeINVErr: '',
                                                                        })}
                                                                    />Invoice Details
                                                                </label>
                                                                {this.state.isInvoice &&
                                                                    <label className="d-flex mr-2" style={{ justifyContent: 'end', marginRight: '15px' }}>
                                                                        <input
                                                                            type="radio"
                                                                            name="correspondenceDetails"
                                                                            value={this.state.isSameAsAbove}
                                                                            checked={this.state.isSameAsAbove}
                                                                            onClick={(e) => {
                                                                                if (!this.state.isSameAsAbove) {
                                                                                    this.setState({
                                                                                        isSameAsAbove: true,
                                                                                        INVPersonName: firstName,
                                                                                        INVPersonNameErr: '',
                                                                                        INVCompanyName: institute,
                                                                                        INVCompanyNameErr: '',
                                                                                        countryIdINVErr: '',
                                                                                        countryIdINV: countryId,
                                                                                        pincodeINV: pincode,
                                                                                        pincodeINVErr: '',
                                                                                        regStateINV: regState,
                                                                                        regStateINVErr: '',
                                                                                        cityINV: city,
                                                                                        cityINVErr: '',
                                                                                    })
                                                                                }
                                                                            }
                                                                            }
                                                                        />
                                                                        Same as Correspondence Details
                                                                    </label>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.isInvoice && <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Person Incharge Name<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={INVPersonName}
                                                                maxLength={'50'}
                                                                onChange={(e) => this.setState({ INVPersonName: e.target.value, INVPersonNameErr: "" }, () => {
                                                                    this.checkCorrespondence()
                                                                })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVPersonNameErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">Company Name<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={INVCompanyName}
                                                                maxLength={'200'}
                                                                onChange={(e) => this.setState({ INVCompanyName: e.target.value, INVCompanyNameErr: "" }, () => {
                                                                    this.checkCorrespondence()
                                                                })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVCompanyNameErr}</span>}

                                                        </div>
                                                        <div className="col-xl-6 mb-1">
                                                            <label className="mt-3">Address
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={INVAddress} maxLength={'50'}
                                                                onChange={(e) => this.setState({ INVAddress: e.target.value, INVAddressErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVAddressErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mt-2">
                                                            <div className="d-flex">
                                                                <label className=" w-auto" >
                                                                    Select Country
                                                                    <span className="text-red">*</span>

                                                                </label>
                                                                {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{countryIdINVErr}</span>}
                                                            </div>
                                                            <select className="form-control" value={countryIdINV}
                                                                onChange={(e) => {
                                                                    this.onCountrySelectINV(e)
                                                                    this.checkCorrespondence()
                                                                }}
                                                            >
                                                                <option value={''}>Select Your Country</option>
                                                                {
                                                                    countryId != 91 ? countryList.length > 0 && countryList.map((data) => (
                                                                        data.Code != 91 && <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                    )) : countryList.length > 0 && countryList.map((data) => (
                                                                        <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                Pincode/Zipcode
                                                                {<span className="red-star text-danger">*</span>}
                                                            </label>
                                                            {
                                                                countryIdINV == "91" &&
                                                                <input type="text" className="form-control" value={pincodeINV}
                                                                    maxLength={6} onChange={(e) => {
                                                                        this.onPincodeSearchINV(e)
                                                                        this.checkCorrespondence()
                                                                    }
                                                                    }
                                                                />
                                                            }
                                                            {
                                                                countryIdINV != "91" &&
                                                                <input type="text" className="form-control" value={pincodeINV}
                                                                    maxLength={10} onChange={(e) => {
                                                                        this.onPincodeSearchINV(e)
                                                                        this.checkCorrespondence()
                                                                    }
                                                                    }
                                                                    onInput={toInputUppercase}
                                                                />
                                                            }
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{pincodeINVErr}</span>}
                                                            {isDisplayPincodeListINV && this.renderPincodeListINV()}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">
                                                                State/Province
                                                                {countryIdINV == "91" && <span className="red-star text-danger">*</span>}
                                                            </label>
                                                            <input type="text" className="form-control" value={regStateINV} maxLength={'50'}
                                                                onChange={(e) => {
                                                                    this.onStateSearchINV(e)
                                                                    this.checkCorrespondence()
                                                                }
                                                                }
                                                                onBlur={(e) => countryIdINV == "91" ? this.checkStateName(e.target.value, 1) : null}
                                                            />
                                                            {isDisplayStateListINV && this.renderStateListINV()}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{regStateINVErr}</span>}
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-2">City
                                                                <span className="red-star text-danger">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={cityINV} maxLength={'50'}
                                                                onChange={(e) => {
                                                                    this.onCitySearchINV(e)
                                                                    this.checkCorrespondence()
                                                                }
                                                                } />
                                                            {isDisplayCityListINV && this.renderCityListINV()}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{cityINVErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">PAN Number{countryId == 91 && <span className="text-red">*</span>}</label>
                                                            <input type="text" className="form-control" value={PANNo}
                                                                maxLength={'50'}
                                                                onChange={(e) => {
                                                                    const errMsg = panNoValidator(e.target.value)
                                                                    this.setState({ PANNo: e.target.value, PANNoErr: '' })
                                                                    if (errMsg != '') {
                                                                        this.setState({
                                                                            PANNoErr: errMsg,
                                                                        })
                                                                    } else {
                                                                        this.setState({
                                                                            PANNoErr: "",
                                                                        })
                                                                    }
                                                                }
                                                                }
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{PANNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">TAN Number
                                                            </label>
                                                            <input type="text" className="form-control" value={INVTanNo}
                                                                maxLength={'50'}
                                                                onChange={(e) => {
                                                                    const errMsg = tanNoValidator(e.target.value)
                                                                    this.setState({
                                                                        INVTanNo: e.target.value,
                                                                    })
                                                                    if (errMsg != '') {
                                                                        this.setState({
                                                                            INVTanNoErr: errMsg,
                                                                        })
                                                                    } else {
                                                                        this.setState({
                                                                            INVTanNoErr: "",
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{INVTanNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label className="mt-3">GST Number{countryId == 91 && <span className="text-red">*</span>}</label>
                                                            <input type="text" className="form-control" value={GSTNo}
                                                                maxLength={'50'}
                                                                onChange={(e) =>
                                                                    this.onGSTchange(e.target.value)
                                                                }
                                                                onInput={toInputUppercase}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{GSTNoErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>

                                            {(this.state.VisitorTypeID == 2 && !this.state.isCoordinatorVisit) ? null : <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0 fw-semibold">
                                                                    Date of Visit Single Day Pass / All Day Pass{" "}
                                                                    <span className="text-red">*</span>
                                                                    {!isExhibitionFree && (countryId != null && countryId != '') && <span
                                                                        style={{ marginLeft: '10px', cursor: 'pointer', position: 'absolute', right: '2%' }}
                                                                        // style={{ textAlign: 'right', right: '20px', position: 'absolute', cursor: 'pointer' }} 
                                                                        className="mb-0 text-danger visit-charge-mobile"
                                                                    >
                                                                        Visit days Charges
                                                                        <strong onClick={() => this.setState({ isOpen4: true })}> (Click here)</strong>
                                                                    </span>}
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{daysErr}</span>}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4 mb-4">
                                                    <div className="row mt-2" >
                                                        {
                                                            daysList.length > 0 && daysList.map((data) => (
                                                                <div className="col-sm-4" key={data.Code}>
                                                                    <label className="d-flex">
                                                                        <input type="checkbox" select={data.isSelect}
                                                                            checked={data.isSelect} value={data.Code}
                                                                            onChange={(e) => this.onSelectDates(e)}
                                                                        />
                                                                        {data.VisitDate}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>

                                            </div>}
                                            {this.state.VisitorTypeID == 2 && <div className="btn-group ms-2 mt-4 mb-4 save-can d-block">
                                                <div className="btn-group" role="group" aria-label="Basic example">
                                                    {this.state.isCoordinatorVisit && <button
                                                        type="button"
                                                        className="btn btn-aqua rounded-1 d-block"
                                                        style={{ marginRight: 10 }}
                                                        onClick={() => this.toggleModel('Coordinator')}
                                                    >
                                                        Coordinator details
                                                    </button>}
                                                    <button
                                                        type="button"
                                                        className="btn btn-aqua rounded-1 d-block"
                                                        style={{ marginRight: 10 }}
                                                        onClick={() => this.state.isFirst && !this.state.isCoordinatorVisit ? this.toggleModel(2) : this.toggleModel()}
                                                    >
                                                        Add Visitor
                                                    </button>

                                                    {/* <button type="button" class="btn btn-primary rounded-0">Payment Listing Page</button> */}
                                                </div>

                                            </div>}
                                            {this.state.VisitorTypeID == 2 && this.renderGroupList()}

                                            <div className="main-container m-2">
                                                <div className="mb-4">
                                                    {this.state.VisitorTypeID == 2 && <a
                                                        className="btn-primary btn"
                                                        type="submit"
                                                        onClick={(e) => this.state.VisitorTypeID == 2 ? this.onVisitorRegistrationGroupNext(e, 1) : this.onVisitorRegistrationNext(e, 1)}
                                                    // onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: this.state.VisitorTypeID == 2 ? 0 : 1 }, popArg: [e, 1] })}
                                                    >
                                                        save
                                                    </a>}
                                                    <a
                                                        className="btn btn-aqua ms-2"
                                                        type="submit"
                                                        onClick={(e) => this.state.VisitorTypeID == 2 ? this.onVisitorRegistrationGroupNext(e) : this.onVisitorRegistrationNext(e)}
                                                    // onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: this.state.VisitorTypeID == 2 ? 2 : 3 }, popArg: [e] })}
                                                    >
                                                        Next
                                                    </a>
                                                    {/* <a
                                                    className="btn btn-aqua ms-2"
                                                    type="submit"
                                                    onClick={() => this.addTestElement()}
                                                >
                                                    ADD TEST
                                                </a> */}
                                                </div>
                                            </div>
                                            <div style={{ height: 20 }} />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="main-content app-content mt-0"
                                    style={{ backgroundColor: "#ececec", height: '100vh' }}
                                >
                                    <div className="side-app">
                                        <div className="main-container container-fluid top-form-name">
                                            <div className="row ">
                                                <form className="needs-validation " noValidate="">
                                                    <div className="form-row mt-4">
                                                        <div className="form-group col-md-7 p-4 thank-box">
                                                            <div className="form-group mb-2">
                                                                <h4
                                                                    className="mb-0 pt-2 pb-4 thank-top-mes"
                                                                    style={{ color: "#318958" }}
                                                                >
                                                                    <strong>Exhibition Closed</strong>
                                                                </h4>
                                                                <p className="mb-1 mt-1 text-center com-font">
                                                                    Thank you for your interest but the
                                                                </p>
                                                                <p className="mt-1 mb-0 text-center com-font">
                                                                    {sessionStorage.getItem("sessionExhibitionName")} from {moment(sessionStorage.getItem("exhibitionDateFrom")).format("DD MMMM YYYY")} to {moment(sessionStorage.getItem("exhibitionDateTo")).format("DD MMMM YYYY")}
                                                                </p>
                                                                <p className="mb-3 text-center com-font">
                                                                    at {sessionStorage.getItem("exhibitionAddress")} is now closed.
                                                                </p>
                                                                <p className="mb-3 text-center com-font">
                                                                    This Event already completed. Please Visit Again once the next edition is announced.
                                                                </p>
                                                            </div>
                                                            <div classname="">
                                                                <div classname="mt-1 mb-4">

                                                                    <button
                                                                        classname="btn btn-aqua"
                                                                        style={{
                                                                            background: "#007bff",
                                                                            padding: "6px 20px",
                                                                            fontSize: 14,
                                                                            border: "1px solid #007bff",
                                                                            borderRadius: 2,
                                                                            color: "#fff",
                                                                            marginTop: 16
                                                                        }}
                                                                        onClick={e => this.onPreviousClick(e)}
                                                                    >
                                                                        {" "}
                                                                        BACK TO EVENT WEBSITE
                                                                    </button>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>
                        <Modal
                            size="lg"
                            show={isOpen}
                            // dialogClassName="modal-90w"
                            onHide={() => this.toggleModel()}
                            aria-labelledby="example-modal-sizes-title-lg"
                        >
                            <Modal.Header>
                                <Modal.Title id="example-modal-sizes-title-lg">
                                    <h5 class="modal-title">{this.state.isModalEdit ? this.state.modalID == 'Coordinator' ? 'Update Coordinator' : 'Update Visitor' : 'Add Visitor'}</h5>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="navgred mt-0" style={{ backgroundColor: 'white', border: '2px solid #DC3545' }}>
                                    <ul className="nav nav-pillsred">
                                        <li className="nava-item " style={{ border: 'none' }}>
                                            <button onClick={() => this.setState({ activeModalStep: 1, isVisaApplied: passportFile != '' && passportFile != null ? true : isVisaApplied })} style={this.state.activeModalStep == 1 ? { backgroundColor: '#DC3545', border: 'none' } : { backgroundColor: 'white', border: 'none', color: '#DC3545 !important' }} className={this.state.activeModalStep == 1 ? "nav-linkred active px-4 py-2" : "nav-linkred  px-4 py-2"}>
                                                {" "}
                                                <a style={this.state.activeModalStep == 1 ? { backgroundColor: '#DC3545' } : { backgroundColor: 'white', color: '#DC3545 !important' }} className={this.state.activeModalStep == 1 ? "nav-linkred active px-4 py-2 " : "nav-linkred  px-4 py-2"}>
                                                    Step 1{" "}
                                                </a>{" "}
                                            </button>

                                        </li>
                                        {/* </Link> */}
                                        <li className="nava-item " style={{ border: 'none' }}>
                                            {" "}
                                            <button onClick={() => this.setState({ activeModalStep: 2, isVisaApplied: passportFile != '' && passportFile != null ? true : isVisaApplied })} style={this.state.activeModalStep == 2 ? { backgroundColor: '#DC3545', border: 'none' } : { backgroundColor: 'white', border: 'none', color: '#DC3545 !important' }} className={this.state.activeModalStep == 2 ? "nav-linkred active px-4 py-2" : "nav-linkred  px-4 py-2"} disabled={!this.state.modalStep2}>
                                                {" "}
                                                <a style={this.state.activeModalStep == 2 ? { backgroundColor: '#DC3545' } : { backgroundColor: 'white', color: '#DC3545 !important' }} className={this.state.activeModalStep == 2 ? "nav-linkred active px-4 py-2 " : "nav-linkred  px-4 py-2"}>
                                                    Step 2{" "}
                                                </a>{" "}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                {/* <div class="row"> */}
                                {this.state.activeModalStep == 1 && <>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-xl-3 mt-3">
                                                <label>
                                                    First Name<span className="text-red">*</span>
                                                </label>
                                                <div className="name-input-group">
                                                    <select
                                                                className="form-control name-prefix"
                                                                id="validationCustom03"
                                                                required=""
                                                                value={prenameModal}
                                                                onChange={(e) => this.setState({
                                                                    prenameModal: e.target.value,
                                                                    isOtherPreNameModal: e.target.value == "Other" && true
                                                                })}
                                                            >
                                                                <option value="Mr">Mr</option>
                                                                <option value="Ms">Ms</option>
                                                                <option value="DR">DR</option>
                                                                <option value="Prof">Prof</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                    {
                                                        isOtherPreNameModal &&
                                                        <input
                                                            type="text"
                                                            className="form-control name-other"
                                                            maxLength={'40'}
                                                            value={otherNameModal}
                                                            onChange={e => this.setState({ otherNameModal: e.target.value })}
                                                            placeholder={'Other'}
                                                        />
                                                    }
                                                    <input
                                                        type="text"
                                                        className="form-control name-no"
                                                        maxLength={'50'}
                                                        value={firstNameModal}
                                                        onChange={(e) => this.setState({ firstNameModal: e.target.value, firstNameErrModal: "" })}
                                                    />
                                                </div>
                                                {<span className='text-danger text-start text-left d-block'>{firstNameErrModal}</span>}

                                            </div>
                                            <div className="col-xl-3 mb-1">
                                                <label className="mt-3">Middle Name</label>
                                                <input type="text" className="form-control" value={middleNameModal}
                                                    maxLength={'50'}
                                                    onChange={(e) => this.setState({ middleNameModal: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-xl-3 mb-1">
                                                <label className="mt-3">Last Name
                                                    <span className="text-red">*</span>
                                                </label>
                                                <input type="text" className="form-control" value={lastNameModal} maxLength={'50'}
                                                    onChange={(e) => this.setState({ lastNameModal: e.target.value, lastNameErrModal: "" })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{lastNameErrModal}</span>}
                                            </div>
                                            <div className="col-xl-3">
                                                <div className="d-flex">
                                                    <label className="mt-3 w-auto" >
                                                        Select Country
                                                        <span className="text-red">*</span>

                                                    </label>
                                                    {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{this.state.countryIdErrModal}</span>}
                                                </div>
                                                <select className="form-control" value={this.state.countryIdModal}
                                                    onChange={(e) => this.onCountrySelect(e, 1)}
                                                >
                                                    <option value={''}>Select Your Country</option>
                                                    {
                                                        countryList.length > 0 && countryList.map((data) => (
                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-12 mb-4">
                                        <div className="row">

                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">
                                                    Institute/Organisation <span className="rad-star text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control" value={instituteModal} maxLength={'500'}
                                                    onChange={(e) => this.setState({ instituteModal: e.target.value, instituteErrModal: "" })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{instituteErrModal}</span>}

                                            </div>
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">Mobile No
                                                    <span className="rad-star text-danger">*</span>
                                                </label>
                                                <div className="phone-input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control phone-code" autoComplete="off" readOnly
                                                        placeholder="ISD"
                                                        maxLength={'4'}
                                                        value={preMobNoModal}
                                                    />
                                                    <input
                                                        type="number"
                                                        className="form-control phone-no"
                                                        value={mobNoModal}
                                                        maxLength={'10'}
                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                        onPaste={(e) => this.handlePaste(e)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => e.target.value >= 0 &&
                                                            this.setState({ mobNoModal: e.target.value, mobNoErrModal: "" })}
                                                    />
                                                </div>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{mobNoErrModal}</span>}
                                            </div>
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2"> WhatsApp Mobile No
                                                    <span className="rad-star text-danger">*</span>
                                                </label>
                                                <div className="phone-input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control phone-code" autoComplete="off" readOnly
                                                        value={preWhatsAppMobNoModal}
                                                        placeholder="ISD"
                                                        maxLength={'10'}
                                                    />
                                                    <input
                                                        type="number"
                                                        className="form-control phone-no"
                                                        value={whatsAppMobNoModal}
                                                        maxLength={'10'}
                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                        onPaste={(e) => this.handlePaste(e)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => e.target.value >= 0 &&
                                                            this.setState({ whatsAppMobNoModal: e.target.value, whatsAppMobNoErrModal: "" })}
                                                    />
                                                </div>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{whatsAppMobNoErrModal}</span>}
                                            </div>
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-6">
                                                    <input type="checkbox" name="fav_language"
                                                        value={isSameAsMobNoModal} checked={isSameAsMobNoModal}
                                                        onClick={(e) => this.onSameAsMobNoClick(e, 1)}
                                                    />
                                                    Same as Mobile No
                                                </label>
                                            </div>
                                            {toShowEduRole && <div className="col-xl-3">
                                                <div className="d-flex">
                                                    <label className="w-auto mt-2" >
                                                        Education Role
                                                        <span className="text-red">*</span>

                                                    </label>

                                                </div>
                                                <select className="form-control" value={this.state.educationRoleTypeIdModal}
                                                    onChange={(e) => this.onEduRoleSelect(e, 1)}
                                                >
                                                    <option value={''}>Select Education Role</option>
                                                    {
                                                        this.state.educationRoleTypeList.length > 0 && this.state.educationRoleTypeList.map((data) => (
                                                            <option key={data.EducationRoleTypeID} value={data.EducationRoleTypeID} >{data.EducationRoleTypeName}</option>
                                                        ))
                                                    }
                                                </select>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.educationRoleTypeIdErrModal}</span>}
                                            </div>}
                                            {toShowEduRole && <div className="col-xl-3">
                                                <div className="d-flex">
                                                    <label className="w-auto mt-2">
                                                        Institute Identity Card <span className="text-red">*</span>
                                                        {identityCardFilePathModal ? <a href={identityCardFilePathModal} target="_blank" rel="noreferrer" className="ms-2 text-primary" style={{ fontSize: '12px', fontWeight: 'normal' }}>View</a> : null}
                                                    </label>
                                                </div>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={(e) => this.onIdentityCardFilePick(e, 1)}
                                                />
                                                {identityCardFileNameModal ? <span className="text-success mt-1 d-block" style={{ fontSize: '12px' }}>{identityCardFileNameModal}</span> : null}
                                                {<span className='text-danger text-start text-left d-block mt-1'>{identityCardFileErrModal}</span>}
                                            </div>}
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">
                                                    Designation <span className="rad-star text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control" value={designationModal} maxLength={'50'} disabled={toShowEduRole && this.state.educationRoleTypeIdModal != 5}
                                                    onChange={(e) => this.setState({ designationModal: e.target.value, designationErrModal: "" })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{designationErrModal}</span>}

                                            </div>
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">
                                                    Pincode/Zipcode<span className="rad-star text-danger">*</span>
                                                </label>
                                                {/* {
                                            countryId == "91" &&
                                            // <input type="number" className="form-control" value={pincodeModal}
                                            //     maxLength={6} onChange={(e) => this.onPincodeSearch(e, 1)}
                                            // />
                                            <input type="text" className="form-control" value={pincodeModal}
                                                maxLength={6} onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.onPincodeSearch(e, 1) : null}
                                            />
                                        }
                                        {
                                            countryId != "91" &&
                                            <input type="text" className="form-control" value={pincodeModal}
                                                maxLength={10} onChange={(e) => this.onPincodeSearch(e, 1)}
                                                onInput={toInputUppercase}
                                            />
                                        }
                                        {isDisplayGroupPincodeList && this.renderGroupPincodeList()} */}
                                                <Form.Control
                                                    type="text"
                                                    // placeholder="Search..."
                                                    value={pincodeModal}
                                                    maxLength={countryId == "91" ? 6 : 10}
                                                    // onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                    onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.handleSearchChange(e, 2, 1) : null}
                                                    // onChange={this.handleSearchChange}
                                                    onFocus={() => pincodeModal.length > 0 && this.setState({ isOpenDropDownPinModal: true })}
                                                    // onBlur={() => this.setState({ isOpenDropDownPinModal: false })}
                                                    onBlur={() => setTimeout(() => {
                                                        this.setState({ isOpenDropDownPinModal: false })
                                                    }, 500)}
                                                    onKeyDown={(e) => this.handleKeyDown(e, 2, 1)}
                                                    autoFocus
                                                />

                                                {/* Dropdown options - shown only if there are results */}
                                                {isOpenDropDownPinModal && tempGroupPincodeList.length > 0 && (
                                                    <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 999, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                        {tempGroupPincodeList.map((item, index) => (
                                                            <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 2, 1)}
                                                                // className={this.state.focusedIndexPinModal === index ? 'text-white' : 'none'}
                                                                style={{
                                                                    whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none', fontSize: 'small',
                                                                    backgroundColor: this.state.focusedIndexPinModal === index ? '#a4c2df' : 'transparent',
                                                                }}
                                                                onMouseEnter={() => this.handleHover(index, 2, 1)}
                                                            >
                                                                {item.Pincode}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                )}
                                                {<span className='text-danger text-start text-left d-block mt-1'>{pincodeErrModal}</span>}
                                            </div>
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">
                                                    State/Province
                                                    {countryId == "91" && <span className="red-star text-danger">*</span>}
                                                </label>
                                                {/* <input type="text" className="form-control" value={regStateModal} maxLength={'50'}
                                            onChange={(e) => this.onStateSearch(e, 1)}
                                        />
                                        {isDisplayGroupStateList && this.renderGroupStateList()} */}
                                                <Form.Control
                                                    type="text"
                                                    // placeholder="Search..."
                                                    value={regStateModal}
                                                    onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 1)}
                                                    // onChange={this.handleSearchChange}
                                                    onFocus={() => regStateModal.length > 0 && this.setState({ isOpenDropDownStateModal: true })}
                                                    // onBlur={() => this.setState({ isOpenDropDownStateModal: false })}
                                                    onBlur={() => setTimeout(() => {
                                                        this.setState({ isOpenDropDownStateModal: false })
                                                    }, 500)}
                                                    onKeyDown={(e) => this.handleKeyDown(e, 0, 1)}
                                                    autoFocus
                                                />

                                                {/* Dropdown options - shown only if there are results */}
                                                {isOpenDropDownStateModal && tempGroupStateList.length > 0 && (
                                                    <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 999, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                        {tempGroupStateList.map((item, index) => (
                                                            <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 0, 1)}
                                                                // className={this.state.focusedIndexStateModal === index ? 'text-white' : 'none'}
                                                                style={{
                                                                    whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none', fontSize: 'small',
                                                                    backgroundColor: this.state.focusedIndexStateModal === index ? '#a4c2df' : 'transparent',
                                                                }}
                                                                onMouseEnter={() => this.handleHover(index, 0, 1)}
                                                            >
                                                                {item.Description}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                )}
                                                {<span className='text-danger text-start text-left d-block mt-1'>{regStateErrModal}</span>}
                                            </div>

                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">City
                                                    <span className="red-star text-danger">*</span>
                                                </label>
                                                {/* <input type="text" className="form-control" value={cityModal} maxLength={'50'}
                                            onChange={(e) => this.onCitySearch(e, 1)} />
                                        {isDisplayGroupCityList && this.renderGroupCityList()} */}
                                                <Form.Control
                                                    type="text"
                                                    // placeholder="Search..."
                                                    value={cityModal}
                                                    onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 1, 1)}
                                                    // onChange={this.handleSearchChange}
                                                    onFocus={() => cityModal.length > 0 && this.setState({ isOpenDropDownCityModal: true })}
                                                    // onBlur={() => this.setState({ isOpenDropDownCityModal: false })}
                                                    onBlur={() => setTimeout(() => {
                                                        this.setState({ isOpenDropDownCityModal: false })
                                                    }, 500)}
                                                    onKeyDown={(e) => this.handleKeyDown(e, 1, 1)}
                                                    autoFocus
                                                />

                                                {/* Dropdown options - shown only if there are results */}
                                                {isOpenDropDownCityModal && tempGroupCityList.length > 0 && (
                                                    <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 999, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                        {tempGroupCityList.map((item, index) => (
                                                            <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 1, 1)}
                                                                // className={this.state.focusedIndexCityModal === index ? 'text-white' : 'none'}
                                                                style={{
                                                                    whiteSpace: 'normal', height: '50px', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none', fontSize: 'small',
                                                                    backgroundColor: this.state.focusedIndexCityModal === index ? '#a4c2df' : 'transparent',
                                                                }}
                                                                onMouseEnter={() => this.handleHover(index, 1, 1)}
                                                            >
                                                                {item.Description}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                )}
                                                {<span className='text-danger text-start text-left d-block mt-1'>{cityErrModal}</span>}
                                            </div>

                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2"> Website</label>
                                                <input type="text" className="form-control" value={websiteModal} maxLength={'50'}
                                                    disabled
                                                    onChange={(e) => this.setState({ websiteModal: e.target.value })}
                                                />
                                            </div>
                                            {/* <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> GST No</label>
                                                    <input type="text" className="form-control" value={gstNo}
                                                        onChange={(e) => this.setState({ gstNo: e.target.value })}
                                                    />
                                                </div>
                                                <div className="col-sm-3">
                                                    <label className="d-flex mt-2"> PAN No</label>
                                                    <input type="text" className="form-control" value={panNo}
                                                        onChange={(e) => this.setState({ panNo: e.target.value })}
                                                    />
                                                </div> */}
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2"> Email
                                                    <span className="rad-star text-danger">*</span>
                                                </label>
                                                <input type="text" className="form-control" value={emailModal} maxLength={'50'}
                                                    id="emailModalUnique"
                                                    name="emailModalUnique"
                                                    onChange={(e) => this.setState({ emailModal: e.target.value, emailErrModal: "" })}
                                                    onBlur={(e) => this.verifyEmail(e, 1)}
                                                    autoComplete="new-password"

                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{emailErrModal}</span>}
                                            </div>
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">Telephone No</label>
                                                <div className="phone-input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control phone-code" autoComplete="off"
                                                        value={preTelNoModal} placeholder="STD" maxLength={'4'}
                                                        onChange={(e) => this.setState({ preTelNoModal: e.target.value })}
                                                    />
                                                    <input
                                                        type="number"
                                                        className="form-control phone-no"
                                                        value={telNoModal}
                                                        maxLength={'10'}
                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                        onPaste={(e) => this.preventMinus(e)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => e.target.value >= 0 && this.setState({ telNoModal: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <label className="d-flex mt-2">Telephone No 1</label>
                                                <div className="phone-input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control phone-code" autoComplete="off"
                                                        value={preTel1NoModal} placeholder="STD" maxLength={'4'}
                                                        onChange={(e) => this.setState({ preTel1NoModal: e.target.value })}
                                                    />
                                                    <input
                                                        type="number"
                                                        className="form-control phone-no"
                                                        value={tel1NoModal}
                                                        maxLength={'10'}
                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                        onKeyDown={(e) => this.preventMinus(e)}
                                                        onPaste={(e) => this.handlePaste(e)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => e.target.value >= 0 && this.setState({ tel1NoModal: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="one-section">
                                        {(countryId != null && countryId != '') && <div style={{ textAlign: 'right' }}>
                                            <div className="p-1 title-bg d-flex">


                                                <span className="mb-0" >
                                                    Date of Visit Single Day Pass / All Day Pass <span className="text-red">*</span> &nbsp; &nbsp; &nbsp;  {!isExhibitionFree && <spa style={{ color: 'red' }}>
                                                        Visit days Charges
                                                        <strong onClick={() => !isExhibitionFree ? this.setState({ isOpen4: true }) : null}> (Click here)</strong>
                                                    </spa>}
                                                </span>
                                            </div>
                                        </div>}
                                        {/* <div className="containerfluid">
                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                <div className="p-1 title-bg d-flex">
                                                   
                                                    {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.daysModalErr}</span>}
                                                    <p className="mb-0"  onClick={() => this.setState({ isOpen4: true })}>
                                                        Date of Visit Single Day Pass / All Day Pass <span className="text-red">*</span> Visit days Charges
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                        <div className="col-xl-8 mb-4">
                                            {console.log(daysList)}
                                            <div className="row mt-4" >
                                                {
                                                    this.state.daysModalList.length > 0 && this.state.daysModalList.map((data) => (
                                                        <div className="col-sm-4" key={data.Code}>
                                                            <label className="d-flex">
                                                                <input type="checkbox" select={data.isSelect}
                                                                    checked={data.isSelect} value={data.Code}
                                                                    onChange={(e) => this.onModalSelectDates(e)}
                                                                />
                                                                {data.VisitDate}
                                                            </label>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.daysModalErr}</span>}
                                        </div>

                                    </div>
                                </>
                                }
                                {
                                    this.state.activeModalStep == 2 &&
                                    <>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0">Industry Segment <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.chapterErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" mb-2">
                                                <div className="row mt-1">
                                                    <div className="asc">
                                                        <div className="" style={{ paddingLeft: 10 }}>
                                                            <form className="needs-validation pb-2" noValidate="">
                                                                <div className="form-row mt-3">
                                                                    {
                                                                        chapterList.length > 0 && chapterList.map((data) => (
                                                                            <div className="col-sm-3">
                                                                                <section className="" key={data.IndustrySegmentID}>
                                                                                    {/* <input type="checkbox" name="collapse"
                                                                                select={data.IsSelect} checked={data.IndustrySegmentID}
                                                                                value={data.IndustrySegmentID}
                                                                            /> */}
                                                                                    <label>
                                                                                        <input type="checkbox"
                                                                                            select={data.IsSelect} checked={data.IsSelect}
                                                                                            value={data.IndustrySegmentID}
                                                                                            onChange={(e) => this.onSelectPrimaryChapter(e)} />
                                                                                        {data['Industrial Segment']}
                                                                                    </label>
                                                                                    {data.IndustrySegmentID == 16 && this.state.isOtherOpen && <input type="text" className="form-control" value={this.state.other}
                                                                                        // style={{ marginRight: "50px" }}
                                                                                        // maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                        // onPaste={(e) => this.handlePaste(e)}
                                                                                        // onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                                        onChange={(e) =>
                                                                                            this.setState({ other: e.target.value, })}
                                                                                    />}
                                                                                </section>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0">
                                                                List of Products <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{ChapterHallErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-12 mb-4">
                                                <div className="row mt-4">
                                                    <div class="accordion" id="accordionExample">
                                                        {
                                                            level2.length > 0 && level2.map(level2Data => (
                                                                <>
                                                                    {
                                                                        // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                        <div class="accordion-item">
                                                                            <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                    type="button" data-bs-toggle="collapse"
                                                                                    data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                    aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                    {/* // checkbox for level2 */}
                                                                                    {
                                                                                        level2Data.IsCheckbox &&
                                                                                        <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                            checked={level2Data.IsSelect}
                                                                                            onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                                    }
                                                                                    {level2Data.ChapterName} </button>
                                                                            </h2>
                                                                            {this.recordTwo(level2Data, level3, level4)}
                                                                        </div>
                                                                    }

                                                                </>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="" style={{ marginLeft: "10px" }}>
                                                <p className="mb-0" style={{ fontSize: 15 }}>
                                                    <strong>  Selected List of Products</strong>
                                                </p>
                                            </div>
                                            <div style={{ padding: "0px 0px 0px 10px" }}>
                                                {
                                                    filerArray.length > 0 ? filerArray.map((data) => (
                                                        <p>
                                                            {data.ChapterName}
                                                        </p>
                                                    )) :
                                                        <p>
                                                            {"No Results"}
                                                        </p>
                                                }
                                            </div>
                                        </div>

                                        {/* {!(parseInt(this.state.countryIdModal) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) && <div className="one-section mb-3 mt-3">
                                        <div className="col-sm-3 ">
                                            <label className="d-flex">
                                                <input className="do-you"
                                                    type="checkbox"
                                                    name="fav_language"
                                                    checked={isGrpDelegation}
                                                    onChange={(e) => this.setState({
                                                        isGrpDelegation: !isGrpDelegation

                                                    })}
                                                />
                                                <span className="do-you1" style={{ whiteSpace: "nowrap", color: "#bc202b", fontSize: "16px" }}><strong>Are you part of Group Delegation ?</strong>
                                                    (If yes below section would open)</span>
                                            </label>
                                        </div>
                                        {
                                            isGrpDelegation &&
                                            <div
                                                className="col-md-12 mb-2"
                                                id="divMsg"
                                            >
                                                <div className="row">
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Delegation Leader/Organisation<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={leader} maxLength={'50'}
                                                            onChange={(e) => this.setState({ leader: e.target.value, leaderErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{leaderErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <div className="d-flex">
                                                            <label className="mt-3 w-auto" >
                                                                Country/Region
                                                                <span className="text-red">*</span>

                                                            </label>
                                                            {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{delegationCountryErr}</span>}
                                                        </div>
                                                        <select className="form-control" value={delegationCountry}
                                                            onChange={(e) => this.onCountrySelect(e, 3)}
                                                        >
                                                            <option>Select Your Country</option>
                                                            {
                                                                countryList.length > 0 && countryList.map((data) => (
                                                                    <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Arrival Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={arrivalDate}
                                                            onChange={(date) =>
                                                                this.setState({
                                                                    arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                    arrivalDateErr: ""
                                                                })}
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            placeholderText="Arrival Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{arrivalDateErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Departure Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={departureDate}
                                                            onChange={(date) =>
                                                                this.setState({
                                                                    departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                    departureDateErr: ""
                                                                })}
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            placeholderText="Departure Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{departureDateErr}</span>}
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xl-12 mb-1">
                                                            <label className="mt-3">Remark
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <textarea
                                                                className="form-control"
                                                                rows={3}
                                                                maxLength={'250'}
                                                                defaultValue={""}
                                                                value={delegationRemark}
                                                                onChange={(e) => this.setState({ delegationRemark: e.target.value, delegationRemarkErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{delegationRemarkErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>} */}
                                        {this.state.isShowIntrestList &&
                                            <div >
                                                <div className="containerfluid">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Seminar Registration</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            this.state.interestListModal.length > 0 && this.state.interestListModal.map((data) => (
                                                                <>
                                                                    {data.status &&
                                                                        <>
                                                                            <div className="col-sm-12 mb-2" key={data.AreaofInterestID}>
                                                                                <label className="d-flex">
                                                                                    <input type="checkbox" name="fav_language" value={data.AreaofInterestID}
                                                                                        select={data.isSelect} checked={data.isSelect}
                                                                                        onChange={(e) => this.onSelectInterest(e)}
                                                                                    />
                                                                                    {data.AreaofInterestID == 1 ? 'Yes, I wish to attend Seminar' : data.Name}

                                                                                </label>
                                                                                {this.state.isInterestTwo && data.AreaofInterestID == 2 && false &&
                                                                                    < div >
                                                                                        <div className="col-sm-3 ">
                                                                                            <label className="d-flex">
                                                                                                <span className="do-you1" style={{ whiteSpace: "nowrap", fontSize: "16px" }}><strong>If interested Please fill preferred Date & Time</strong>
                                                                                                    (Exhibition time is 1000hrs to 1800hrs) <a className="text-primary"
                                                                                                        onClick={(e) => this.onFileClick(e)}><spa className="text-danger blink-soft">Click here</spa> to view exhibitor list for meeting at respective booth.</a></span>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-md-12 mb-2"
                                                                                            id="divMsg"
                                                                                        >
                                                                                            <div className="row">
                                                                                                <div className="col-xl-3">
                                                                                                    <label className="mt-1">Date
                                                                                                        <span className="text-red">*</span>
                                                                                                    </label>
                                                                                                    <DatePicker selected={preffDateModal}
                                                                                                        onChange={(date) =>
                                                                                                            this.setState({
                                                                                                                preffDateModal: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                                preffDateErrModal: ""
                                                                                                            })}
                                                                                                        dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                                        peekNextMonth
                                                                                                        value={preffDateModal}
                                                                                                        showMonthDropdown
                                                                                                        showYearDropdown
                                                                                                        dropdownMode="select"
                                                                                                        minDate={moment(sessionStorage.getItem('exhibitionDateFrom'), 'YYYY-MM-DD').toDate()}
                                                                                                        maxDate={moment(sessionStorage.getItem('exhibitionDateTo'), 'YYYY-MM-DD').toDate()}
                                                                                                        placeholderText="Preferred Date"
                                                                                                        dayClassName={() => "example-datepicker-day-class"}
                                                                                                        popperClassName="example-datepicker-class" />
                                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{preffDateErrModal}</span>}
                                                                                                    <div>
                                                                                                        <div >
                                                                                                            <label>preferred Time<span className="text-red">*</span></label>
                                                                                                            <input
                                                                                                                type="time"
                                                                                                                className="form-control"
                                                                                                                value={prefTimeModal}
                                                                                                                onChange={(e) => this.handlePrefTime(e)}
                                                                                                            />
                                                                                                            {<span className='text-danger text-start text-left d-block mt-1'>{preffTimeErrModal}</span>}
                                                                                                        </div>
                                                                                                        {console.log(prefTimeModal)}
                                                                                                    </div>

                                                                                                </div>


                                                                                            </div>

                                                                                            <div className="row">
                                                                                                <div className="col-xl-8 mb-1">
                                                                                                    <label className="mt-1">Remark
                                                                                                    </label>
                                                                                                    <textarea
                                                                                                        className="form-control"
                                                                                                        rows={3}
                                                                                                        maxLength={'250'}
                                                                                                        defaultValue={""}
                                                                                                        value={b2bRemarkModal}
                                                                                                        onChange={(e) => this.setState({ b2bRemarkModal: e.target.value, b2bRemarkErrModal: "" })}
                                                                                                    />
                                                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{b2bRemarkErrModal}</span>}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                                {this.state.isInterstOne && data.AreaofInterestID == 1 &&
                                                                                    <div className="table-responsive" >
                                                                                        <table className="table border table-bordered mb-0 mt-1" >
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th className="text-center" style={{ width: '100px' }}>Day</th>
                                                                                                    <th style={{ width: '250px' }} className="text-center">Register</th>
                                                                                                    <th style={{ width: '350px' }}>Date & Time</th>
                                                                                                    <th >Session Name</th>
                                                                                                    {/* <th style={{ width: '400px' }}>Description</th>
                                                                                                <th style={{ width: '400px' }}>Speaker</th> */}
                                                                                                    {/* <th style={{ width: '250px' }} className="text-center">Info</th> */}
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {
                                                                                                    seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => (
                                                                                                        <>
                                                                                                            {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                                                                <td style={{ borderRight: 'none' }}></td>
                                                                                                                <td style={{ border: 'none' }}></td>
                                                                                                                <td style={{ border: 'none' }}></td>
                                                                                                                <td style={{ border: 'none' }}></td>
                                                                                                                {/* <td style={{ border: 'none' }}></td> */}
                                                                                                                {/* <td style={{ borderLeft: 'none' }}></td> */}
                                                                                                            </tr>}
                                                                                                            {data.IsVisitor && <tr key={Math.random()}>
                                                                                                                {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                                                                    <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center' }}>{data.Day}</td>
                                                                                                                    : <></>}
                                                                                                                <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                                                                    {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                                                                        (data.SeminarTypeID == 2 ?
                                                                                                                            <a
                                                                                                                                style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                                                                className="btn btn-aqua me-2"
                                                                                                                                // type="submit"
                                                                                                                                onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                            >
                                                                                                                                {data.isSelect ? "Withdraw Request" : "Request for Invite"}
                                                                                                                            </a>
                                                                                                                            : data.SeminarTypeID == 3 ?

                                                                                                                                <input
                                                                                                                                    // style={{ marginTop: '12px' }}
                                                                                                                                    type="checkbox"
                                                                                                                                    checked={data.isSelect}
                                                                                                                                    onChange={(e) =>
                                                                                                                                        this.setState({
                                                                                                                                            // ChargesPop: data.isSelect ? false : this.state.ChargesPop,
                                                                                                                                            // seminarCharges: sessionStorage.getItem("countryId") == 91 ? data.PriceINR : data.PriceUSD,
                                                                                                                                            // seminarCGST: sessionStorage.getItem("countryId") == 91 ? data.PriceINR : data.PriceUSD,
                                                                                                                                            // seminarSGST: sessionStorage.getItem("countryId") == 91 ? data.PriceINR : data.PriceUSD,
                                                                                                                                            // seminarIGST: sessionStorage.getItem("countryId") == 91 ? data.PriceINR : data.PriceUSD,
                                                                                                                                            // TotalPayable: sessionStorage.getItem("countryId") == 91 ? data.PriceINR : data.PriceUSD,
                                                                                                                                        }, () => {
                                                                                                                                            !data.isSelect && this.getSeminarGST(regStateINV != null && regStateINV != '' ? regStateINV.trim() : regState.trim(), sessionStorage.getItem("sessionExhibitionID"), data.SeminarID, this.state.countryIdINV != null && this.state.countryIdINV != '' ? this.state.countryIdINV : this.state.countryId)
                                                                                                                                            this.onCheckedSeminar(e, data.SeminarID)
                                                                                                                                        })
                                                                                                                                    }
                                                                                                                                />
                                                                                                                                :
                                                                                                                                <input type="checkbox"
                                                                                                                                    value={data.isSelect}
                                                                                                                                    checked={data.isSelect}
                                                                                                                                    onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                                />)
                                                                                                                    }
                                                                                                                </td>
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.DateTime}</td>
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.SessionName}{data.SeminarDetailsHtmlRef ? <>&nbsp;<span style={{ cursor: 'pointer' }} className="text-primary" onClick={() => {
                                                                                                                    this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                                }}>Click Here</span> to view more details.</> : ''}</td>
                                                                                                                {/* {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                                                                <> */}


                                                                                                                {/* <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                                                            {data.SeminarID != 14 ? (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                                                            ) : (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                                                    <tr className="text-start">{item}</tr>
                                                                                                                ))}</td>
                                                                                                            )} */}


                                                                                                                {/* </> :
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>
                                                                                                                } */}

                                                                                                                {/* <td className="text-center">
                                                                                                                    {data.SeminarDetailsHtmlRef != '' && data.SeminarDetailsHtmlRef != null ?
                                                                                                                        <span onClick={() => {
                                                                                                                            this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                                        }}>
                                                                                                                            <i class="bi bi-info-circle"></i>
                                                                                                                        </span> : <></>}
                                                                                                                </td> */}

                                                                                                            </tr>}
                                                                                                        </>
                                                                                                    ))
                                                                                                }
                                                                                            </tbody>
                                                                                        </table>

                                                                                        <div />
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    }</>
                                                            ))
                                                        }
                                                    </div >
                                                </div>
                                            </div>}
                                        {!(parseInt(this.state.countryIdModal) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) && <div className="one-section mb-3">
                                            <div className="col-sm-12 ">
                                                <label className="d-flex">
                                                    <input className="do-you" style={{ marginBottom: '25px' }}
                                                        type="checkbox"
                                                        name="fav_language"
                                                        checked={needVisaAssistance}
                                                        onChange={(e) => this.setState({
                                                            needVisaAssistance: !needVisaAssistance,
                                                            preApplicantMobNo: preApplicantMobNo != '' ? preApplicantMobNo : preMobNoModal,
                                                            applicantEmail: applicantEmail != '' ? applicantEmail : emailModal,
                                                            applicantMobNo: applicantMobNo != '' ? applicantMobNo : mobNoModal,

                                                        })}
                                                    />
                                                    <span className="" style={{ color: "#bc202b", fontSize: "16px" }}><strong>Do you need Visa Assistance?</strong>
                                                        (<b>Note</b> : Visa Application letter will be issued {sessionStorage.getItem("ExhVisitorVisaIssueDate")}. In case applying for Business visa kindly. fill the below details to obtain Visa Invitation Letter.)</span>
                                                </label>
                                            </div>
                                            {
                                                needVisaAssistance &&
                                                <div
                                                    className="col-md-12 mb-2"
                                                    id="divMsg"
                                                >
                                                    <div className="row">
                                                        <div className="col-xl-4">
                                                            <label className="mt-3">
                                                                Name as per Passport<span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={passName} maxLength={'50'}
                                                                onChange={(e) => this.setState({ passName: e.target.value, passNameErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{passNameErr}</span>}
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label className="mt-3">
                                                                Applicant mobile number<span className="text-red">*</span>
                                                            </label>
                                                            <div className="phone-input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code mt-2" autoComplete="off" placeholder="ISD"
                                                                    // placeholder="ISD"
                                                                    maxLength={'4'} value={preApplicantMobNo}
                                                                    onChange={(e) => this.setState({ preApplicantMobNo: e.target.value })}
                                                                    maxLength={'10'}
                                                                />
                                                                <input type="number" className="form-control phone-no" value={applicantMobNo}
                                                                    maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => e.target.value >= 0 &&
                                                                        this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: "" })}
                                                                />
                                                            </div>
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{applicantMobNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label className="mt-3">
                                                                Applicant email id<span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={applicantEmail} maxLength={'50'}
                                                                onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                            // onBlur={(e) => this.verifyEmail(e)}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{applicantEmailErr}</span>}
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label className="mt-3">Passport No
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={passNo} maxLength={'10'}
                                                                onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{passNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label className="mt-3">Passport issue Date
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker selected={passDate}
                                                                onChange={(date) =>
                                                                    this.setState({
                                                                        passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                        passDateErr: ""
                                                                    })}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                maxDate={passExipryDate}
                                                                dropdownMode="select"
                                                                placeholderText="Passport Issued Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{passDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label className="mt-3">Passport Expiry Date
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker selected={passExipryDate}
                                                                onChange={(date) =>
                                                                    this.setState({
                                                                        passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                        passExipryDateErr: ""
                                                                    })}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                minDate={passDate}
                                                                dropdownMode="select"
                                                                placeholderText="Passport Expiry Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{passExipryDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <div className="d-flex">
                                                                <label className="mt-3 w-auto" >
                                                                    Passport issuing Country
                                                                    <span className="text-red">*</span>

                                                                </label>
                                                                {<span className='text-danger text-start text-left d-block mt-3 ml-2'>{passCountryErr}</span>}
                                                            </div>
                                                            <select className="form-control" value={passCountry}
                                                                onChange={(e) => this.onCountrySelect(e, 2)}
                                                            >
                                                                <option value={''}>Select Your Country</option>
                                                                {
                                                                    countryList.length > 0 && countryList.map((data) => (
                                                                        <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        {/* <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={passCountry}
                                                            onChange={(e) => this.onPassportCountrySearch(e)}
                                                        />
                                                        {isDisplayPassCountryList && this.renderPassCountryList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{ }</span>}
                                                    </div> */}
                                                        {!(isPassportFilePresent) && !isVisaApplied &&
                                                            < div className="col-xl-7">
                                                                <label className="mt-3 ">
                                                                    Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                    <span className="text-red">*</span>
                                                                    {<span className='text-danger text-start text-left mt-1 ms-3'>{passportFileErr}</span>}
                                                                </label>
                                                                <form action="/action_page.php" style={{ position: 'relative', left: 0, marginTop: '0' }}>
                                                                    <input type="file" id="passportFile" name="filename"
                                                                        accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                        onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                    />
                                                                    <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                        Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                    </span>
                                                                    {
                                                                        passportFile != "" && passportFile != 0 && passportFile != null &&
                                                                        < i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                                    }
                                                                </form>
                                                            </div>
                                                        }
                                                        {
                                                            isVisaApplied && passportFile != "" && passportFile != null && passportFile != 0 &&
                                                            <div className="col-xl-7">
                                                                <label className="mt-3">
                                                                    Passport Front Page File
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <div style={{
                                                                    border: '1px solid #ccc',
                                                                    padding: '10px',
                                                                    // display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '10px',
                                                                    // marginLeft: '12px',
                                                                    maxWidth: '350px', marginTop: '0'
                                                                }}>
                                                                    <span style={{ marginRight: '10px', marginTop: '0' }}
                                                                    >{passPortFileName}</span>
                                                                    <i className="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1, 1)}></i>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {console.log(this.state.visitorGroupList)}
                                            {/* {
                                            needVisaAssistance && sessionStorage.getItem('VisitorTypeID') == 2 &&
                                            //map+all data points
                                            this.state.visitorGroupList.length > 0 && this.state.visitorGroupList.map((data, i) => (<>
                                                {data.isVisit && < div
                                                    className="list-group-item col-md-12 m-3"
                                                    id="divMsg"
                                                // style={{backgroundColor:}}
                                                >
                                                    <div className="row">
                                                        <h5>{data.isCoordinator == true ? 'Coordinator' : `Visitor ${i}`}</h5>
                                                        {console.log('ppp')}
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">
                                                                Name as per Passport<span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={data.passName} maxLength={'50'}
                                                                onChange={(e) => this.onInput(e, e.target.value, i, 'name')}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{data.passNameErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">
                                                                Applicant mobile number<span className="text-red">*</span>
                                                            </label>
                                                            <input type="number" className="form-control" value={data.applicantMobNo}
                                                                style={{ paddingLeft: "65px" }}
                                                                maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                disabled
                                                            />
                                                            <input
                                                                type="text"
                                                                className="form-control-1 mt-2"
                                                                // placeholder="ISD"
                                                                value={data.preApplicantMobNo}
                                                                disabled
                                                                // onChange={(e) => this.setState({ preApplicantMobNo: e.target.value })}
                                                                maxLength={'10'}
                                                                style={{
                                                                    width: 55,
                                                                    position: "absolute",
                                                                    top: 30,
                                                                    padding: " 6px !important",
                                                                    paddingLeft: 5,
                                                                    borderLeft: 0,
                                                                    borderTop: 0,
                                                                    background: "none",
                                                                    borderBottom: 0,
                                                                    height: 34
                                                                }}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantMobNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">
                                                                Applicant email id<span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={data.applicantEmail} maxLength={'50'}
                                                                disabled
                                                            // onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantEmailErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">Passport No
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={data.passNo} maxLength={'10'}
                                                                // onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                                onChange={(e) => this.onInput(e, e.target.value, i, 'passno')}

                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{data.passNoErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">Passport issue Date
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker selected={data.passDate}
                                                                onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDate')}
                                                                // onChange={(date) =>
                                                                //     this.setState({
                                                                //         passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                //         passDateErr: ""
                                                                //     })}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                maxDate={data.passExipryDate}
                                                                dropdownMode="select"
                                                                placeholderText="Passport Issued Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{data.passDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">Passport Expiry Date
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker selected={data.passExipryDate}
                                                                onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDateEx')}
                                                                // onChange={(date) =>
                                                                //     this.setState({
                                                                //         passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                //         passExipryDateErr: ""
                                                                //     })}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                minDate={data.passDate}
                                                                dropdownMode="select"
                                                                placeholderText="Passport Expiry Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{data.passExipryDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="mt-3">
                                                                Passport issuing Country<span className="text-red">*</span>
                                                            </label>
                                                            <input type="text" className="form-control" value={data.passCountry}
                                                                onChange={(e) => this.onInput(e, e, i, 'passCountry')}

                                                            />
                                                            {data.isDisplayPassCountryList && this.renderPassCountryList(i)}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{data.passCountryErr}</span>}
                                                        </div>
                                                        {!(data.isPassportFilePresent) &&
                                                            <div className="col-xl-5">
                                                                <label className="mt-3">
                                                                    Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                    <input
                                                                        // type="file" id="passportFile" name="filename"
                                                                        //     accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                        //     onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                        type="file"
                                                                        id={`path${i}`}
                                                                        className="image-upload"
                                                                        accept=".jpg, .jpeg, .png"
                                                                        onChange={e => this.onInput(e, e.target.files, i, 'passImg')}
                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{data.passportFileErr}</span>}
                                                                    {
                                                                        data.passportFile != "" &&
                                                                        <i class="fa fa-times text-danger img-can"
                                                                            onClick={() => this.onCrossClick(1, i)}
                                                                        ></i>
                                                                    }
                                                                </form>
                                                            </div>
                                                        }
                                                        {
                                                            data.passportFilePath != "" && data.passportFilePath != null && data.isPassportFilePresent &&
                                                            <div className="col-xl-5">
                                                                <label className="mt-3">
                                                                    Passport Front Page File
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <div style={{
                                                                    border: '1px solid #ccc',
                                                                    padding: '10px',
                                                                    // display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '10px',
                                                                    // marginLeft: '12px',
                                                                    maxWidth: '300px'
                                                                }}>
                                                                    <span style={{ marginRight: '10px' }}
                                                                    >{data.passportFile}</span>
                                                                    <i className="fa fa-times text-danger img-can"
                                                                        onClick={() => this.onCrossClick(1, i)}
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>}
                                            </>
                                            ))
                                        } */}
                                        </div>}
                                    </>}
                                {/* </div> */}
                            </Modal.Body>
                            <Modal.Footer>
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleAddGroupDetail(this.state.activeModalStep)}>{this.state.activeModalStep == 2 ? this.state.isModalEdit ? 'Update' : 'Add' : 'Next'}</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.cancelModal()}>cancel</button>
                                </div>
                            </Modal.Footer>
                        </Modal>
                        <Modal
                            size="lg"
                            show={this.state.isOpen2}
                            // dialogClassName="modal-90w"
                            // onHide={() => this.toggleModel()}
                            aria-labelledby="example-modal-sizes-title-lg"
                        >
                            <Modal.Header>
                                <Modal.Title id="example-modal-sizes-title-lg">
                                    <h5 class="modal-title">Coordinator visitng?</h5>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {/* <div class="row"> */}
                                <div className="col-md-12">
                                    <p>Kindly make sure if the Coordinator will be visiting the Exhibition or the Coordinator will only fill the visitor registration form.</p>
                                </div>
                                {/* </div> */}
                            </Modal.Body>
                            <Modal.Footer>
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={() => this.toggleModel(1)}>will Visit the Exhibition</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.toggleModel()}>only Filling Form</button>
                                </div>
                            </Modal.Footer>
                        </Modal>
                        <Modal show={isOpen3} >
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen3: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this Document?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleDelete(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen3: false })}>No</button>
                                </div>
                            </div>
                        </Modal>

                        <Modal show={isOpen4} size="xl">

                            <div class="modal-header p-2">
                                <h5 class="modal-title">Visit Days Charges</h5>
                                {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen4: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" >
                                                        No of Days
                                                    </th>
                                                    {countryId == 91 ? <th className="text-center">Price (INR)</th> :
                                                        <th className="text-center">Price (USD)</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pricingList.length > 0 ? pricingList.map((data, index) => (
                                                        <tr key={Math.random()}>
                                                            <td className="text-center">{data.VisitDays}</td>
                                                            {countryId == 91 ?
                                                                <td className="text-center">{data.PriceINR != null && data.PriceINR != '' ? data.PriceINR : '-'}</td> :
                                                                <td className="text-center">{data.PriceUSD != null && data.PriceUSD != '' ? data.PriceUSD : '-'}</td>
                                                            }

                                                        </tr>
                                                    )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <span className="text-danger mt-2">
                                        <strong>Note: "Bank Charges will be applicable at payment stage"</strong>
                                    </span>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    {/* <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleDelete(e)}>Yes</button> */}
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen4: false })}>close</button>
                                </div>
                            </div>
                        </Modal>
                        {console.log(parseInt(sessionStorage.getItem('sessionExhibitionID')), '///')}

                        {console.log(daysList, this.state.daysModalList, '8888888888888888')}
                        {console.log(this.state.applicantMobNo, this.state.ApplicantMobileNoCoordinator, this.state.preApplicantMobNo, '8888888888888888', this.state.applicantMobNo)}
                        {
                            console.log(';;;', GroupDetailsList)

                        }
                        <Modal show={this.state.isOpen5} >
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen5: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this Visitor?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleDeleteVisitor(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen5: false })}>No</button>
                                </div>
                            </div>
                        </Modal>
                    </div > :
                    <div
                        className="main-content app-content mt-0"
                        style={{ backgroundColor: "#ececec", height: '100vh' }}
                    >
                        <div className="side-app">
                            <div className="main-container container-fluid top-form-name">
                                <div className="row ">
                                    <form className="needs-validation " noValidate="">
                                        <div className="form-row mt-4">
                                            <div className="form-group col-md-7 p-4 thank-box">
                                                <div className="form-group mb-2">
                                                    <h4
                                                        className="mb-0 pt-2 pb-4 thank-top-mes"
                                                        style={{ color: "#318958" }}
                                                    >
                                                        <strong>Coming Soon</strong>
                                                    </h4>
                                                    <p className="mb-1 mt-1 text-center com-font">
                                                        Thank you for your interest kindly visit again as we are not live yet.
                                                    </p>

                                                </div>
                                                <div classname="">
                                                    <div classname="mt-1 mb-4">

                                                        <button
                                                            classname="btn btn-next-bot m-1"
                                                            style={{
                                                                background: "#007bff",
                                                                padding: "6px 20px",
                                                                fontSize: 14,
                                                                border: "1px solid #007bff",
                                                                borderRadius: 2,
                                                                color: "#fff",
                                                                marginTop: 16
                                                            }}
                                                            onClick={e => this.onPreviousClick(e)}
                                                        >
                                                            {" "}
                                                            BACK TO EVENT WEBSITE
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>}
                <Modal
                    isOpen={this.state.HTMLEDITOR}
                    className="modal-fullscreen"
                    style={{ width: 'none' }}
                >
                    <div className="modal-dialog modal-fullscreen">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Preview</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() =>
                                        this.setState({
                                            HTMLEDITOR: false,
                                        })
                                    }
                                />
                            </div>

                            <div className="modal-body">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: this.state.HtmlContent || "",
                                    }}
                                />
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-aqua"
                                    onClick={() =>
                                        this.setState({
                                            HTMLEDITOR: false,
                                        })
                                    }
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal show={this.state.ChargesPop} size="l">
                    <div class="modal-header text-right p-2">
                        {/* <h5 class="modal-title modal_title_text text-Primary">
                                                </h5> */}
                    </div>
                    <div class="modal-body">
                        {(this.state.TotalPayable != '' && this.state.TotalPayable != null) && <><div className="row mb-2">
                            <div className="d-flex justify-content-between mb-2">
                                <h5 className="mb-0">Seminar Charges</h5>
                                <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{parseFloat(this.state.seminarCharges).toFixed(2)}</strong></h5>
                            </div>
                        </div>
                            {this.state.seminarCGST != '' && this.state.seminarCGST != 0 && this.state.seminarCGST != null && < div className="row mb-2">
                                <div className="d-flex justify-content-between mb-2">
                                    <h5 className="mb-0">CGST</h5>
                                    <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{parseFloat(this.state.seminarCGST).toFixed(2)}</strong></h5>
                                </div>
                            </div>}
                            {this.state.seminarSGST != '' && this.state.seminarSGST != 0 && this.state.seminarSGST != null && <div className="row mb-2">
                                <div className="d-flex justify-content-between mb-2">
                                    <h5 className="mb-0">SGST</h5>
                                    <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{parseFloat(this.state.seminarSGST).toFixed(2)}</strong></h5>
                                </div>
                            </div>}
                            {this.state.seminarIGST != '' && this.state.seminarIGST != 0 && this.state.seminarIGST != null && < div className="row mb-2">
                                <div className="d-flex justify-content-between mb-2">
                                    <h5 className="mb-0">IGST</h5>
                                    <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{parseFloat(this.state.seminarIGST).toFixed(2)}</strong></h5>
                                </div>
                            </div>}
                            <div className="row mb-2 mt-2">
                                <div className="d-flex justify-content-between mb-2">
                                    <h5 className="mb-0">Total Payable</h5>
                                    <h5 className="mb-0"><strong>{countryId == 91 ? "₹" : '$'}{parseFloat(this.state.TotalPayable).toFixed(2)}</strong></h5>
                                </div>
                            </div>
                            {this.state.toShowExtraDaysinPop && <hr></hr>}
                        </>}
                        {this.state.toShowExtraDaysinPop && <span style={{ fontWeight: '500' }}>Please be advised that the selection of an Exhibition Visit Date was not completed in the previous step for this conference. Consequently, standard visitor registration fees will be included in the final payment summary.</span>}
                    </div>
                    <div class="modal-footer p-1">
                        <div class="form-group text-right mod-fot">
                            <button type="button" className="btn btn-aqua"
                                onClick={() => {
                                    // this.togglePGCharges(2)
                                    setTimeout(() => {

                                        this.setState({
                                            ChargesPop: false,
                                            seminarCharges: '',
                                            seminarCGST: '',
                                            seminarSGST: '',
                                            seminarIGST: '',
                                            TotalPayable: '',
                                        })
                                    }, 500);

                                }
                                }
                            >Ok</button>
                            {/* <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                    >Close</button> */}
                        </div>
                    </div>

                </Modal>

                {/* <Modal isOpen={this.state.HTMLEDITOR} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">

                        </div>
                    </div>
                </Modal > */}
                {console.log("mdodod", this.state.interestListModal, this.state.interestList)}
            </>
        )
    }
}
export default withRouter(connect(null, {
    getSeminarGST_action,
    fill_action, getVistiorRegistarionDetails_action, visitorRegistrationNext_action, getIncompleteVisitorDetail_action, visitorRegistrationGroupNext_action, delVisaDoc_action, deleteVisitor_action,
    verifyVisitorEmail_action
})(VisitorRegistration));
